!function (e, n) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = n(require("react"), require("styled-components"), require("solid-auth-client"), require("react-dom"), require("@solid/query-ldflex"));else if ("function" === typeof define && define.amd) define(["react", "styled-components",, "react-dom"], n);else {
    var a = "object" === typeof exports ? n(require("react"), require("styled-components"), require("solid-auth-client"), require("react-dom"), require("@solid/query-ldflex")) : n(e.react, e["styled-components"], e.solid.auth, e["react-dom"], e.solid.data);

    for (var t in a) {
      ("object" === typeof exports ? exports : e)[t] = a[t];
    }
  }
}(window, function (e, n, a, t, i) {
  return function (e) {
    var n = {};

    function a(t) {
      if (n[t]) return n[t].exports;
      var i = n[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(i.exports, i, i.exports, a), i.l = !0, i.exports;
    }

    return a.m = e, a.c = n, a.d = function (e, n, t) {
      a.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: t
      });
    }, a.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, a.t = function (e, n) {
      if (1 & n && (e = a(e)), 8 & n) return e;
      if (4 & n && "object" === typeof e && e && e.__esModule) return e;
      var t = Object.create(null);
      if (a.r(t), Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var i in e) {
        a.d(t, i, function (n) {
          return e[n];
        }.bind(null, i));
      }
      return t;
    }, a.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return a.d(n, "a", n), n;
    }, a.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, a.p = "/docs/", a(a.s = 59);
  }([function (n, a) {
    n.exports = e;
  }, function (e, n, a) {
    e.exports = a(84)();
  }, function (e, n) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
  }, function (e, n, a) {
    "use strict";

    e.exports = function () {};
  }, function (e, a) {
    e.exports = n;
  }, function (e, n, a) {
    e.exports = a(61);
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0;
    var i = t(a(12));
    n.useWebId = i.default;
    var o = t(a(24));
    n.useLoggedIn = o.default;
    var s = t(a(33));
    n.useLoggedOut = s.default;
    var r = t(a(15));
    n.useLDflex = r.default;
    var c = t(a(17));
    n.useLDflexValue = c.default;
    var p = t(a(37));
    n.useLDflexList = p.default;
    var u = t(a(34));
    n.useLiveUpdate = u.default;
    var l = t(a(38));
    n.withWebId = l.default;
    var d = t(a(39));
    n.evaluateExpressions = d.default;
    var m = t(a(76));
    n.evaluateList = m.default;
    var f = t(a(41));
    n.LoggedIn = f.default;
    var v = t(a(77));
    n.LoggedOut = v.default;
    var h = t(a(31));
    n.LoginButton = h.default;
    var x = t(a(42));
    n.LogoutButton = x.default;
    var b = t(a(43));
    n.AuthButton = b.default;
    var g = t(a(19));
    n.Value = g.default;
    var y = t(a(44));
    n.Image = y.default;
    var w = t(a(45));
    n.Link = w.default;
    var E = t(a(32));
    n.Label = E.default;
    var k = t(a(46));
    n.Name = k.default;
    var O = t(a(47));
    n.List = O.default;
    var C = t(a(48));
    n.LiveUpdate = C.default;
    var A = t(a(20));
    n.ActivityButton = A.default;
    var j = t(a(80));
    n.LikeButton = j.default, n.Like = j.default;
    var S = t(a(81));
    n.DislikeButton = S.default, n.Dislike = S.default;
    var F = t(a(82));
    n.FollowButton = F.default, n.Follow = F.default;
    var D = t(a(25));
    n.UpdateContext = D.default, a(83);
  }, function (e, n) {
    e.exports = a;
  }, function (e, n, a) {
    "use strict";

    e.exports = function (e, n, a, t, i, o, s, r) {
      if (!e) {
        var c;
        if (void 0 === n) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var p = [a, t, i, o, s, r],
              u = 0;
          (c = new Error(n.replace(/%s/g, function () {
            return p[u++];
          }))).name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    };
  }, function (e, n, a) {
    "use strict";

    var t = function t() {};

    e.exports = t;
  }, function (e, n) {
    function a() {
      return e.exports = a = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var a = arguments[n];

          for (var t in a) {
            Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
          }
        }

        return e;
      }, a.apply(this, arguments);
    }

    e.exports = a;
  }, function (e, n, a) {
    "use strict";

    var t = a(5),
        i = a(16);

    function o(e) {
      return e.displayName || e.name || "Component";
    }

    n.__esModule = !0, n.srcToLDflex = function (e) {
      /^https?:[^"]+$/.test(e) && (e = '["'.concat(e, '"]'));
      return e;
    }, n.pick = function (e, n) {
      var a = {},
          t = !0,
          i = !1,
          o = void 0;

      try {
        for (var s, r = n[Symbol.iterator](); !(t = (s = r.next()).done); t = !0) {
          var c = s.value;
          a[c] = e[c];
        }
      } catch (p) {
        i = !0, o = p;
      } finally {
        try {
          t || null == r.return || r.return();
        } finally {
          if (i) throw o;
        }
      }

      return a;
    }, n.getDisplayName = o, n.higherOrderComponent = function (e, n) {
      return function (a) {
        var t = n(a);
        return t.displayName = "".concat(e, "(").concat(o(a), ")"), t;
      };
    }, n.createTaskQueue = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = e.drop,
          a = void 0 !== n && n,
          o = e.timeBetween,
          s = void 0 === o ? 10 : o,
          r = e.concurrent,
          c = void 0 === r ? a ? 1 : 4 : r,
          p = [],
          u = 0;

      function l() {
        u = p.length && setTimeout(l, s), p.splice(0, c).forEach(function () {
          var e = i(t.mark(function e(n) {
            var a, i, o;
            return t.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return a = n.run, i = n.resolve, o = n.reject, e.prev = 1, e.t0 = i, e.next = 5, a();

                  case 5:
                    e.t1 = e.sent, (0, e.t0)(e.t1), e.next = 12;
                    break;

                  case 9:
                    e.prev = 9, e.t2 = e.catch(1), o(e.t2);

                  case 12:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[1, 9]]);
          }));
          return function (n) {
            return e.apply(this, arguments);
          };
        }());
      }

      return {
        schedule: function e(n) {
          var t,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          if (!Array.isArray(n)) return e([n])[0];
          var o = [],
              s = n.map(function (e) {
            return new Promise(function (n, a) {
              return o.push({
                run: e,
                resolve: n,
                reject: a,
                group: i
              });
            });
          });
          return a ? p = o : (t = p).push.apply(t, o), u || l(), s;
        },
        clear: function clear(e) {
          var n = p.length > 0;
          return p = p.filter(function (n) {
            return void 0 !== e && n.group !== e;
          }), n;
        }
      };
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : c,
          n = (0, i.useReducer)(e, s, e),
          a = n[0],
          t = n[1];
      return (0, i.useDebugValue)(s), (0, i.useEffect)(function () {
        return t(s), r.add(t), function () {
          return r.delete(t);
        };
      }, []), a;
    };

    var i = a(0),
        o = t(a(7)),
        s = void 0,
        r = new Set(),
        c = function c(e, n) {
      return n;
    };

    o.default.trackSession(function (e) {
      s = e ? e.webId : null;
      var n = !0,
          a = !1,
          t = void 0;

      try {
        for (var i, o = r[Symbol.iterator](); !(n = (i = o.next()).done); n = !0) {
          (0, i.value)(s);
        }
      } catch (c) {
        a = !0, t = c;
      } finally {
        try {
          n || null == o.return || o.return();
        } finally {
          if (a) throw t;
        }
      }
    });
  }, function (e, n) {
    e.exports = t;
  }, function (e, n, a) {
    "use strict";

    var t = a(96),
        i = a(98).extname,
        o = /^\s*([^;\s]*)(?:;|\s|$)/,
        s = /^text\//i;

    function r(e) {
      if (!e || "string" !== typeof e) return !1;
      var n = o.exec(e),
          a = n && t[n[1].toLowerCase()];
      return a && a.charset ? a.charset : !(!n || !s.test(n[1])) && "UTF-8";
    }

    n.charset = r, n.charsets = {
      lookup: r
    }, n.contentType = function (e) {
      if (!e || "string" !== typeof e) return !1;
      var a = -1 === e.indexOf("/") ? n.lookup(e) : e;
      if (!a) return !1;

      if (-1 === a.indexOf("charset")) {
        var t = n.charset(a);
        t && (a += "; charset=" + t.toLowerCase());
      }

      return a;
    }, n.extension = function (e) {
      if (!e || "string" !== typeof e) return !1;
      var a = o.exec(e),
          t = a && n.extensions[a[1].toLowerCase()];
      if (!t || !t.length) return !1;
      return t[0];
    }, n.extensions = Object.create(null), n.lookup = function (e) {
      if (!e || "string" !== typeof e) return !1;
      var a = i("x." + e).toLowerCase().substr(1);
      if (!a) return !1;
      return n.types[a] || !1;
    }, n.types = Object.create(null), function (e, n) {
      var a = ["nginx", "apache", void 0, "iana"];
      Object.keys(t).forEach(function (i) {
        var o = t[i],
            s = o.extensions;

        if (s && s.length) {
          e[i] = s;

          for (var r = 0; r < s.length; r++) {
            var c = s[r];

            if (n[c]) {
              var p = a.indexOf(t[n[c]].source),
                  u = a.indexOf(o.source);
              if ("application/octet-stream" !== n[c] && (p > u || p === u && "application/" === n[c].substr(0, 12))) continue;
            }

            n[c] = i;
          }
        }
      });
    }(n.extensions, n.types);
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          a = (0, s.default)(),
          t = (0, r.default)(),
          m = (0, o.useState)(n ? u : p),
          f = m[0],
          v = f.result,
          h = f.pending,
          x = f.error,
          b = m[1];
      return (0, o.useDebugValue)(x || v, d), (0, o.useEffect)(function () {
        var a = new c.default(),
            t = {
          result: e
        };
        return a.evaluate(n ? l : t, n ? t : l, function (e) {
          return b(function (n) {
            return (0, i.default)({}, n, e);
          });
        }), function () {
          return a.destroy();
        };
      }, [e, t, a && "string" === typeof e]), [v, h, x];
    }, n.toString = d;
    var i = t(a(10)),
        o = a(0),
        s = t(a(12)),
        r = t(a(34)),
        c = t(a(35)),
        p = {
      result: void 0,
      pending: !0,
      error: void 0
    },
        u = {
      result: [],
      pending: !0,
      error: void 0
    },
        l = {};

    function d(e) {
      return Array.isArray(e) ? e.map(d) : "".concat(e);
    }
  }, function (e, n) {
    function a(e, n, a, t, i, o, s) {
      try {
        var r = e[o](s),
            c = r.value;
      } catch (p) {
        return void a(p);
      }

      r.done ? n(c) : Promise.resolve(c).then(t, i);
    }

    e.exports = function (e) {
      return function () {
        var n = this,
            t = arguments;
        return new Promise(function (i, o) {
          var s = e.apply(n, t);

          function r(e) {
            a(s, i, o, r, c, "next", e);
          }

          function c(e) {
            a(s, i, o, r, c, "throw", e);
          }

          r(void 0);
        });
      };
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(30);
    n.__esModule = !0, n.default = function (e) {
      var n = (0, o.default)(e, !1)[0];
      return (0, i.useDebugValue)(n, o.toString), n;
    };
    var i = a(0),
        o = t(a(15));
  }, function (e, n) {
    e.exports = function (e, n) {
      if (null == e) return {};
      var a,
          t,
          i = {},
          o = Object.keys(e);

      for (t = 0; t < o.length; t++) {
        a = o[t], n.indexOf(a) >= 0 || (i[a] = e[a]);
      }

      return i;
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.src,
          a = e.children,
          t = (0, o.default)(n),
          s = t[0],
          r = t[1],
          c = t[2];
      return void 0 !== s && null !== s ? "".concat(s) : r ? a || i.default.createElement("span", {
        className: "solid value pending"
      }) : c ? a || i.default.createElement("span", {
        className: "solid value error",
        "data-error": c.message
      }) : a || i.default.createElement("span", {
        className: "solid value empty"
      });
    };
    var i = t(a(0)),
        o = t(a(15));
  }, function (e, n, a) {
    "use strict";

    var t = a(5),
        i = a(16),
        o = a(30),
        s = a(2);
    n.__esModule = !0, n.default = f, n.customActivityButton = function (e, n, a, t) {
      var i = "".concat(m).concat(e);
      return function (e) {
        var o = e.object,
            s = e.children,
            u = void 0 === s ? o ? null : "this page" : s,
            l = e.activateText,
            d = void 0 === l ? n : l,
            m = e.deactivateText,
            v = void 0 === m ? u ? a : t : m,
            h = (0, c.default)(e, ["object", "children", "activateText", "deactivateText"]);
        return p.default.createElement(f, (0, r.default)({}, h, {
          activityType: i,
          object: o,
          children: u,
          activateText: d,
          deactivateText: v
        }));
      };
    };
    var r = s(a(10)),
        c = s(a(18)),
        p = o(a(0)),
        u = s(a(29)),
        l = a(11),
        d = s(a(17)),
        m = u.default.context.as;

    function f(e) {
      var n = e.activityType,
          a = void 0 === n ? "".concat(m, "Like") : n,
          o = e.object,
          s = void 0 === o ? "[".concat(window.location.href, "]") : o,
          f = e.children,
          v = e.shortName,
          h = void 0 === v ? /\w*$/.exec(a)[0] : v,
          x = e.className,
          b = void 0 === x ? "solid activity ".concat(h.toLowerCase()) : x,
          g = e.activateText,
          y = void 0 === g ? h : g,
          w = e.deactivateText,
          E = void 0 === w ? y : w,
          k = e.activateLabel,
          O = void 0 === k ? f ? [y, " ", f] : y : k,
          C = e.deactivateLabel,
          A = void 0 === C ? f ? [E, " ", f] : E : C,
          j = (0, c.default)(e, ["activityType", "object", "children", "shortName", "className", "activateText", "deactivateText", "activateLabel", "deactivateLabel"]);
      s = (0, l.srcToLDflex)(s);
      var S = (0, p.useState)(),
          F = S[0],
          D = S[1],
          P = (0, d.default)("".concat(s, '.findActivity("').concat(a, '")'));

      function M() {
        return (M = i(t.mark(function e() {
          var n;
          return t.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return D(!F), e.prev = 1, n = F ? "delete" : "create", e.next = 5, u.default.resolve("".concat(s, ".").concat(n, 'Activity("').concat(a, '")'));

                case 5:
                  D(!F), e.next = 12;
                  break;

                case 8:
                  e.prev = 8, e.t0 = e.catch(1), D(F), console.warn("@solid/react-components", e.t0);

                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[1, 8]]);
        }))).apply(this, arguments);
      }

      return void 0 === F && P && D(!0), b = "".concat(b, " ").concat(F ? "performed" : ""), p.default.createElement("button", (0, r.default)({
        className: b,
        onClick: function onClick() {
          return M.apply(this, arguments);
        }
      }, j), F ? A : O);
    }
  }, function (e, n) {}, function (e, n, a) {
    var t = a(95);
    e.exports = m, e.exports.parse = o, e.exports.compile = function (e, n) {
      return r(o(e, n));
    }, e.exports.tokensToFunction = r, e.exports.tokensToRegExp = d;
    var i = new RegExp(["(\\\\.)", "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"].join("|"), "g");

    function o(e, n) {
      for (var a, t = [], o = 0, s = 0, r = "", u = n && n.delimiter || "/"; null != (a = i.exec(e));) {
        var l = a[0],
            d = a[1],
            m = a.index;
        if (r += e.slice(s, m), s = m + l.length, d) r += d[1];else {
          var f = e[s],
              v = a[2],
              h = a[3],
              x = a[4],
              b = a[5],
              g = a[6],
              y = a[7];
          r && (t.push(r), r = "");
          var w = null != v && null != f && f !== v,
              E = "+" === g || "*" === g,
              k = "?" === g || "*" === g,
              O = a[2] || u,
              C = x || b;
          t.push({
            name: h || o++,
            prefix: v || "",
            delimiter: O,
            optional: k,
            repeat: E,
            partial: w,
            asterisk: !!y,
            pattern: C ? p(C) : y ? ".*" : "[^" + c(O) + "]+?"
          });
        }
      }

      return s < e.length && (r += e.substr(s)), r && t.push(r), t;
    }

    function s(e) {
      return encodeURI(e).replace(/[\/?#]/g, function (e) {
        return "%" + e.charCodeAt(0).toString(16).toUpperCase();
      });
    }

    function r(e) {
      for (var n = new Array(e.length), a = 0; a < e.length; a++) {
        "object" === typeof e[a] && (n[a] = new RegExp("^(?:" + e[a].pattern + ")$"));
      }

      return function (a, i) {
        for (var o = "", r = a || {}, c = (i || {}).pretty ? s : encodeURIComponent, p = 0; p < e.length; p++) {
          var u = e[p];

          if ("string" !== typeof u) {
            var l,
                d = r[u.name];

            if (null == d) {
              if (u.optional) {
                u.partial && (o += u.prefix);
                continue;
              }

              throw new TypeError('Expected "' + u.name + '" to be defined');
            }

            if (t(d)) {
              if (!u.repeat) throw new TypeError('Expected "' + u.name + '" to not repeat, but received `' + JSON.stringify(d) + "`");

              if (0 === d.length) {
                if (u.optional) continue;
                throw new TypeError('Expected "' + u.name + '" to not be empty');
              }

              for (var m = 0; m < d.length; m++) {
                if (l = c(d[m]), !n[p].test(l)) throw new TypeError('Expected all "' + u.name + '" to match "' + u.pattern + '", but received `' + JSON.stringify(l) + "`");
                o += (0 === m ? u.prefix : u.delimiter) + l;
              }
            } else {
              if (l = u.asterisk ? encodeURI(d).replace(/[?#]/g, function (e) {
                return "%" + e.charCodeAt(0).toString(16).toUpperCase();
              }) : c(d), !n[p].test(l)) throw new TypeError('Expected "' + u.name + '" to match "' + u.pattern + '", but received "' + l + '"');
              o += u.prefix + l;
            }
          } else o += u;
        }

        return o;
      };
    }

    function c(e) {
      return e.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
    }

    function p(e) {
      return e.replace(/([=!:$\/()])/g, "\\$1");
    }

    function u(e, n) {
      return e.keys = n, e;
    }

    function l(e) {
      return e.sensitive ? "" : "i";
    }

    function d(e, n, a) {
      t(n) || (a = n || a, n = []);

      for (var i = (a = a || {}).strict, o = !1 !== a.end, s = "", r = 0; r < e.length; r++) {
        var p = e[r];
        if ("string" === typeof p) s += c(p);else {
          var d = c(p.prefix),
              m = "(?:" + p.pattern + ")";
          n.push(p), p.repeat && (m += "(?:" + d + m + ")*"), s += m = p.optional ? p.partial ? d + "(" + m + ")?" : "(?:" + d + "(" + m + "))?" : d + "(" + m + ")";
        }
      }

      var f = c(a.delimiter || "/"),
          v = s.slice(-f.length) === f;
      return i || (s = (v ? s.slice(0, -f.length) : s) + "(?:" + f + "(?=$))?"), s += o ? "$" : i && v ? "" : "(?=" + f + "|$)", u(new RegExp("^" + s, l(a)), n);
    }

    function m(e, n, a) {
      return t(n) || (a = n || a, n = []), a = a || {}, e instanceof RegExp ? function (e, n) {
        var a = e.source.match(/\((?!\?)/g);
        if (a) for (var t = 0; t < a.length; t++) {
          n.push({
            name: t,
            prefix: null,
            delimiter: null,
            optional: !1,
            repeat: !1,
            partial: !1,
            asterisk: !1,
            pattern: null
          });
        }
        return u(e, n);
      }(e, n) : t(e) ? function (e, n, a) {
        for (var t = [], i = 0; i < e.length; i++) {
          t.push(m(e[i], n, a).source);
        }

        return u(new RegExp("(?:" + t.join("|") + ")", l(a)), n);
      }(e, n, a) : function (e, n, a) {
        return d(o(e, a), n, a);
      }(e, n, a);
    }
  }, function (e, n, a) {
    "use strict";

    var t = r(a(88)),
        i = r(a(93)),
        o = r(a(53)),
        s = r(a(50));

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    e.exports = {
      Transition: s.default,
      TransitionGroup: o.default,
      ReplaceTransition: i.default,
      CSSTransition: t.default
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function () {
      var e = (0, o.default)(s);
      return (0, i.useDebugValue)(e), e;
    };

    var i = a(0),
        o = t(a(12)),
        s = function s(e, n) {
      return void 0 === n ? void 0 : null !== n;
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = void 0;
    var i = t(a(0)).default.createContext({});
    n.default = i;
  }, function (e, n, a) {
    var t = a(67),
        i = a(68),
        o = a(69);

    e.exports = function (e) {
      return t(e) || i(e) || o();
    };
  }, function (e, n) {
    e.exports = function (e, n) {
      if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, n) {
    function a(e, n) {
      for (var a = 0; a < n.length; a++) {
        var t = n[a];
        t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }

    e.exports = function (e, n, t) {
      return n && a(e.prototype, n), t && a(e, t), e;
    };
  }, function (e, n) {
    e.exports = i;
  }, function (e, n) {
    e.exports = function (e) {
      if (e && e.__esModule) return e;
      var n = {};
      if (null != e) for (var a in e) {
        if (Object.prototype.hasOwnProperty.call(e, a)) {
          var t = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(e, a) : {};
          t.get || t.set ? Object.defineProperty(n, a, t) : n[a] = e[a];
        }
      }
      return n.default = e, n;
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.popup,
          a = e.children,
          t = void 0 === a ? "Log in" : a,
          s = e.className,
          r = void 0 === s ? "solid auth login" : s;
      return i.default.createElement("button", {
        className: r,
        onClick: function onClick() {
          return o.default.popupLogin({
            popupUri: n
          });
        }
      }, t);
    };
    var i = t(a(0)),
        o = t(a(7));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.src,
          a = e.children,
          t = void 0 === a ? null : a;
      return i.default.createElement(o.default, {
        src: n && "".concat((0, s.srcToLDflex)(n), ".label")
      }, t);
    };
    var i = t(a(0)),
        o = t(a(19)),
        s = a(11);
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function () {
      var e = (0, o.default)(s);
      return (0, i.useDebugValue)(e), e;
    };

    var i = a(0),
        o = t(a(12)),
        s = function s(e, n) {
      return void 0 === n ? void 0 : null === n;
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function () {
      var e = (0, i.useContext)(o.default);
      return (0, i.useDebugValue)(e.timestamp || null), e;
    };
    var i = a(0),
        o = t(a(25));
  }, function (e, n, a) {
    "use strict";

    var t = a(60),
        i = a(5),
        o = a(63),
        s = a(26),
        r = a(16),
        c = a(27),
        p = a(28),
        u = a(2);
    n.__esModule = !0, n.default = void 0;

    var l = u(a(36)),
        d = u(a(70)),
        m = a(11),
        f = u(a(29)),
        v = (0, m.createTaskQueue)(),
        h = function () {
      function e() {
        c(this, e), (0, l.default)(this, "pending", {}), (0, l.default)(this, "cancel", !1);
      }

      return p(e, [{
        key: "destroy",
        value: function value() {
          this.pending = {}, this.cancel = !0, v.clear(this);
        }
      }, {
        key: "evaluate",
        value: function () {
          var e = r(i.mark(function e(n, a, t) {
            var r,
                c,
                p = this;
            return i.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return t({
                      pending: !0,
                      error: void 0
                    }), r = v.schedule([].concat(s(Object.entries(n).map(function (e) {
                      var n = o(e, 2),
                          a = n[0],
                          i = n[1];
                      return function () {
                        return p.evaluateAsValue(a, i, t);
                      };
                    })), s(Object.entries(a).map(function (e) {
                      var n = o(e, 2),
                          a = n[0],
                          i = n[1];
                      return function () {
                        return p.evaluateAsList(a, i, t);
                      };
                    }))), this), e.prev = 2, e.next = 5, Promise.all(r);

                  case 5:
                    e.next = 10;
                    break;

                  case 7:
                    e.prev = 7, e.t0 = e.catch(2), t({
                      error: e.t0
                    });

                  case 10:
                    return e.next = 12, Promise.all(r.map(function (e) {
                      return e.catch(function (e) {
                        return console.warn("@solid/react-components", "Expression evaluation failed.", e), !0;
                      });
                    }));

                  case 12:
                    if (c = e.sent, !this.cancel) {
                      e.next = 15;
                      break;
                    }

                    return e.abrupt("return");

                  case 15:
                    c.some(function (e) {
                      return !e;
                    }) || 0 !== Object.keys(this.pending).length || t({
                      pending: !1
                    });

                  case 16:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[2, 7]]);
          }));
          return function (n, a, t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "evaluateAsValue",
        value: function () {
          var e = r(i.mark(function e(n, a, o) {
            var s, r;
            return i.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return s = this.resolveExpression(n, a, "then"), this.pending[n] = s, e.prev = 2, e.next = 5, s;

                  case 5:
                    if (r = e.sent, this.pending[n] === s) {
                      e.next = 8;
                      break;
                    }

                    return e.abrupt("return", !1);

                  case 8:
                    o(t({}, n, r));

                  case 9:
                    return e.prev = 9, this.pending[n] === s && delete this.pending[n], e.finish(9);

                  case 12:
                    return e.abrupt("return", !0);

                  case 13:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[2,, 9, 12]]);
          }));
          return function (n, a, t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "evaluateAsList",
        value: function () {
          var e = r(i.mark(function e(n, a, o) {
            var s,
                r,
                c,
                p,
                u,
                l,
                f,
                v,
                h,
                x,
                b,
                g,
                y = this;
            return i.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (s = this.resolveExpression(n, a, Symbol.asyncIterator)) {
                      e.next = 3;
                      break;
                    }

                    return e.abrupt("return", !0);

                  case 3:
                    this.pending[n] = s, r = [], c = function c() {
                      return !y.cancel && o(t({}, n, [].concat(r)));
                    }, p = (0, m.createTaskQueue)({
                      timeBetween: 100,
                      drop: !0
                    }), e.prev = 7, u = !0, l = !1, e.prev = 10, v = (0, d.default)(s);

                  case 12:
                    return e.next = 14, v.next();

                  case 14:
                    return h = e.sent, u = h.done, e.next = 18, h.value;

                  case 18:
                    if (x = e.sent, u) {
                      e.next = 28;
                      break;
                    }

                    if (b = x, this.pending[n] === s) {
                      e.next = 23;
                      break;
                    }

                    return e.abrupt("return", !1);

                  case 23:
                    r.push(b), p.schedule(c);

                  case 25:
                    u = !0, e.next = 12;
                    break;

                  case 28:
                    e.next = 34;
                    break;

                  case 30:
                    e.prev = 30, e.t0 = e.catch(10), l = !0, f = e.t0;

                  case 34:
                    if (e.prev = 34, e.prev = 35, u || null == v.return) {
                      e.next = 39;
                      break;
                    }

                    return e.next = 39, v.return();

                  case 39:
                    if (e.prev = 39, !l) {
                      e.next = 42;
                      break;
                    }

                    throw f;

                  case 42:
                    return e.finish(39);

                  case 43:
                    return e.finish(34);

                  case 44:
                    return e.prev = 44, g = p.clear(), this.pending[n] === s && (g && c(), delete this.pending[n]), e.finish(44);

                  case 48:
                    return e.abrupt("return", !0);

                  case 49:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[7,, 44, 48], [10, 30, 34, 44], [35,, 39, 43]]);
          }));
          return function (n, a, t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "resolveExpression",
        value: function value(e, n, a) {
          if (!n) return "";
          var t = "string" === typeof n ? f.default.resolve(n) : n;
          if (!t || "function" !== typeof t[a]) throw new Error("".concat(e, " should be an LDflex path or string but is ").concat(n));
          return t;
        }
      }]), e;
    }();

    n.default = h;
  }, function (e, n) {
    e.exports = function (e, n, a) {
      return n in e ? Object.defineProperty(e, n, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = a, e;
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(30);
    n.__esModule = !0, n.default = function (e) {
      var n = (0, o.default)(e, !0)[0];
      return (0, i.useDebugValue)(n, o.toString), n;
    };
    var i = a(0),
        o = t(a(15));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = void 0;
    var i = t(a(10)),
        o = t(a(0)),
        s = t(a(12)),
        r = (0, a(11).higherOrderComponent)("WithWebId", function (e) {
      return function (n) {
        return o.default.createElement(e, (0, i.default)({}, n, {
          webId: (0, s.default)()
        }));
      };
    });
    n.default = r;
  }, function (e, n, a) {
    "use strict";

    var t = a(27),
        i = a(28),
        o = a(71),
        s = a(73),
        r = a(74),
        c = a(40),
        p = a(26),
        u = a(2);
    n.__esModule = !0, n.default = function (e, n, a) {
      if (!a) {
        var u = [n, []];
        a = u[0], n = u[1];
      }

      e = e ? p(e) : [], n = n ? p(n) : [];
      var x = {
        pending: !0
      },
          b = !0,
          g = !1,
          y = void 0;

      try {
        for (var w, E = e[Symbol.iterator](); !(b = (w = E.next()).done); b = !0) {
          var k = w.value;
          x[k] = void 0;
        }
      } catch (P) {
        g = !0, y = P;
      } finally {
        try {
          b || null == E.return || E.return();
        } finally {
          if (g) throw y;
        }
      }

      var O = !0,
          C = !1,
          A = void 0;

      try {
        for (var j, S = n[Symbol.iterator](); !(O = (j = S.next()).done); O = !0) {
          var F = j.value;
          x[F] = [];
        }
      } catch (P) {
        C = !0, A = P;
      } finally {
        try {
          O || null == S.return || S.return();
        } finally {
          if (C) throw A;
        }
      }

      var D = function (p) {
        function u() {
          var e, n;
          t(this, u);

          for (var a = arguments.length, i = new Array(a), r = 0; r < a; r++) {
            i[r] = arguments[r];
          }

          return n = o(this, (e = s(u)).call.apply(e, [this].concat(i))), (0, d.default)(c(c(n)), "state", x), n;
        }

        return r(u, p), i(u, [{
          key: "componentDidMount",
          value: function value() {
            var a = this;
            this.evaluator = new v.default(), this.update = function (e) {
              return a.setState(e);
            }, this.evaluate(e, n);
          }
        }, {
          key: "componentDidUpdate",
          value: function value(a) {
            var t = this,
                i = this.props.webId !== a.webId,
                o = function o(e) {
              return t.props[e] !== a[e] || i && "string" === typeof t.props[e];
            };

            this.evaluate(e.filter(o), n.filter(o));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.evaluator.destroy();
          }
        }, {
          key: "render",
          value: function value() {
            return m.default.createElement(a, (0, l.default)({}, this.props, this.state));
          }
        }, {
          key: "evaluate",
          value: function value(e, n) {
            var a = this.props,
                t = this.evaluator;
            (e.length > 0 || n.length > 0) && t.evaluate((0, h.pick)(a, e), (0, h.pick)(a, n), this.update);
          }
        }]), u;
      }(m.default.Component);

      return (0, d.default)(D, "displayName", "EvaluateExpressions(".concat((0, h.getDisplayName)(a), ")")), (0, f.default)(D);
    };
    var l = u(a(10)),
        d = u(a(36)),
        m = u(a(0)),
        f = u(a(38)),
        v = u(a(35)),
        h = a(11);
  }, function (e, n) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.children,
          a = void 0 === n ? null : n;
      return (0, i.default)() ? a : null;
    };
    var i = t(a(24));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.children,
          a = void 0 === n ? "Log out" : n,
          t = e.className,
          s = void 0 === t ? "solid auth logout" : t;
      return i.default.createElement("button", {
        className: s,
        onClick: function onClick() {
          return o.default.logout();
        }
      }, a);
    };
    var i = t(a(0)),
        o = t(a(7));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.login,
          a = e.logout,
          t = (0, i.default)(e, ["login", "logout"]);
      return (0, c.default)() ? o.default.createElement(r.default, t, a) : o.default.createElement(s.default, t, n);
    };
    var i = t(a(18)),
        o = t(a(0)),
        s = t(a(31)),
        r = t(a(42)),
        c = t(a(24));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.src,
          a = e.defaultSrc,
          t = e.children,
          c = void 0 === t ? null : t,
          p = (0, o.default)(e, ["src", "defaultSrc", "children"]);
      return (n = (0, r.default)(n) || a) ? s.default.createElement("img", (0, i.default)({
        src: n,
        alt: ""
      }, p)) : c;
    };
    var i = t(a(10)),
        o = t(a(18)),
        s = t(a(0)),
        r = t(a(17));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.href,
          a = e.children,
          t = (0, o.default)(e, ["href", "children"]);
      return n = (0, c.default)(n) || "", a = a || s.default.createElement(r.default, {
        src: n && "[".concat(n, "]")
      }, "".concat(n)), n ? s.default.createElement("a", (0, i.default)({
        href: n
      }, t), a) : a;
    };
    var i = t(a(10)),
        o = t(a(18)),
        s = t(a(0)),
        r = t(a(32)),
        c = t(a(17));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.src,
          a = e.children,
          t = void 0 === a ? null : a;
      return i.default.createElement(o.default, {
        src: n && "".concat((0, s.srcToLDflex)(n), ".name")
      }, t);
    };
    var i = t(a(0)),
        o = t(a(19)),
        s = a(11);
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.src,
          a = e.offset,
          t = void 0 === a ? 0 : a,
          s = e.limit,
          r = void 0 === s ? 1 / 0 : s,
          c = e.filter,
          p = void 0 === c ? function () {
        return !0;
      } : c,
          u = e.container,
          l = void 0 === u ? function (e) {
        return i.default.createElement("ul", null, e);
      } : u,
          d = e.children,
          m = void 0 === d ? function (e, n) {
        return i.default.createElement("li", {
          key: n
        }, "".concat(e));
      } : d,
          f = (0, o.default)(n).filter(p).slice(t, +t + +r).map(m);
      return l ? l(f) : f;
    };
    var i = t(a(0)),
        o = t(a(37));
  }, function (e, n, a) {
    "use strict";

    var t = a(26),
        i = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.subscribe,
          a = void 0 === n ? "*" : n,
          i = e.children,
          s = void 0 === i ? null : i,
          p = "string" !== typeof a ? a : /\S/.test(a) ? a.trim().split(/\s+/) : [],
          u = r.default.apply(void 0, t(p));
      return o.default.createElement(c, {
        value: u
      }, s);
    };
    var o = i(a(0)),
        s = i(a(25)),
        r = i(a(78)),
        c = s.default.Provider;
  }, function (e, n) {
    var a,
        t,
        i = e.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function s() {
      throw new Error("clearTimeout has not been defined");
    }

    function r(e) {
      if (a === setTimeout) return setTimeout(e, 0);
      if ((a === o || !a) && setTimeout) return a = setTimeout, setTimeout(e, 0);

      try {
        return a(e, 0);
      } catch (n) {
        try {
          return a.call(null, e, 0);
        } catch (n) {
          return a.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        a = "function" === typeof setTimeout ? setTimeout : o;
      } catch (e) {
        a = o;
      }

      try {
        t = "function" === typeof clearTimeout ? clearTimeout : s;
      } catch (e) {
        t = s;
      }
    }();
    var c,
        p = [],
        u = !1,
        l = -1;

    function d() {
      u && c && (u = !1, c.length ? p = c.concat(p) : l = -1, p.length && m());
    }

    function m() {
      if (!u) {
        var e = r(d);
        u = !0;

        for (var n = p.length; n;) {
          for (c = p, p = []; ++l < n;) {
            c && c[l].run();
          }

          l = -1, n = p.length;
        }

        c = null, u = !1, function (e) {
          if (t === clearTimeout) return clearTimeout(e);
          if ((t === s || !t) && clearTimeout) return t = clearTimeout, clearTimeout(e);

          try {
            t(e);
          } catch (n) {
            try {
              return t.call(null, e);
            } catch (n) {
              return t.call(this, e);
            }
          }
        }(e);
      }
    }

    function f(e, n) {
      this.fun = e, this.array = n;
    }

    function v() {}

    i.nextTick = function (e) {
      var n = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var a = 1; a < arguments.length; a++) {
        n[a - 1] = arguments[a];
      }
      p.push(new f(e, n)), 1 !== p.length || u || r(m);
    }, f.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = v, i.addListener = v, i.once = v, i.off = v, i.removeListener = v, i.removeAllListeners = v, i.emit = v, i.prependListener = v, i.prependOnceListener = v, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.default = n.EXITING = n.ENTERED = n.ENTERING = n.EXITED = n.UNMOUNTED = void 0;

    var t = function (e) {
      if (e && e.__esModule) return e;
      var n = {};
      if (null != e) for (var a in e) {
        if (Object.prototype.hasOwnProperty.call(e, a)) {
          var t = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(e, a) : {};
          t.get || t.set ? Object.defineProperty(n, a, t) : n[a] = e[a];
        }
      }
      return n.default = e, n;
    }(a(1)),
        i = r(a(0)),
        o = r(a(13)),
        s = a(51);

    a(52);

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var c = "unmounted";
    n.UNMOUNTED = c;
    var p = "exited";
    n.EXITED = p;
    var u = "entering";
    n.ENTERING = u;
    var l = "entered";
    n.ENTERED = l;
    n.EXITING = "exiting";

    var d = function (e) {
      var n, a;

      function t(n, a) {
        var t;
        t = e.call(this, n, a) || this;
        var i,
            o = a.transitionGroup,
            s = o && !o.isMounting ? n.enter : n.appear;
        return t.appearStatus = null, n.in ? s ? (i = p, t.appearStatus = u) : i = l : i = n.unmountOnExit || n.mountOnEnter ? c : p, t.state = {
          status: i
        }, t.nextCallback = null, t;
      }

      a = e, (n = t).prototype = Object.create(a.prototype), n.prototype.constructor = n, n.__proto__ = a;
      var s = t.prototype;
      return s.getChildContext = function () {
        return {
          transitionGroup: null
        };
      }, t.getDerivedStateFromProps = function (e, n) {
        return e.in && n.status === c ? {
          status: p
        } : null;
      }, s.componentDidMount = function () {
        this.updateStatus(!0, this.appearStatus);
      }, s.componentDidUpdate = function (e) {
        var n = null;

        if (e !== this.props) {
          var a = this.state.status;
          this.props.in ? a !== u && a !== l && (n = u) : a !== u && a !== l || (n = "exiting");
        }

        this.updateStatus(!1, n);
      }, s.componentWillUnmount = function () {
        this.cancelNextCallback();
      }, s.getTimeouts = function () {
        var e,
            n,
            a,
            t = this.props.timeout;
        return e = n = a = t, null != t && "number" !== typeof t && (e = t.exit, n = t.enter, a = t.appear), {
          exit: e,
          enter: n,
          appear: a
        };
      }, s.updateStatus = function (e, n) {
        if (void 0 === e && (e = !1), null !== n) {
          this.cancelNextCallback();
          var a = o.default.findDOMNode(this);
          n === u ? this.performEnter(a, e) : this.performExit(a);
        } else this.props.unmountOnExit && this.state.status === p && this.setState({
          status: c
        });
      }, s.performEnter = function (e, n) {
        var a = this,
            t = this.props.enter,
            i = this.context.transitionGroup ? this.context.transitionGroup.isMounting : n,
            o = this.getTimeouts();
        n || t ? (this.props.onEnter(e, i), this.safeSetState({
          status: u
        }, function () {
          a.props.onEntering(e, i), a.onTransitionEnd(e, o.enter, function () {
            a.safeSetState({
              status: l
            }, function () {
              a.props.onEntered(e, i);
            });
          });
        })) : this.safeSetState({
          status: l
        }, function () {
          a.props.onEntered(e);
        });
      }, s.performExit = function (e) {
        var n = this,
            a = this.props.exit,
            t = this.getTimeouts();
        a ? (this.props.onExit(e), this.safeSetState({
          status: "exiting"
        }, function () {
          n.props.onExiting(e), n.onTransitionEnd(e, t.exit, function () {
            n.safeSetState({
              status: p
            }, function () {
              n.props.onExited(e);
            });
          });
        })) : this.safeSetState({
          status: p
        }, function () {
          n.props.onExited(e);
        });
      }, s.cancelNextCallback = function () {
        null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
      }, s.safeSetState = function (e, n) {
        n = this.setNextCallback(n), this.setState(e, n);
      }, s.setNextCallback = function (e) {
        var n = this,
            a = !0;
        return this.nextCallback = function (t) {
          a && (a = !1, n.nextCallback = null, e(t));
        }, this.nextCallback.cancel = function () {
          a = !1;
        }, this.nextCallback;
      }, s.onTransitionEnd = function (e, n, a) {
        this.setNextCallback(a), e ? (this.props.addEndListener && this.props.addEndListener(e, this.nextCallback), null != n && setTimeout(this.nextCallback, n)) : setTimeout(this.nextCallback, 0);
      }, s.render = function () {
        var e = this.state.status;
        if (e === c) return null;

        var n = this.props,
            a = n.children,
            t = function (e, n) {
          if (null == e) return {};
          var a,
              t,
              i = {},
              o = Object.keys(e);

          for (t = 0; t < o.length; t++) {
            a = o[t], n.indexOf(a) >= 0 || (i[a] = e[a]);
          }

          return i;
        }(n, ["children"]);

        if (delete t.in, delete t.mountOnEnter, delete t.unmountOnExit, delete t.appear, delete t.enter, delete t.exit, delete t.timeout, delete t.addEndListener, delete t.onEnter, delete t.onEntering, delete t.onEntered, delete t.onExit, delete t.onExiting, delete t.onExited, "function" === typeof a) return a(e, t);
        var o = i.default.Children.only(a);
        return i.default.cloneElement(o, t);
      }, t;
    }(i.default.Component);

    function m() {}

    d.contextTypes = {
      transitionGroup: t.object
    }, d.childContextTypes = {
      transitionGroup: function transitionGroup() {}
    }, d.propTypes = {}, d.defaultProps = {
      in: !1,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1,
      enter: !0,
      exit: !0,
      onEnter: m,
      onEntering: m,
      onEntered: m,
      onExit: m,
      onExiting: m,
      onExited: m
    }, d.UNMOUNTED = 0, d.EXITED = 1, d.ENTERING = 2, d.ENTERED = 3, d.EXITING = 4;
    var f = (0, s.polyfill)(d);
    n.default = f;
  }, function (e, n, a) {
    "use strict";

    function t() {
      var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
      null !== e && void 0 !== e && this.setState(e);
    }

    function i(e) {
      this.setState(function (n) {
        var a = this.constructor.getDerivedStateFromProps(e, n);
        return null !== a && void 0 !== a ? a : null;
      }.bind(this));
    }

    function o(e, n) {
      try {
        var a = this.props,
            t = this.state;
        this.props = e, this.state = n, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(a, t);
      } finally {
        this.props = a, this.state = t;
      }
    }

    function s(e) {
      var n = e.prototype;
      if (!n || !n.isReactComponent) throw new Error("Can only polyfill class components");
      if ("function" !== typeof e.getDerivedStateFromProps && "function" !== typeof n.getSnapshotBeforeUpdate) return e;
      var a = null,
          s = null,
          r = null;

      if ("function" === typeof n.componentWillMount ? a = "componentWillMount" : "function" === typeof n.UNSAFE_componentWillMount && (a = "UNSAFE_componentWillMount"), "function" === typeof n.componentWillReceiveProps ? s = "componentWillReceiveProps" : "function" === typeof n.UNSAFE_componentWillReceiveProps && (s = "UNSAFE_componentWillReceiveProps"), "function" === typeof n.componentWillUpdate ? r = "componentWillUpdate" : "function" === typeof n.UNSAFE_componentWillUpdate && (r = "UNSAFE_componentWillUpdate"), null !== a || null !== s || null !== r) {
        var c = e.displayName || e.name,
            p = "function" === typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + c + " uses " + p + " but also contains the following legacy lifecycles:" + (null !== a ? "\n  " + a : "") + (null !== s ? "\n  " + s : "") + (null !== r ? "\n  " + r : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
      }

      if ("function" === typeof e.getDerivedStateFromProps && (n.componentWillMount = t, n.componentWillReceiveProps = i), "function" === typeof n.getSnapshotBeforeUpdate) {
        if ("function" !== typeof n.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        n.componentWillUpdate = o;
        var u = n.componentDidUpdate;

        n.componentDidUpdate = function (e, n, a) {
          var t = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : a;
          u.call(this, e, n, t);
        };
      }

      return e;
    }

    a.r(n), a.d(n, "polyfill", function () {
      return s;
    }), t.__suppressDeprecationWarning = !0, i.__suppressDeprecationWarning = !0, o.__suppressDeprecationWarning = !0;
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.classNamesShape = n.timeoutsShape = void 0;
    var t;
    (t = a(1)) && t.__esModule;
    n.timeoutsShape = null;
    n.classNamesShape = null;
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.default = void 0;
    var t = r(a(1)),
        i = r(a(0)),
        o = a(51),
        s = a(94);

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function c() {
      return (c = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var a = arguments[n];

          for (var t in a) {
            Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function p(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    var u = Object.values || function (e) {
      return Object.keys(e).map(function (n) {
        return e[n];
      });
    },
        l = function (e) {
      var n, a;

      function t(n, a) {
        var t,
            i = (t = e.call(this, n, a) || this).handleExited.bind(p(p(t)));
        return t.state = {
          handleExited: i,
          firstRender: !0
        }, t;
      }

      a = e, (n = t).prototype = Object.create(a.prototype), n.prototype.constructor = n, n.__proto__ = a;
      var o = t.prototype;
      return o.getChildContext = function () {
        return {
          transitionGroup: {
            isMounting: !this.appeared
          }
        };
      }, o.componentDidMount = function () {
        this.appeared = !0, this.mounted = !0;
      }, o.componentWillUnmount = function () {
        this.mounted = !1;
      }, t.getDerivedStateFromProps = function (e, n) {
        var a = n.children,
            t = n.handleExited;
        return {
          children: n.firstRender ? (0, s.getInitialChildMapping)(e, t) : (0, s.getNextChildMapping)(e, a, t),
          firstRender: !1
        };
      }, o.handleExited = function (e, n) {
        var a = (0, s.getChildMapping)(this.props.children);
        e.key in a || (e.props.onExited && e.props.onExited(n), this.mounted && this.setState(function (n) {
          var a = c({}, n.children);
          return delete a[e.key], {
            children: a
          };
        }));
      }, o.render = function () {
        var e = this.props,
            n = e.component,
            a = e.childFactory,
            t = function (e, n) {
          if (null == e) return {};
          var a,
              t,
              i = {},
              o = Object.keys(e);

          for (t = 0; t < o.length; t++) {
            a = o[t], n.indexOf(a) >= 0 || (i[a] = e[a]);
          }

          return i;
        }(e, ["component", "childFactory"]),
            o = u(this.state.children).map(a);

        return delete t.appear, delete t.enter, delete t.exit, null === n ? o : i.default.createElement(n, t, o);
      }, t;
    }(i.default.Component);

    l.childContextTypes = {
      transitionGroup: t.default.object.isRequired
    }, l.propTypes = {}, l.defaultProps = {
      component: "div",
      childFactory: function childFactory(e) {
        return e;
      }
    };
    var d = (0, o.polyfill)(l);
    n.default = d, e.exports = n.default;
  }, function (e, n, a) {
    (function (n) {
      for (var t = a(87), i = "undefined" === typeof window ? n : window, o = ["moz", "webkit"], s = "AnimationFrame", r = i["request" + s], c = i["cancel" + s] || i["cancelRequest" + s], p = 0; !r && p < o.length; p++) {
        r = i[o[p] + "Request" + s], c = i[o[p] + "Cancel" + s] || i[o[p] + "CancelRequest" + s];
      }

      if (!r || !c) {
        var u = 0,
            l = 0,
            d = [];
        r = function r(e) {
          if (0 === d.length) {
            var n = t(),
                a = Math.max(0, 1e3 / 60 - (n - u));
            u = a + n, setTimeout(function () {
              var e = d.slice(0);
              d.length = 0;

              for (var n = 0; n < e.length; n++) {
                if (!e[n].cancelled) try {
                  e[n].callback(u);
                } catch (a) {
                  setTimeout(function () {
                    throw a;
                  }, 0);
                }
              }
            }, Math.round(a));
          }

          return d.push({
            handle: ++l,
            callback: e,
            cancelled: !1
          }), l;
        }, c = function c(e) {
          for (var n = 0; n < d.length; n++) {
            d[n].handle === e && (d[n].cancelled = !0);
          }
        };
      }

      e.exports = function (e) {
        return r.call(i, e);
      }, e.exports.cancel = function () {
        c.apply(i, arguments);
      }, e.exports.polyfill = function (e) {
        e || (e = i), e.requestAnimationFrame = r, e.cancelAnimationFrame = c;
      };
    }).call(this, a(86));
  }, function (e, n, a) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: !0
    });

    var t = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var a = arguments[n];

        for (var t in a) {
          Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
        }
      }

      return e;
    },
        i = function () {
      function e(e, n) {
        for (var a = 0; a < n.length; a++) {
          var t = n[a];
          t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
        }
      }

      return function (n, a, t) {
        return a && e(n.prototype, a), t && e(n, t), n;
      };
    }(),
        o = a(0),
        s = c(o),
        r = c(a(1));

    function c(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var p = {
      position: "absolute",
      top: 0,
      left: 0,
      visibility: "hidden",
      height: 0,
      overflow: "scroll",
      whiteSpace: "pre"
    },
        u = ["extraWidth", "injectStyles", "inputClassName", "inputRef", "inputStyle", "minWidth", "onAutosize", "placeholderIsMinWidth"],
        l = function l(e, n) {
      n.style.fontSize = e.fontSize, n.style.fontFamily = e.fontFamily, n.style.fontWeight = e.fontWeight, n.style.fontStyle = e.fontStyle, n.style.letterSpacing = e.letterSpacing, n.style.textTransform = e.textTransform;
    },
        d = !("undefined" === typeof window || !window.navigator) && /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent),
        m = function m() {
      return d ? "_" + Math.random().toString(36).substr(2, 12) : void 0;
    },
        f = function (e) {
      function n(e) {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, n);

        var a = function (e, n) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !n || "object" !== typeof n && "function" !== typeof n ? e : n;
        }(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));

        return a.inputRef = function (e) {
          a.input = e, "function" === typeof a.props.inputRef && a.props.inputRef(e);
        }, a.placeHolderSizerRef = function (e) {
          a.placeHolderSizer = e;
        }, a.sizerRef = function (e) {
          a.sizer = e;
        }, a.state = {
          inputWidth: e.minWidth,
          inputId: e.id || m()
        }, a;
      }

      return function (e, n) {
        if ("function" !== typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
        e.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
      }(n, o.Component), i(n, [{
        key: "componentDidMount",
        value: function value() {
          this.mounted = !0, this.copyInputStyles(), this.updateInputWidth();
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var n = e.id;
          n !== this.props.id && this.setState({
            inputId: n || m()
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, n) {
          n.inputWidth !== this.state.inputWidth && "function" === typeof this.props.onAutosize && this.props.onAutosize(this.state.inputWidth), this.updateInputWidth();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.mounted = !1;
        }
      }, {
        key: "copyInputStyles",
        value: function value() {
          if (this.mounted && window.getComputedStyle) {
            var e = this.input && window.getComputedStyle(this.input);
            e && (l(e, this.sizer), this.placeHolderSizer && l(e, this.placeHolderSizer));
          }
        }
      }, {
        key: "updateInputWidth",
        value: function value() {
          if (this.mounted && this.sizer && "undefined" !== typeof this.sizer.scrollWidth) {
            var e = void 0;
            e = this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth) ? Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2 : this.sizer.scrollWidth + 2, (e += "number" === this.props.type && void 0 === this.props.extraWidth ? 16 : parseInt(this.props.extraWidth) || 0) < this.props.minWidth && (e = this.props.minWidth), e !== this.state.inputWidth && this.setState({
              inputWidth: e
            });
          }
        }
      }, {
        key: "getInput",
        value: function value() {
          return this.input;
        }
      }, {
        key: "focus",
        value: function value() {
          this.input.focus();
        }
      }, {
        key: "blur",
        value: function value() {
          this.input.blur();
        }
      }, {
        key: "select",
        value: function value() {
          this.input.select();
        }
      }, {
        key: "renderStyles",
        value: function value() {
          var e = this.props.injectStyles;
          return d && e ? s.default.createElement("style", {
            dangerouslySetInnerHTML: {
              __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
            }
          }) : null;
        }
      }, {
        key: "render",
        value: function value() {
          var e = [this.props.defaultValue, this.props.value, ""].reduce(function (e, n) {
            return null !== e && void 0 !== e ? e : n;
          }),
              n = t({}, this.props.style);
          n.display || (n.display = "inline-block");

          var a = t({
            boxSizing: "content-box",
            width: this.state.inputWidth + "px"
          }, this.props.inputStyle),
              i = function (e, n) {
            var a = {};

            for (var t in e) {
              n.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(e, t) && (a[t] = e[t]);
            }

            return a;
          }(this.props, []);

          return function (e) {
            u.forEach(function (n) {
              return delete e[n];
            });
          }(i), i.className = this.props.inputClassName, i.id = this.state.inputId, i.style = a, s.default.createElement("div", {
            className: this.props.className,
            style: n
          }, this.renderStyles(), s.default.createElement("input", t({}, i, {
            ref: this.inputRef
          })), s.default.createElement("div", {
            ref: this.sizerRef,
            style: p
          }, e), this.props.placeholder ? s.default.createElement("div", {
            ref: this.placeHolderSizerRef,
            style: p
          }, this.props.placeholder) : null);
        }
      }]), n;
    }();

    f.propTypes = {
      className: r.default.string,
      defaultValue: r.default.any,
      extraWidth: r.default.oneOfType([r.default.number, r.default.string]),
      id: r.default.string,
      injectStyles: r.default.bool,
      inputClassName: r.default.string,
      inputRef: r.default.func,
      inputStyle: r.default.object,
      minWidth: r.default.oneOfType([r.default.number, r.default.string]),
      onAutosize: r.default.func,
      onChange: r.default.func,
      placeholder: r.default.string,
      placeholderIsMinWidth: r.default.bool,
      style: r.default.object,
      value: r.default.any
    }, f.defaultProps = {
      minWidth: 1,
      injectStyles: !0
    }, n.default = f;
  }, function (e, n) {
    e.exports = "data:image/png;base64,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";
  }, function (e, n) {
    e.exports = "data:image/png;base64,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";
  },, function (e, n, a) {
    e.exports = a(99);
  }, function (e, n) {
    e.exports = function (e, n, a) {
      return n in e ? Object.defineProperty(e, n, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = a, e;
    };
  }, function (e, n, a) {
    var t = function () {
      return this || "object" === typeof self && self;
    }() || Function("return this")(),
        i = t.regeneratorRuntime && Object.getOwnPropertyNames(t).indexOf("regeneratorRuntime") >= 0,
        o = i && t.regeneratorRuntime;

    if (t.regeneratorRuntime = void 0, e.exports = a(62), i) t.regeneratorRuntime = o;else try {
      delete t.regeneratorRuntime;
    } catch (s) {
      t.regeneratorRuntime = void 0;
    }
  }, function (e, n) {
    !function (n) {
      "use strict";

      var a,
          t = Object.prototype,
          i = t.hasOwnProperty,
          o = "function" === typeof Symbol ? Symbol : {},
          s = o.iterator || "@@iterator",
          r = o.asyncIterator || "@@asyncIterator",
          c = o.toStringTag || "@@toStringTag",
          p = "object" === typeof e,
          u = n.regeneratorRuntime;
      if (u) p && (e.exports = u);else {
        (u = n.regeneratorRuntime = p ? e.exports : {}).wrap = y;
        var l = "suspendedStart",
            d = "suspendedYield",
            m = "executing",
            f = "completed",
            v = {},
            h = {};

        h[s] = function () {
          return this;
        };

        var x = Object.getPrototypeOf,
            b = x && x(x(P([])));
        b && b !== t && i.call(b, s) && (h = b);
        var g = O.prototype = E.prototype = Object.create(h);
        k.prototype = g.constructor = O, O.constructor = k, O[c] = k.displayName = "GeneratorFunction", u.isGeneratorFunction = function (e) {
          var n = "function" === typeof e && e.constructor;
          return !!n && (n === k || "GeneratorFunction" === (n.displayName || n.name));
        }, u.mark = function (e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, O) : (e.__proto__ = O, c in e || (e[c] = "GeneratorFunction")), e.prototype = Object.create(g), e;
        }, u.awrap = function (e) {
          return {
            __await: e
          };
        }, C(A.prototype), A.prototype[r] = function () {
          return this;
        }, u.AsyncIterator = A, u.async = function (e, n, a, t) {
          var i = new A(y(e, n, a, t));
          return u.isGeneratorFunction(n) ? i : i.next().then(function (e) {
            return e.done ? e.value : i.next();
          });
        }, C(g), g[c] = "Generator", g[s] = function () {
          return this;
        }, g.toString = function () {
          return "[object Generator]";
        }, u.keys = function (e) {
          var n = [];

          for (var a in e) {
            n.push(a);
          }

          return n.reverse(), function a() {
            for (; n.length;) {
              var t = n.pop();
              if (t in e) return a.value = t, a.done = !1, a;
            }

            return a.done = !0, a;
          };
        }, u.values = P, D.prototype = {
          constructor: D,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(F), !e) for (var n in this) {
              "t" === n.charAt(0) && i.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = a);
            }
          },
          stop: function stop() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var n = this;

            function t(t, i) {
              return r.type = "throw", r.arg = e, n.next = t, i && (n.method = "next", n.arg = a), !!i;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var s = this.tryEntries[o],
                  r = s.completion;
              if ("root" === s.tryLoc) return t("end");

              if (s.tryLoc <= this.prev) {
                var c = i.call(s, "catchLoc"),
                    p = i.call(s, "finallyLoc");

                if (c && p) {
                  if (this.prev < s.catchLoc) return t(s.catchLoc, !0);
                  if (this.prev < s.finallyLoc) return t(s.finallyLoc);
                } else if (c) {
                  if (this.prev < s.catchLoc) return t(s.catchLoc, !0);
                } else {
                  if (!p) throw new Error("try statement without catch or finally");
                  if (this.prev < s.finallyLoc) return t(s.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(e, n) {
            for (var a = this.tryEntries.length - 1; a >= 0; --a) {
              var t = this.tryEntries[a];

              if (t.tryLoc <= this.prev && i.call(t, "finallyLoc") && this.prev < t.finallyLoc) {
                var o = t;
                break;
              }
            }

            o && ("break" === e || "continue" === e) && o.tryLoc <= n && n <= o.finallyLoc && (o = null);
            var s = o ? o.completion : {};
            return s.type = e, s.arg = n, o ? (this.method = "next", this.next = o.finallyLoc, v) : this.complete(s);
          },
          complete: function complete(e, n) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && n && (this.next = n), v;
          },
          finish: function finish(e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var a = this.tryEntries[n];
              if (a.finallyLoc === e) return this.complete(a.completion, a.afterLoc), F(a), v;
            }
          },
          catch: function _catch(e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var a = this.tryEntries[n];

              if (a.tryLoc === e) {
                var t = a.completion;

                if ("throw" === t.type) {
                  var i = t.arg;
                  F(a);
                }

                return i;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, n, t) {
            return this.delegate = {
              iterator: P(e),
              resultName: n,
              nextLoc: t
            }, "next" === this.method && (this.arg = a), v;
          }
        };
      }

      function y(e, n, a, t) {
        var i = n && n.prototype instanceof E ? n : E,
            o = Object.create(i.prototype),
            s = new D(t || []);
        return o._invoke = function (e, n, a) {
          var t = l;
          return function (i, o) {
            if (t === m) throw new Error("Generator is already running");

            if (t === f) {
              if ("throw" === i) throw o;
              return M();
            }

            for (a.method = i, a.arg = o;;) {
              var s = a.delegate;

              if (s) {
                var r = j(s, a);

                if (r) {
                  if (r === v) continue;
                  return r;
                }
              }

              if ("next" === a.method) a.sent = a._sent = a.arg;else if ("throw" === a.method) {
                if (t === l) throw t = f, a.arg;
                a.dispatchException(a.arg);
              } else "return" === a.method && a.abrupt("return", a.arg);
              t = m;
              var c = w(e, n, a);

              if ("normal" === c.type) {
                if (t = a.done ? f : d, c.arg === v) continue;
                return {
                  value: c.arg,
                  done: a.done
                };
              }

              "throw" === c.type && (t = f, a.method = "throw", a.arg = c.arg);
            }
          };
        }(e, a, s), o;
      }

      function w(e, n, a) {
        try {
          return {
            type: "normal",
            arg: e.call(n, a)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      function E() {}

      function k() {}

      function O() {}

      function C(e) {
        ["next", "throw", "return"].forEach(function (n) {
          e[n] = function (e) {
            return this._invoke(n, e);
          };
        });
      }

      function A(e) {
        var n;

        this._invoke = function (a, t) {
          function o() {
            return new Promise(function (n, o) {
              !function n(a, t, o, s) {
                var r = w(e[a], e, t);

                if ("throw" !== r.type) {
                  var c = r.arg,
                      p = c.value;
                  return p && "object" === typeof p && i.call(p, "__await") ? Promise.resolve(p.__await).then(function (e) {
                    n("next", e, o, s);
                  }, function (e) {
                    n("throw", e, o, s);
                  }) : Promise.resolve(p).then(function (e) {
                    c.value = e, o(c);
                  }, function (e) {
                    return n("throw", e, o, s);
                  });
                }

                s(r.arg);
              }(a, t, n, o);
            });
          }

          return n = n ? n.then(o, o) : o();
        };
      }

      function j(e, n) {
        var t = e.iterator[n.method];

        if (t === a) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator.return && (n.method = "return", n.arg = a, j(e, n), "throw" === n.method)) return v;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return v;
        }

        var i = w(t, e.iterator, n.arg);
        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, v;
        var o = i.arg;
        return o ? o.done ? (n[e.resultName] = o.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = a), n.delegate = null, v) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
      }

      function S(e) {
        var n = {
          tryLoc: e[0]
        };
        1 in e && (n.catchLoc = e[1]), 2 in e && (n.finallyLoc = e[2], n.afterLoc = e[3]), this.tryEntries.push(n);
      }

      function F(e) {
        var n = e.completion || {};
        n.type = "normal", delete n.arg, e.completion = n;
      }

      function D(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(S, this), this.reset(!0);
      }

      function P(e) {
        if (e) {
          var n = e[s];
          if (n) return n.call(e);
          if ("function" === typeof e.next) return e;

          if (!isNaN(e.length)) {
            var t = -1,
                o = function n() {
              for (; ++t < e.length;) {
                if (i.call(e, t)) return n.value = e[t], n.done = !1, n;
              }

              return n.value = a, n.done = !0, n;
            };

            return o.next = o;
          }
        }

        return {
          next: M
        };
      }

      function M() {
        return {
          value: a,
          done: !0
        };
      }
    }(function () {
      return this || "object" === typeof self && self;
    }() || Function("return this")());
  }, function (e, n, a) {
    var t = a(64),
        i = a(65),
        o = a(66);

    e.exports = function (e, n) {
      return t(e) || i(e, n) || o();
    };
  }, function (e, n) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    };
  }, function (e, n) {
    e.exports = function (e, n) {
      var a = [],
          t = !0,
          i = !1,
          o = void 0;

      try {
        for (var s, r = e[Symbol.iterator](); !(t = (s = r.next()).done) && (a.push(s.value), !n || a.length !== n); t = !0) {
          ;
        }
      } catch (c) {
        i = !0, o = c;
      } finally {
        try {
          t || null == r.return || r.return();
        } finally {
          if (i) throw o;
        }
      }

      return a;
    };
  }, function (e, n) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }, function (e, n) {
    e.exports = function (e) {
      if (Array.isArray(e)) {
        for (var n = 0, a = new Array(e.length); n < e.length; n++) {
          a[n] = e[n];
        }

        return a;
      }
    };
  }, function (e, n) {
    e.exports = function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    };
  }, function (e, n) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    };
  }, function (e, n) {
    e.exports = function (e) {
      var n;

      if ("function" === typeof Symbol) {
        if (Symbol.asyncIterator && null != (n = e[Symbol.asyncIterator])) return n.call(e);
        if (Symbol.iterator && null != (n = e[Symbol.iterator])) return n.call(e);
      }

      throw new TypeError("Object is not async iterable");
    };
  }, function (e, n, a) {
    var t = a(72),
        i = a(40);

    e.exports = function (e, n) {
      return !n || "object" !== t(n) && "function" !== typeof n ? i(e) : n;
    };
  }, function (e, n) {
    function a(e) {
      return (a = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function t(n) {
      return "function" === typeof Symbol && "symbol" === a(Symbol.iterator) ? e.exports = t = function t(e) {
        return a(e);
      } : e.exports = t = function t(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : a(e);
      }, t(n);
    }

    e.exports = t;
  }, function (e, n) {
    function a(n) {
      return e.exports = a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, a(n);
    }

    e.exports = a;
  }, function (e, n, a) {
    var t = a(75);

    e.exports = function (e, n) {
      if ("function" !== typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && t(e, n);
    };
  }, function (e, n) {
    function a(n, t) {
      return e.exports = a = Object.setPrototypeOf || function (e, n) {
        return e.__proto__ = n, e;
      }, a(n, t);
    }

    e.exports = a;
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e, n) {
      return (0, i.default)([], [e], n);
    };
    var i = t(a(39));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function (e) {
      var n = e.children,
          a = void 0 === n ? null : n;
      return (0, i.default)() ? a : null;
    };
    var i = t(a(33));
  }, function (e, n, a) {
    "use strict";

    var t = a(2);
    n.__esModule = !0, n.default = function () {
      for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++) {
        n[a] = arguments[a];
      }

      var t = (0, i.useState)({}),
          s = t[0],
          r = t[1];
      return (0, i.useDebugValue)(s.timestamp || null), (0, i.useEffect)(function () {
        var e = new o.default(r);
        return e.subscribe.apply(e, n), function () {
          return e.unsubscribe.apply(e, n);
        };
      }, n), s;
    };
    var i = a(0),
        o = t(a(79));
  }, function (e, n, a) {
    "use strict";

    var t = a(5),
        i = a(16),
        o = a(27),
        s = a(28),
        r = a(2);
    n.__esModule = !0, n.default = void 0;

    var c = r(a(7)),
        p = r(a(29)),
        u = "*",
        l = {},
        d = {},
        m = new Set(),
        f = function () {
      function e(n) {
        o(this, e), this.subscriber = n;
      }

      return s(e, [{
        key: "subscribe",
        value: function value() {
          for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++) {
            n[a] = arguments[a];
          }

          for (var t = 0; t < n.length; t++) {
            var i = n[t];
            (i = i.replace(/#.*/, "")) in l || (l[i] = new Set(), i !== u ? v(i) : m.forEach(v)), l[i].add(this.subscriber);
          }
        }
      }, {
        key: "unsubscribe",
        value: function value() {
          for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++) {
            n[a] = arguments[a];
          }

          for (var t = 0; t < n.length; t++) {
            var i = n[t];
            (i = i.replace(/#.*/, "")) in l && l[i].delete(this.subscriber);
          }
        }
      }]), e;
    }();

    function v(e) {
      var n = new URL(e),
          a = n.protocol,
          t = n.host,
          i = d[t];

      if (!i) {
        var o = "".concat(a.replace("http", "ws"), "//").concat(t, "/");
        d[t] = i = new WebSocket(o), Object.assign(i, {
          enqueue: h,
          onmessage: b,
          ready: new Promise(function (e) {
            return i.onopen = e;
          })
        });
      }

      i.enqueue("sub ".concat(e));
    }

    function h(e) {
      return x.apply(this, arguments);
    }

    function x() {
      return (x = i(t.mark(function e(n) {
        return t.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.ready;

              case 2:
                this.send(n);

              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      }))).apply(this, arguments);
    }

    function b(e) {
      var n = e.data,
          a = /^pub +(.+)/.exec(n);

      if (a) {
        var t = a[1];
        p.default.clearCache(t);
        var i = {
          timestamp: new Date(),
          url: t
        },
            o = !0,
            s = !1,
            r = void 0;

        try {
          for (var c, d = (l[t] || [])[Symbol.iterator](); !(o = (c = d.next()).done); o = !0) {
            (0, c.value)(i);
          }
        } catch (b) {
          s = !0, r = b;
        } finally {
          try {
            o || null == d.return || d.return();
          } finally {
            if (s) throw r;
          }
        }

        var m = !0,
            f = !1,
            v = void 0;

        try {
          for (var h, x = (l[u] || [])[Symbol.iterator](); !(m = (h = x.next()).done); m = !0) {
            (0, h.value)(i);
          }
        } catch (b) {
          f = !0, v = b;
        } finally {
          try {
            m || null == x.return || x.return();
          } finally {
            if (f) throw v;
          }
        }
      }
    }

    n.default = f, c.default.on("request", function (e) {
      m.has(e) || (u in l && v(e), m.add(e));
    });
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.default = void 0;
    var t = (0, a(20).customActivityButton)("Like", "Like", "You liked", "Liked");
    n.default = t;
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.default = void 0;
    var t = (0, a(20).customActivityButton)("Dislike", "Dislike", "You disliked", "Disliked");
    n.default = t;
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.default = void 0;
    var t = (0, a(20).customActivityButton)("Follow", "Follow", "You follow", "Following");
    n.default = t;
  }, function (e, n, a) {
    "use strict";

    var t = a(2),
        i = a(1),
        o = t(a(41)),
        s = t(a(31)),
        r = t(a(43)),
        c = t(a(19)),
        p = t(a(44)),
        u = t(a(45)),
        l = t(a(32)),
        d = t(a(46)),
        m = t(a(47)),
        f = t(a(48)),
        v = (0, i.oneOfType)([i.string, i.object]),
        h = (0, i.oneOfType)([i.number, i.string]),
        x = (0, i.oneOfType)([i.array, i.string, i.element]),
        b = {
      children: x.isRequired
    },
        g = {
      src: v.isRequired,
      children: x
    };

    function y(e) {
      for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), t = 1; t < n; t++) {
        a[t - 1] = arguments[t];
      }

      e.propTypes = Object.assign.apply(Object, [{}].concat(a));
    }

    y(o.default, b), y(o.default, b), y(s.default, {
      popup: i.string
    }), y(r.default, s.default.propTypes), y(c.default, g), y(p.default, g, {
      defaultSrc: i.string
    }), y(u.default, {
      href: v.isRequired,
      children: x
    }), y(l.default, g), y(d.default, g), y(m.default, {
      src: v.isRequired,
      container: i.func,
      children: i.func,
      limit: h,
      offset: h,
      filter: i.func
    }), y(f.default, {
      subscribe: (0, i.oneOfType)([i.array, i.string])
    });
  }, function (e, n, a) {
    "use strict";

    var t = a(85);

    function i() {}

    e.exports = function () {
      function e(e, n, a, i, o, s) {
        if (s !== t) {
          var r = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw r.name = "Invariant Violation", r;
        }
      }

      function n() {
        return e;
      }

      e.isRequired = e;
      var a = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: n,
        element: e,
        instanceOf: n,
        node: e,
        objectOf: n,
        oneOf: n,
        oneOfType: n,
        shape: n,
        exact: n
      };
      return a.checkPropTypes = i, a.PropTypes = a, a;
    };
  }, function (e, n, a) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, n) {
    var a;

    a = function () {
      return this;
    }();

    try {
      a = a || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" === typeof window && (a = window);
    }

    e.exports = a;
  }, function (e, n, a) {
    (function (n) {
      (function () {
        var a, t, i, o, s, r;
        "undefined" !== typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : "undefined" !== typeof n && null !== n && n.hrtime ? (e.exports = function () {
          return (a() - s) / 1e6;
        }, t = n.hrtime, o = (a = function a() {
          var e;
          return 1e9 * (e = t())[0] + e[1];
        })(), r = 1e9 * n.uptime(), s = o - r) : Date.now ? (e.exports = function () {
          return Date.now() - i;
        }, i = Date.now()) : (e.exports = function () {
          return new Date().getTime() - i;
        }, i = new Date().getTime());
      }).call(this);
    }).call(this, a(49));
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.default = void 0;
    !function (e) {
      if (e && e.__esModule) return e;
      var n = {};
      if (null != e) for (var a in e) {
        if (Object.prototype.hasOwnProperty.call(e, a)) {
          var t = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(e, a) : {};
          t.get || t.set ? Object.defineProperty(n, a, t) : n[a] = e[a];
        }
      }
      n.default = e;
    }(a(1));
    var t = r(a(89)),
        i = r(a(92)),
        o = r(a(0)),
        s = r(a(50));
    a(52);

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function c() {
      return (c = Object.assign || function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var a = arguments[n];

          for (var t in a) {
            Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var p = function p(e, n) {
      return e && n && n.split(" ").forEach(function (n) {
        return (0, t.default)(e, n);
      });
    },
        u = function u(e, n) {
      return e && n && n.split(" ").forEach(function (n) {
        return (0, i.default)(e, n);
      });
    },
        l = function (e) {
      var n, a;

      function t() {
        for (var n, a = arguments.length, t = new Array(a), i = 0; i < a; i++) {
          t[i] = arguments[i];
        }

        return (n = e.call.apply(e, [this].concat(t)) || this).onEnter = function (e, a) {
          var t = n.getClassNames(a ? "appear" : "enter").className;
          n.removeClasses(e, "exit"), p(e, t), n.props.onEnter && n.props.onEnter(e, a);
        }, n.onEntering = function (e, a) {
          var t = n.getClassNames(a ? "appear" : "enter").activeClassName;
          n.reflowAndAddClass(e, t), n.props.onEntering && n.props.onEntering(e, a);
        }, n.onEntered = function (e, a) {
          var t = n.getClassNames("enter").doneClassName;
          n.removeClasses(e, a ? "appear" : "enter"), p(e, t), n.props.onEntered && n.props.onEntered(e, a);
        }, n.onExit = function (e) {
          var a = n.getClassNames("exit").className;
          n.removeClasses(e, "appear"), n.removeClasses(e, "enter"), p(e, a), n.props.onExit && n.props.onExit(e);
        }, n.onExiting = function (e) {
          var a = n.getClassNames("exit").activeClassName;
          n.reflowAndAddClass(e, a), n.props.onExiting && n.props.onExiting(e);
        }, n.onExited = function (e) {
          var a = n.getClassNames("exit").doneClassName;
          n.removeClasses(e, "exit"), p(e, a), n.props.onExited && n.props.onExited(e);
        }, n.getClassNames = function (e) {
          var a = n.props.classNames,
              t = "string" !== typeof a ? a[e] : a + "-" + e;
          return {
            className: t,
            activeClassName: "string" !== typeof a ? a[e + "Active"] : t + "-active",
            doneClassName: "string" !== typeof a ? a[e + "Done"] : t + "-done"
          };
        }, n;
      }

      a = e, (n = t).prototype = Object.create(a.prototype), n.prototype.constructor = n, n.__proto__ = a;
      var i = t.prototype;
      return i.removeClasses = function (e, n) {
        var a = this.getClassNames(n),
            t = a.className,
            i = a.activeClassName,
            o = a.doneClassName;
        t && u(e, t), i && u(e, i), o && u(e, o);
      }, i.reflowAndAddClass = function (e, n) {
        n && (e && e.scrollTop, p(e, n));
      }, i.render = function () {
        var e = c({}, this.props);
        return delete e.classNames, o.default.createElement(s.default, c({}, e, {
          onEnter: this.onEnter,
          onEntered: this.onEntered,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }));
      }, t;
    }(o.default.Component);

    l.propTypes = {};
    var d = l;
    n.default = d, e.exports = n.default;
  }, function (e, n, a) {
    "use strict";

    var t = a(90);
    n.__esModule = !0, n.default = function (e, n) {
      e.classList ? e.classList.add(n) : (0, i.default)(e, n) || ("string" === typeof e.className ? e.className = e.className + " " + n : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + n));
    };
    var i = t(a(91));
    e.exports = n.default;
  }, function (e, n) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.default = function (e, n) {
      return e.classList ? !!n && e.classList.contains(n) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + n + " ");
    }, e.exports = n.default;
  }, function (e, n, a) {
    "use strict";

    function t(e, n) {
      return e.replace(new RegExp("(^|\\s)" + n + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
    }

    e.exports = function (e, n) {
      e.classList ? e.classList.remove(n) : "string" === typeof e.className ? e.className = t(e.className, n) : e.setAttribute("class", t(e.className && e.className.baseVal || "", n));
    };
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.default = void 0;
    s(a(1));
    var t = s(a(0)),
        i = a(13),
        o = s(a(53));

    function s(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var r = function (e) {
      var n, a;

      function s() {
        for (var n, a = arguments.length, t = new Array(a), i = 0; i < a; i++) {
          t[i] = arguments[i];
        }

        return (n = e.call.apply(e, [this].concat(t)) || this).handleEnter = function () {
          for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
            a[t] = arguments[t];
          }

          return n.handleLifecycle("onEnter", 0, a);
        }, n.handleEntering = function () {
          for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
            a[t] = arguments[t];
          }

          return n.handleLifecycle("onEntering", 0, a);
        }, n.handleEntered = function () {
          for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
            a[t] = arguments[t];
          }

          return n.handleLifecycle("onEntered", 0, a);
        }, n.handleExit = function () {
          for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
            a[t] = arguments[t];
          }

          return n.handleLifecycle("onExit", 1, a);
        }, n.handleExiting = function () {
          for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
            a[t] = arguments[t];
          }

          return n.handleLifecycle("onExiting", 1, a);
        }, n.handleExited = function () {
          for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
            a[t] = arguments[t];
          }

          return n.handleLifecycle("onExited", 1, a);
        }, n;
      }

      a = e, (n = s).prototype = Object.create(a.prototype), n.prototype.constructor = n, n.__proto__ = a;
      var r = s.prototype;
      return r.handleLifecycle = function (e, n, a) {
        var o,
            s = this.props.children,
            r = t.default.Children.toArray(s)[n];
        r.props[e] && (o = r.props)[e].apply(o, a), this.props[e] && this.props[e]((0, i.findDOMNode)(this));
      }, r.render = function () {
        var e = this.props,
            n = e.children,
            a = e.in,
            i = function (e, n) {
          if (null == e) return {};
          var a,
              t,
              i = {},
              o = Object.keys(e);

          for (t = 0; t < o.length; t++) {
            a = o[t], n.indexOf(a) >= 0 || (i[a] = e[a]);
          }

          return i;
        }(e, ["children", "in"]),
            s = t.default.Children.toArray(n),
            r = s[0],
            c = s[1];

        return delete i.onEnter, delete i.onEntering, delete i.onEntered, delete i.onExit, delete i.onExiting, delete i.onExited, t.default.createElement(o.default, i, a ? t.default.cloneElement(r, {
          key: "first",
          onEnter: this.handleEnter,
          onEntering: this.handleEntering,
          onEntered: this.handleEntered
        }) : t.default.cloneElement(c, {
          key: "second",
          onEnter: this.handleExit,
          onEntering: this.handleExiting,
          onEntered: this.handleExited
        }));
      }, s;
    }(t.default.Component);

    r.propTypes = {};
    var c = r;
    n.default = c, e.exports = n.default;
  }, function (e, n, a) {
    "use strict";

    n.__esModule = !0, n.getChildMapping = i, n.mergeChildMappings = o, n.getInitialChildMapping = function (e, n) {
      return i(e.children, function (a) {
        return (0, t.cloneElement)(a, {
          onExited: n.bind(null, a),
          in: !0,
          appear: s(a, "appear", e),
          enter: s(a, "enter", e),
          exit: s(a, "exit", e)
        });
      });
    }, n.getNextChildMapping = function (e, n, a) {
      var r = i(e.children),
          c = o(n, r);
      return Object.keys(c).forEach(function (i) {
        var o = c[i];

        if ((0, t.isValidElement)(o)) {
          var p = i in n,
              u = i in r,
              l = n[i],
              d = (0, t.isValidElement)(l) && !l.props.in;
          !u || p && !d ? u || !p || d ? u && p && (0, t.isValidElement)(l) && (c[i] = (0, t.cloneElement)(o, {
            onExited: a.bind(null, o),
            in: l.props.in,
            exit: s(o, "exit", e),
            enter: s(o, "enter", e)
          })) : c[i] = (0, t.cloneElement)(o, {
            in: !1
          }) : c[i] = (0, t.cloneElement)(o, {
            onExited: a.bind(null, o),
            in: !0,
            exit: s(o, "exit", e),
            enter: s(o, "enter", e)
          });
        }
      }), c;
    };
    var t = a(0);

    function i(e, n) {
      var a = Object.create(null);
      return e && t.Children.map(e, function (e) {
        return e;
      }).forEach(function (e) {
        a[e.key] = function (e) {
          return n && (0, t.isValidElement)(e) ? n(e) : e;
        }(e);
      }), a;
    }

    function o(e, n) {
      function a(a) {
        return a in n ? n[a] : e[a];
      }

      e = e || {}, n = n || {};
      var t,
          i = Object.create(null),
          o = [];

      for (var s in e) {
        s in n ? o.length && (i[s] = o, o = []) : o.push(s);
      }

      var r = {};

      for (var c in n) {
        if (i[c]) for (t = 0; t < i[c].length; t++) {
          var p = i[c][t];
          r[i[c][t]] = a(p);
        }
        r[c] = a(c);
      }

      for (t = 0; t < o.length; t++) {
        r[o[t]] = a(o[t]);
      }

      return r;
    }

    function s(e, n, a) {
      return null != a[n] ? a[n] : e.props[n];
    }
  }, function (e, n) {
    e.exports = Array.isArray || function (e) {
      return "[object Array]" == Object.prototype.toString.call(e);
    };
  }, function (e, n, a) {
    e.exports = a(97);
  }, function (e) {
    e.exports = {
      "application/1d-interleaved-parityfec": {
        source: "iana"
      },
      "application/3gpdash-qoe-report+xml": {
        source: "iana",
        compressible: !0
      },
      "application/3gpp-ims+xml": {
        source: "iana",
        compressible: !0
      },
      "application/a2l": {
        source: "iana"
      },
      "application/activemessage": {
        source: "iana"
      },
      "application/activity+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-costmap+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-costmapfilter+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-directory+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-endpointcost+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-endpointcostparams+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-endpointprop+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-endpointpropparams+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-error+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-networkmap+json": {
        source: "iana",
        compressible: !0
      },
      "application/alto-networkmapfilter+json": {
        source: "iana",
        compressible: !0
      },
      "application/aml": {
        source: "iana"
      },
      "application/andrew-inset": {
        source: "iana",
        extensions: ["ez"]
      },
      "application/applefile": {
        source: "iana"
      },
      "application/applixware": {
        source: "apache",
        extensions: ["aw"]
      },
      "application/atf": {
        source: "iana"
      },
      "application/atfx": {
        source: "iana"
      },
      "application/atom+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["atom"]
      },
      "application/atomcat+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["atomcat"]
      },
      "application/atomdeleted+xml": {
        source: "iana",
        compressible: !0
      },
      "application/atomicmail": {
        source: "iana"
      },
      "application/atomsvc+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["atomsvc"]
      },
      "application/atxml": {
        source: "iana"
      },
      "application/auth-policy+xml": {
        source: "iana",
        compressible: !0
      },
      "application/bacnet-xdd+zip": {
        source: "iana",
        compressible: !1
      },
      "application/batch-smtp": {
        source: "iana"
      },
      "application/bdoc": {
        compressible: !1,
        extensions: ["bdoc"]
      },
      "application/beep+xml": {
        source: "iana",
        compressible: !0
      },
      "application/calendar+json": {
        source: "iana",
        compressible: !0
      },
      "application/calendar+xml": {
        source: "iana",
        compressible: !0
      },
      "application/call-completion": {
        source: "iana"
      },
      "application/cals-1840": {
        source: "iana"
      },
      "application/cbor": {
        source: "iana"
      },
      "application/cccex": {
        source: "iana"
      },
      "application/ccmp+xml": {
        source: "iana",
        compressible: !0
      },
      "application/ccxml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["ccxml"]
      },
      "application/cdfx+xml": {
        source: "iana",
        compressible: !0
      },
      "application/cdmi-capability": {
        source: "iana",
        extensions: ["cdmia"]
      },
      "application/cdmi-container": {
        source: "iana",
        extensions: ["cdmic"]
      },
      "application/cdmi-domain": {
        source: "iana",
        extensions: ["cdmid"]
      },
      "application/cdmi-object": {
        source: "iana",
        extensions: ["cdmio"]
      },
      "application/cdmi-queue": {
        source: "iana",
        extensions: ["cdmiq"]
      },
      "application/cdni": {
        source: "iana"
      },
      "application/cea": {
        source: "iana"
      },
      "application/cea-2018+xml": {
        source: "iana",
        compressible: !0
      },
      "application/cellml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/cfw": {
        source: "iana"
      },
      "application/clue_info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/cms": {
        source: "iana"
      },
      "application/cnrp+xml": {
        source: "iana",
        compressible: !0
      },
      "application/coap-group+json": {
        source: "iana",
        compressible: !0
      },
      "application/coap-payload": {
        source: "iana"
      },
      "application/commonground": {
        source: "iana"
      },
      "application/conference-info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/cose": {
        source: "iana"
      },
      "application/cose-key": {
        source: "iana"
      },
      "application/cose-key-set": {
        source: "iana"
      },
      "application/cpl+xml": {
        source: "iana",
        compressible: !0
      },
      "application/csrattrs": {
        source: "iana"
      },
      "application/csta+xml": {
        source: "iana",
        compressible: !0
      },
      "application/cstadata+xml": {
        source: "iana",
        compressible: !0
      },
      "application/csvm+json": {
        source: "iana",
        compressible: !0
      },
      "application/cu-seeme": {
        source: "apache",
        extensions: ["cu"]
      },
      "application/cwt": {
        source: "iana"
      },
      "application/cybercash": {
        source: "iana"
      },
      "application/dart": {
        compressible: !0
      },
      "application/dash+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mpd"]
      },
      "application/dashdelta": {
        source: "iana"
      },
      "application/davmount+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["davmount"]
      },
      "application/dca-rft": {
        source: "iana"
      },
      "application/dcd": {
        source: "iana"
      },
      "application/dec-dx": {
        source: "iana"
      },
      "application/dialog-info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/dicom": {
        source: "iana"
      },
      "application/dicom+json": {
        source: "iana",
        compressible: !0
      },
      "application/dicom+xml": {
        source: "iana",
        compressible: !0
      },
      "application/dii": {
        source: "iana"
      },
      "application/dit": {
        source: "iana"
      },
      "application/dns": {
        source: "iana"
      },
      "application/dns+json": {
        source: "iana",
        compressible: !0
      },
      "application/dns-message": {
        source: "iana"
      },
      "application/docbook+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["dbk"]
      },
      "application/dskpp+xml": {
        source: "iana",
        compressible: !0
      },
      "application/dssc+der": {
        source: "iana",
        extensions: ["dssc"]
      },
      "application/dssc+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xdssc"]
      },
      "application/dvcs": {
        source: "iana"
      },
      "application/ecmascript": {
        source: "iana",
        compressible: !0,
        extensions: ["ecma", "es"]
      },
      "application/edi-consent": {
        source: "iana"
      },
      "application/edi-x12": {
        source: "iana",
        compressible: !1
      },
      "application/edifact": {
        source: "iana",
        compressible: !1
      },
      "application/efi": {
        source: "iana"
      },
      "application/emergencycalldata.comment+xml": {
        source: "iana",
        compressible: !0
      },
      "application/emergencycalldata.control+xml": {
        source: "iana",
        compressible: !0
      },
      "application/emergencycalldata.deviceinfo+xml": {
        source: "iana",
        compressible: !0
      },
      "application/emergencycalldata.ecall.msd": {
        source: "iana"
      },
      "application/emergencycalldata.providerinfo+xml": {
        source: "iana",
        compressible: !0
      },
      "application/emergencycalldata.serviceinfo+xml": {
        source: "iana",
        compressible: !0
      },
      "application/emergencycalldata.subscriberinfo+xml": {
        source: "iana",
        compressible: !0
      },
      "application/emergencycalldata.veds+xml": {
        source: "iana",
        compressible: !0
      },
      "application/emma+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["emma"]
      },
      "application/emotionml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/encaprtp": {
        source: "iana"
      },
      "application/epp+xml": {
        source: "iana",
        compressible: !0
      },
      "application/epub+zip": {
        source: "iana",
        compressible: !1,
        extensions: ["epub"]
      },
      "application/eshop": {
        source: "iana"
      },
      "application/exi": {
        source: "iana",
        extensions: ["exi"]
      },
      "application/fastinfoset": {
        source: "iana"
      },
      "application/fastsoap": {
        source: "iana"
      },
      "application/fdt+xml": {
        source: "iana",
        compressible: !0
      },
      "application/fhir+json": {
        source: "iana",
        compressible: !0
      },
      "application/fhir+xml": {
        source: "iana",
        compressible: !0
      },
      "application/fido.trusted-apps+json": {
        compressible: !0
      },
      "application/fits": {
        source: "iana"
      },
      "application/font-sfnt": {
        source: "iana"
      },
      "application/font-tdpfr": {
        source: "iana",
        extensions: ["pfr"]
      },
      "application/font-woff": {
        source: "iana",
        compressible: !1
      },
      "application/framework-attributes+xml": {
        source: "iana",
        compressible: !0
      },
      "application/geo+json": {
        source: "iana",
        compressible: !0,
        extensions: ["geojson"]
      },
      "application/geo+json-seq": {
        source: "iana"
      },
      "application/geopackage+sqlite3": {
        source: "iana"
      },
      "application/geoxacml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/gltf-buffer": {
        source: "iana"
      },
      "application/gml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["gml"]
      },
      "application/gpx+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["gpx"]
      },
      "application/gxf": {
        source: "apache",
        extensions: ["gxf"]
      },
      "application/gzip": {
        source: "iana",
        compressible: !1,
        extensions: ["gz"]
      },
      "application/h224": {
        source: "iana"
      },
      "application/held+xml": {
        source: "iana",
        compressible: !0
      },
      "application/hjson": {
        extensions: ["hjson"]
      },
      "application/http": {
        source: "iana"
      },
      "application/hyperstudio": {
        source: "iana",
        extensions: ["stk"]
      },
      "application/ibe-key-request+xml": {
        source: "iana",
        compressible: !0
      },
      "application/ibe-pkg-reply+xml": {
        source: "iana",
        compressible: !0
      },
      "application/ibe-pp-data": {
        source: "iana"
      },
      "application/iges": {
        source: "iana"
      },
      "application/im-iscomposing+xml": {
        source: "iana",
        compressible: !0
      },
      "application/index": {
        source: "iana"
      },
      "application/index.cmd": {
        source: "iana"
      },
      "application/index.obj": {
        source: "iana"
      },
      "application/index.response": {
        source: "iana"
      },
      "application/index.vnd": {
        source: "iana"
      },
      "application/inkml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["ink", "inkml"]
      },
      "application/iotp": {
        source: "iana"
      },
      "application/ipfix": {
        source: "iana",
        extensions: ["ipfix"]
      },
      "application/ipp": {
        source: "iana"
      },
      "application/isup": {
        source: "iana"
      },
      "application/its+xml": {
        source: "iana",
        compressible: !0
      },
      "application/java-archive": {
        source: "apache",
        compressible: !1,
        extensions: ["jar", "war", "ear"]
      },
      "application/java-serialized-object": {
        source: "apache",
        compressible: !1,
        extensions: ["ser"]
      },
      "application/java-vm": {
        source: "apache",
        compressible: !1,
        extensions: ["class"]
      },
      "application/javascript": {
        source: "iana",
        charset: "UTF-8",
        compressible: !0,
        extensions: ["js", "mjs"]
      },
      "application/jf2feed+json": {
        source: "iana",
        compressible: !0
      },
      "application/jose": {
        source: "iana"
      },
      "application/jose+json": {
        source: "iana",
        compressible: !0
      },
      "application/jrd+json": {
        source: "iana",
        compressible: !0
      },
      "application/json": {
        source: "iana",
        charset: "UTF-8",
        compressible: !0,
        extensions: ["json", "map"]
      },
      "application/json-patch+json": {
        source: "iana",
        compressible: !0
      },
      "application/json-seq": {
        source: "iana"
      },
      "application/json5": {
        extensions: ["json5"]
      },
      "application/jsonml+json": {
        source: "apache",
        compressible: !0,
        extensions: ["jsonml"]
      },
      "application/jwk+json": {
        source: "iana",
        compressible: !0
      },
      "application/jwk-set+json": {
        source: "iana",
        compressible: !0
      },
      "application/jwt": {
        source: "iana"
      },
      "application/kpml-request+xml": {
        source: "iana",
        compressible: !0
      },
      "application/kpml-response+xml": {
        source: "iana",
        compressible: !0
      },
      "application/ld+json": {
        source: "iana",
        compressible: !0,
        extensions: ["jsonld"]
      },
      "application/lgr+xml": {
        source: "iana",
        compressible: !0
      },
      "application/link-format": {
        source: "iana"
      },
      "application/load-control+xml": {
        source: "iana",
        compressible: !0
      },
      "application/lost+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["lostxml"]
      },
      "application/lostsync+xml": {
        source: "iana",
        compressible: !0
      },
      "application/lxf": {
        source: "iana"
      },
      "application/mac-binhex40": {
        source: "iana",
        extensions: ["hqx"]
      },
      "application/mac-compactpro": {
        source: "apache",
        extensions: ["cpt"]
      },
      "application/macwriteii": {
        source: "iana"
      },
      "application/mads+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mads"]
      },
      "application/manifest+json": {
        charset: "UTF-8",
        compressible: !0,
        extensions: ["webmanifest"]
      },
      "application/marc": {
        source: "iana",
        extensions: ["mrc"]
      },
      "application/marcxml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mrcx"]
      },
      "application/mathematica": {
        source: "iana",
        extensions: ["ma", "nb", "mb"]
      },
      "application/mathml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mathml"]
      },
      "application/mathml-content+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mathml-presentation+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-associated-procedure-description+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-deregister+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-envelope+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-msk+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-msk-response+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-protection-description+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-reception-report+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-register+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-register-response+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-schedule+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbms-user-service-description+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mbox": {
        source: "iana",
        extensions: ["mbox"]
      },
      "application/media-policy-dataset+xml": {
        source: "iana",
        compressible: !0
      },
      "application/media_control+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mediaservercontrol+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mscml"]
      },
      "application/merge-patch+json": {
        source: "iana",
        compressible: !0
      },
      "application/metalink+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["metalink"]
      },
      "application/metalink4+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["meta4"]
      },
      "application/mets+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mets"]
      },
      "application/mf4": {
        source: "iana"
      },
      "application/mikey": {
        source: "iana"
      },
      "application/mmt-usd+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mods+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mods"]
      },
      "application/moss-keys": {
        source: "iana"
      },
      "application/moss-signature": {
        source: "iana"
      },
      "application/mosskey-data": {
        source: "iana"
      },
      "application/mosskey-request": {
        source: "iana"
      },
      "application/mp21": {
        source: "iana",
        extensions: ["m21", "mp21"]
      },
      "application/mp4": {
        source: "iana",
        extensions: ["mp4s", "m4p"]
      },
      "application/mpeg4-generic": {
        source: "iana"
      },
      "application/mpeg4-iod": {
        source: "iana"
      },
      "application/mpeg4-iod-xmt": {
        source: "iana"
      },
      "application/mrb-consumer+xml": {
        source: "iana",
        compressible: !0
      },
      "application/mrb-publish+xml": {
        source: "iana",
        compressible: !0
      },
      "application/msc-ivr+xml": {
        source: "iana",
        compressible: !0
      },
      "application/msc-mixer+xml": {
        source: "iana",
        compressible: !0
      },
      "application/msword": {
        source: "iana",
        compressible: !1,
        extensions: ["doc", "dot"]
      },
      "application/mud+json": {
        source: "iana",
        compressible: !0
      },
      "application/mxf": {
        source: "iana",
        extensions: ["mxf"]
      },
      "application/n-quads": {
        source: "iana"
      },
      "application/n-triples": {
        source: "iana"
      },
      "application/nasdata": {
        source: "iana"
      },
      "application/news-checkgroups": {
        source: "iana"
      },
      "application/news-groupinfo": {
        source: "iana"
      },
      "application/news-transmission": {
        source: "iana"
      },
      "application/nlsml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/node": {
        source: "iana"
      },
      "application/nss": {
        source: "iana"
      },
      "application/ocsp-request": {
        source: "iana"
      },
      "application/ocsp-response": {
        source: "iana"
      },
      "application/octet-stream": {
        source: "iana",
        compressible: !1,
        extensions: ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"]
      },
      "application/oda": {
        source: "iana",
        extensions: ["oda"]
      },
      "application/odx": {
        source: "iana"
      },
      "application/oebps-package+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["opf"]
      },
      "application/ogg": {
        source: "iana",
        compressible: !1,
        extensions: ["ogx"]
      },
      "application/omdoc+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["omdoc"]
      },
      "application/onenote": {
        source: "apache",
        extensions: ["onetoc", "onetoc2", "onetmp", "onepkg"]
      },
      "application/oxps": {
        source: "iana",
        extensions: ["oxps"]
      },
      "application/p2p-overlay+xml": {
        source: "iana",
        compressible: !0
      },
      "application/parityfec": {
        source: "iana"
      },
      "application/passport": {
        source: "iana"
      },
      "application/patch-ops-error+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xer"]
      },
      "application/pdf": {
        source: "iana",
        compressible: !1,
        extensions: ["pdf"]
      },
      "application/pdx": {
        source: "iana"
      },
      "application/pgp-encrypted": {
        source: "iana",
        compressible: !1,
        extensions: ["pgp"]
      },
      "application/pgp-keys": {
        source: "iana"
      },
      "application/pgp-signature": {
        source: "iana",
        extensions: ["asc", "sig"]
      },
      "application/pics-rules": {
        source: "apache",
        extensions: ["prf"]
      },
      "application/pidf+xml": {
        source: "iana",
        compressible: !0
      },
      "application/pidf-diff+xml": {
        source: "iana",
        compressible: !0
      },
      "application/pkcs10": {
        source: "iana",
        extensions: ["p10"]
      },
      "application/pkcs12": {
        source: "iana"
      },
      "application/pkcs7-mime": {
        source: "iana",
        extensions: ["p7m", "p7c"]
      },
      "application/pkcs7-signature": {
        source: "iana",
        extensions: ["p7s"]
      },
      "application/pkcs8": {
        source: "iana",
        extensions: ["p8"]
      },
      "application/pkcs8-encrypted": {
        source: "iana"
      },
      "application/pkix-attr-cert": {
        source: "iana",
        extensions: ["ac"]
      },
      "application/pkix-cert": {
        source: "iana",
        extensions: ["cer"]
      },
      "application/pkix-crl": {
        source: "iana",
        extensions: ["crl"]
      },
      "application/pkix-pkipath": {
        source: "iana",
        extensions: ["pkipath"]
      },
      "application/pkixcmp": {
        source: "iana",
        extensions: ["pki"]
      },
      "application/pls+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["pls"]
      },
      "application/poc-settings+xml": {
        source: "iana",
        compressible: !0
      },
      "application/postscript": {
        source: "iana",
        compressible: !0,
        extensions: ["ai", "eps", "ps"]
      },
      "application/ppsp-tracker+json": {
        source: "iana",
        compressible: !0
      },
      "application/problem+json": {
        source: "iana",
        compressible: !0
      },
      "application/problem+xml": {
        source: "iana",
        compressible: !0
      },
      "application/provenance+xml": {
        source: "iana",
        compressible: !0
      },
      "application/prs.alvestrand.titrax-sheet": {
        source: "iana"
      },
      "application/prs.cww": {
        source: "iana",
        extensions: ["cww"]
      },
      "application/prs.hpub+zip": {
        source: "iana",
        compressible: !1
      },
      "application/prs.nprend": {
        source: "iana"
      },
      "application/prs.plucker": {
        source: "iana"
      },
      "application/prs.rdf-xml-crypt": {
        source: "iana"
      },
      "application/prs.xsf+xml": {
        source: "iana",
        compressible: !0
      },
      "application/pskc+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["pskcxml"]
      },
      "application/qsig": {
        source: "iana"
      },
      "application/raml+yaml": {
        compressible: !0,
        extensions: ["raml"]
      },
      "application/raptorfec": {
        source: "iana"
      },
      "application/rdap+json": {
        source: "iana",
        compressible: !0
      },
      "application/rdf+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["rdf", "owl"]
      },
      "application/reginfo+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["rif"]
      },
      "application/relax-ng-compact-syntax": {
        source: "iana",
        extensions: ["rnc"]
      },
      "application/remote-printing": {
        source: "iana"
      },
      "application/reputon+json": {
        source: "iana",
        compressible: !0
      },
      "application/resource-lists+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["rl"]
      },
      "application/resource-lists-diff+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["rld"]
      },
      "application/rfc+xml": {
        source: "iana",
        compressible: !0
      },
      "application/riscos": {
        source: "iana"
      },
      "application/rlmi+xml": {
        source: "iana",
        compressible: !0
      },
      "application/rls-services+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["rs"]
      },
      "application/route-apd+xml": {
        source: "iana",
        compressible: !0
      },
      "application/route-s-tsid+xml": {
        source: "iana",
        compressible: !0
      },
      "application/route-usd+xml": {
        source: "iana",
        compressible: !0
      },
      "application/rpki-ghostbusters": {
        source: "iana",
        extensions: ["gbr"]
      },
      "application/rpki-manifest": {
        source: "iana",
        extensions: ["mft"]
      },
      "application/rpki-publication": {
        source: "iana"
      },
      "application/rpki-roa": {
        source: "iana",
        extensions: ["roa"]
      },
      "application/rpki-updown": {
        source: "iana"
      },
      "application/rsd+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["rsd"]
      },
      "application/rss+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["rss"]
      },
      "application/rtf": {
        source: "iana",
        compressible: !0,
        extensions: ["rtf"]
      },
      "application/rtploopback": {
        source: "iana"
      },
      "application/rtx": {
        source: "iana"
      },
      "application/samlassertion+xml": {
        source: "iana",
        compressible: !0
      },
      "application/samlmetadata+xml": {
        source: "iana",
        compressible: !0
      },
      "application/sbml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["sbml"]
      },
      "application/scaip+xml": {
        source: "iana",
        compressible: !0
      },
      "application/scim+json": {
        source: "iana",
        compressible: !0
      },
      "application/scvp-cv-request": {
        source: "iana",
        extensions: ["scq"]
      },
      "application/scvp-cv-response": {
        source: "iana",
        extensions: ["scs"]
      },
      "application/scvp-vp-request": {
        source: "iana",
        extensions: ["spq"]
      },
      "application/scvp-vp-response": {
        source: "iana",
        extensions: ["spp"]
      },
      "application/sdp": {
        source: "iana",
        extensions: ["sdp"]
      },
      "application/secevent+jwt": {
        source: "iana"
      },
      "application/senml+cbor": {
        source: "iana"
      },
      "application/senml+json": {
        source: "iana",
        compressible: !0
      },
      "application/senml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/senml-exi": {
        source: "iana"
      },
      "application/sensml+cbor": {
        source: "iana"
      },
      "application/sensml+json": {
        source: "iana",
        compressible: !0
      },
      "application/sensml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/sensml-exi": {
        source: "iana"
      },
      "application/sep+xml": {
        source: "iana",
        compressible: !0
      },
      "application/sep-exi": {
        source: "iana"
      },
      "application/session-info": {
        source: "iana"
      },
      "application/set-payment": {
        source: "iana"
      },
      "application/set-payment-initiation": {
        source: "iana",
        extensions: ["setpay"]
      },
      "application/set-registration": {
        source: "iana"
      },
      "application/set-registration-initiation": {
        source: "iana",
        extensions: ["setreg"]
      },
      "application/sgml": {
        source: "iana"
      },
      "application/sgml-open-catalog": {
        source: "iana"
      },
      "application/shf+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["shf"]
      },
      "application/sieve": {
        source: "iana"
      },
      "application/simple-filter+xml": {
        source: "iana",
        compressible: !0
      },
      "application/simple-message-summary": {
        source: "iana"
      },
      "application/simplesymbolcontainer": {
        source: "iana"
      },
      "application/slate": {
        source: "iana"
      },
      "application/smil": {
        source: "iana"
      },
      "application/smil+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["smi", "smil"]
      },
      "application/smpte336m": {
        source: "iana"
      },
      "application/soap+fastinfoset": {
        source: "iana"
      },
      "application/soap+xml": {
        source: "iana",
        compressible: !0
      },
      "application/sparql-query": {
        source: "iana",
        extensions: ["rq"]
      },
      "application/sparql-results+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["srx"]
      },
      "application/spirits-event+xml": {
        source: "iana",
        compressible: !0
      },
      "application/sql": {
        source: "iana"
      },
      "application/srgs": {
        source: "iana",
        extensions: ["gram"]
      },
      "application/srgs+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["grxml"]
      },
      "application/sru+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["sru"]
      },
      "application/ssdl+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["ssdl"]
      },
      "application/ssml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["ssml"]
      },
      "application/stix+json": {
        source: "iana",
        compressible: !0
      },
      "application/tamp-apex-update": {
        source: "iana"
      },
      "application/tamp-apex-update-confirm": {
        source: "iana"
      },
      "application/tamp-community-update": {
        source: "iana"
      },
      "application/tamp-community-update-confirm": {
        source: "iana"
      },
      "application/tamp-error": {
        source: "iana"
      },
      "application/tamp-sequence-adjust": {
        source: "iana"
      },
      "application/tamp-sequence-adjust-confirm": {
        source: "iana"
      },
      "application/tamp-status-query": {
        source: "iana"
      },
      "application/tamp-status-response": {
        source: "iana"
      },
      "application/tamp-update": {
        source: "iana"
      },
      "application/tamp-update-confirm": {
        source: "iana"
      },
      "application/tar": {
        compressible: !0
      },
      "application/taxii+json": {
        source: "iana",
        compressible: !0
      },
      "application/tei+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["tei", "teicorpus"]
      },
      "application/thraud+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["tfi"]
      },
      "application/timestamp-query": {
        source: "iana"
      },
      "application/timestamp-reply": {
        source: "iana"
      },
      "application/timestamped-data": {
        source: "iana",
        extensions: ["tsd"]
      },
      "application/tlsrpt+gzip": {
        source: "iana"
      },
      "application/tlsrpt+json": {
        source: "iana",
        compressible: !0
      },
      "application/tnauthlist": {
        source: "iana"
      },
      "application/trickle-ice-sdpfrag": {
        source: "iana"
      },
      "application/trig": {
        source: "iana"
      },
      "application/ttml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/tve-trigger": {
        source: "iana"
      },
      "application/ulpfec": {
        source: "iana"
      },
      "application/urc-grpsheet+xml": {
        source: "iana",
        compressible: !0
      },
      "application/urc-ressheet+xml": {
        source: "iana",
        compressible: !0
      },
      "application/urc-targetdesc+xml": {
        source: "iana",
        compressible: !0
      },
      "application/urc-uisocketdesc+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vcard+json": {
        source: "iana",
        compressible: !0
      },
      "application/vcard+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vemmi": {
        source: "iana"
      },
      "application/vividence.scriptfile": {
        source: "apache"
      },
      "application/vnd.1000minds.decision-model+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp-prose+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp-prose-pc3ch+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp-v2x-local-service-information": {
        source: "iana"
      },
      "application/vnd.3gpp.access-transfer-events+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.bsf+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.gmop+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.mc-signalling-ear": {
        source: "iana"
      },
      "application/vnd.3gpp.mcdata-payload": {
        source: "iana"
      },
      "application/vnd.3gpp.mcdata-signalling": {
        source: "iana"
      },
      "application/vnd.3gpp.mcptt-affiliation-command+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.mcptt-floor-request+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.mcptt-info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.mcptt-location-info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.mcptt-mbms-usage-info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.mcptt-signed+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.mid-call+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.pic-bw-large": {
        source: "iana",
        extensions: ["plb"]
      },
      "application/vnd.3gpp.pic-bw-small": {
        source: "iana",
        extensions: ["psb"]
      },
      "application/vnd.3gpp.pic-bw-var": {
        source: "iana",
        extensions: ["pvb"]
      },
      "application/vnd.3gpp.sms": {
        source: "iana"
      },
      "application/vnd.3gpp.sms+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.srvcc-ext+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.srvcc-info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.state-and-event-info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp.ussd+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp2.bcmcsinfo+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.3gpp2.sms": {
        source: "iana"
      },
      "application/vnd.3gpp2.tcap": {
        source: "iana",
        extensions: ["tcap"]
      },
      "application/vnd.3lightssoftware.imagescal": {
        source: "iana"
      },
      "application/vnd.3m.post-it-notes": {
        source: "iana",
        extensions: ["pwn"]
      },
      "application/vnd.accpac.simply.aso": {
        source: "iana",
        extensions: ["aso"]
      },
      "application/vnd.accpac.simply.imp": {
        source: "iana",
        extensions: ["imp"]
      },
      "application/vnd.acucobol": {
        source: "iana",
        extensions: ["acu"]
      },
      "application/vnd.acucorp": {
        source: "iana",
        extensions: ["atc", "acutc"]
      },
      "application/vnd.adobe.air-application-installer-package+zip": {
        source: "apache",
        compressible: !1,
        extensions: ["air"]
      },
      "application/vnd.adobe.flash.movie": {
        source: "iana"
      },
      "application/vnd.adobe.formscentral.fcdt": {
        source: "iana",
        extensions: ["fcdt"]
      },
      "application/vnd.adobe.fxp": {
        source: "iana",
        extensions: ["fxp", "fxpl"]
      },
      "application/vnd.adobe.partial-upload": {
        source: "iana"
      },
      "application/vnd.adobe.xdp+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xdp"]
      },
      "application/vnd.adobe.xfdf": {
        source: "iana",
        extensions: ["xfdf"]
      },
      "application/vnd.aether.imp": {
        source: "iana"
      },
      "application/vnd.afpc.afplinedata": {
        source: "iana"
      },
      "application/vnd.afpc.modca": {
        source: "iana"
      },
      "application/vnd.ah-barcode": {
        source: "iana"
      },
      "application/vnd.ahead.space": {
        source: "iana",
        extensions: ["ahead"]
      },
      "application/vnd.airzip.filesecure.azf": {
        source: "iana",
        extensions: ["azf"]
      },
      "application/vnd.airzip.filesecure.azs": {
        source: "iana",
        extensions: ["azs"]
      },
      "application/vnd.amadeus+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.amazon.ebook": {
        source: "apache",
        extensions: ["azw"]
      },
      "application/vnd.amazon.mobi8-ebook": {
        source: "iana"
      },
      "application/vnd.americandynamics.acc": {
        source: "iana",
        extensions: ["acc"]
      },
      "application/vnd.amiga.ami": {
        source: "iana",
        extensions: ["ami"]
      },
      "application/vnd.amundsen.maze+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.android.package-archive": {
        source: "apache",
        compressible: !1,
        extensions: ["apk"]
      },
      "application/vnd.anki": {
        source: "iana"
      },
      "application/vnd.anser-web-certificate-issue-initiation": {
        source: "iana",
        extensions: ["cii"]
      },
      "application/vnd.anser-web-funds-transfer-initiation": {
        source: "apache",
        extensions: ["fti"]
      },
      "application/vnd.antix.game-component": {
        source: "iana",
        extensions: ["atx"]
      },
      "application/vnd.apache.thrift.binary": {
        source: "iana"
      },
      "application/vnd.apache.thrift.compact": {
        source: "iana"
      },
      "application/vnd.apache.thrift.json": {
        source: "iana"
      },
      "application/vnd.api+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.apothekende.reservation+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.apple.installer+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mpkg"]
      },
      "application/vnd.apple.keynote": {
        source: "iana",
        extensions: ["keynote"]
      },
      "application/vnd.apple.mpegurl": {
        source: "iana",
        extensions: ["m3u8"]
      },
      "application/vnd.apple.numbers": {
        source: "iana",
        extensions: ["numbers"]
      },
      "application/vnd.apple.pages": {
        source: "iana",
        extensions: ["pages"]
      },
      "application/vnd.apple.pkpass": {
        compressible: !1,
        extensions: ["pkpass"]
      },
      "application/vnd.arastra.swi": {
        source: "iana"
      },
      "application/vnd.aristanetworks.swi": {
        source: "iana",
        extensions: ["swi"]
      },
      "application/vnd.artisan+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.artsquare": {
        source: "iana"
      },
      "application/vnd.astraea-software.iota": {
        source: "iana",
        extensions: ["iota"]
      },
      "application/vnd.audiograph": {
        source: "iana",
        extensions: ["aep"]
      },
      "application/vnd.autopackage": {
        source: "iana"
      },
      "application/vnd.avalon+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.avistar+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.balsamiq.bmml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.balsamiq.bmpr": {
        source: "iana"
      },
      "application/vnd.banana-accounting": {
        source: "iana"
      },
      "application/vnd.bbf.usp.msg": {
        source: "iana"
      },
      "application/vnd.bbf.usp.msg+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.bekitzur-stech+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.bint.med-content": {
        source: "iana"
      },
      "application/vnd.biopax.rdf+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.blink-idb-value-wrapper": {
        source: "iana"
      },
      "application/vnd.blueice.multipass": {
        source: "iana",
        extensions: ["mpm"]
      },
      "application/vnd.bluetooth.ep.oob": {
        source: "iana"
      },
      "application/vnd.bluetooth.le.oob": {
        source: "iana"
      },
      "application/vnd.bmi": {
        source: "iana",
        extensions: ["bmi"]
      },
      "application/vnd.businessobjects": {
        source: "iana",
        extensions: ["rep"]
      },
      "application/vnd.byu.uapi+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.cab-jscript": {
        source: "iana"
      },
      "application/vnd.canon-cpdl": {
        source: "iana"
      },
      "application/vnd.canon-lips": {
        source: "iana"
      },
      "application/vnd.capasystems-pg+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.cendio.thinlinc.clientconf": {
        source: "iana"
      },
      "application/vnd.century-systems.tcp_stream": {
        source: "iana"
      },
      "application/vnd.chemdraw+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["cdxml"]
      },
      "application/vnd.chess-pgn": {
        source: "iana"
      },
      "application/vnd.chipnuts.karaoke-mmd": {
        source: "iana",
        extensions: ["mmd"]
      },
      "application/vnd.cinderella": {
        source: "iana",
        extensions: ["cdy"]
      },
      "application/vnd.cirpack.isdn-ext": {
        source: "iana"
      },
      "application/vnd.citationstyles.style+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["csl"]
      },
      "application/vnd.claymore": {
        source: "iana",
        extensions: ["cla"]
      },
      "application/vnd.cloanto.rp9": {
        source: "iana",
        extensions: ["rp9"]
      },
      "application/vnd.clonk.c4group": {
        source: "iana",
        extensions: ["c4g", "c4d", "c4f", "c4p", "c4u"]
      },
      "application/vnd.cluetrust.cartomobile-config": {
        source: "iana",
        extensions: ["c11amc"]
      },
      "application/vnd.cluetrust.cartomobile-config-pkg": {
        source: "iana",
        extensions: ["c11amz"]
      },
      "application/vnd.coffeescript": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.document": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.document-template": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.presentation": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.presentation-template": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.spreadsheet": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.spreadsheet-template": {
        source: "iana"
      },
      "application/vnd.collection+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.collection.doc+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.collection.next+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.comicbook+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.comicbook-rar": {
        source: "iana"
      },
      "application/vnd.commerce-battelle": {
        source: "iana"
      },
      "application/vnd.commonspace": {
        source: "iana",
        extensions: ["csp"]
      },
      "application/vnd.contact.cmsg": {
        source: "iana",
        extensions: ["cdbcmsg"]
      },
      "application/vnd.coreos.ignition+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.cosmocaller": {
        source: "iana",
        extensions: ["cmc"]
      },
      "application/vnd.crick.clicker": {
        source: "iana",
        extensions: ["clkx"]
      },
      "application/vnd.crick.clicker.keyboard": {
        source: "iana",
        extensions: ["clkk"]
      },
      "application/vnd.crick.clicker.palette": {
        source: "iana",
        extensions: ["clkp"]
      },
      "application/vnd.crick.clicker.template": {
        source: "iana",
        extensions: ["clkt"]
      },
      "application/vnd.crick.clicker.wordbank": {
        source: "iana",
        extensions: ["clkw"]
      },
      "application/vnd.criticaltools.wbs+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["wbs"]
      },
      "application/vnd.ctc-posml": {
        source: "iana",
        extensions: ["pml"]
      },
      "application/vnd.ctct.ws+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.cups-pdf": {
        source: "iana"
      },
      "application/vnd.cups-postscript": {
        source: "iana"
      },
      "application/vnd.cups-ppd": {
        source: "iana",
        extensions: ["ppd"]
      },
      "application/vnd.cups-raster": {
        source: "iana"
      },
      "application/vnd.cups-raw": {
        source: "iana"
      },
      "application/vnd.curl": {
        source: "iana"
      },
      "application/vnd.curl.car": {
        source: "apache",
        extensions: ["car"]
      },
      "application/vnd.curl.pcurl": {
        source: "apache",
        extensions: ["pcurl"]
      },
      "application/vnd.cyan.dean.root+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.cybank": {
        source: "iana"
      },
      "application/vnd.d2l.coursepackage1p0+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.dart": {
        source: "iana",
        compressible: !0,
        extensions: ["dart"]
      },
      "application/vnd.data-vision.rdz": {
        source: "iana",
        extensions: ["rdz"]
      },
      "application/vnd.datapackage+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dataresource+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.debian.binary-package": {
        source: "iana"
      },
      "application/vnd.dece.data": {
        source: "iana",
        extensions: ["uvf", "uvvf", "uvd", "uvvd"]
      },
      "application/vnd.dece.ttml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["uvt", "uvvt"]
      },
      "application/vnd.dece.unspecified": {
        source: "iana",
        extensions: ["uvx", "uvvx"]
      },
      "application/vnd.dece.zip": {
        source: "iana",
        extensions: ["uvz", "uvvz"]
      },
      "application/vnd.denovo.fcselayout-link": {
        source: "iana",
        extensions: ["fe_launch"]
      },
      "application/vnd.desmume.movie": {
        source: "iana"
      },
      "application/vnd.dir-bi.plate-dl-nosuffix": {
        source: "iana"
      },
      "application/vnd.dm.delegation+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dna": {
        source: "iana",
        extensions: ["dna"]
      },
      "application/vnd.document+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dolby.mlp": {
        source: "apache",
        extensions: ["mlp"]
      },
      "application/vnd.dolby.mobile.1": {
        source: "iana"
      },
      "application/vnd.dolby.mobile.2": {
        source: "iana"
      },
      "application/vnd.doremir.scorecloud-binary-document": {
        source: "iana"
      },
      "application/vnd.dpgraph": {
        source: "iana",
        extensions: ["dpg"]
      },
      "application/vnd.dreamfactory": {
        source: "iana",
        extensions: ["dfac"]
      },
      "application/vnd.drive+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ds-keypoint": {
        source: "apache",
        extensions: ["kpxx"]
      },
      "application/vnd.dtg.local": {
        source: "iana"
      },
      "application/vnd.dtg.local.flash": {
        source: "iana"
      },
      "application/vnd.dtg.local.html": {
        source: "iana"
      },
      "application/vnd.dvb.ait": {
        source: "iana",
        extensions: ["ait"]
      },
      "application/vnd.dvb.dvbj": {
        source: "iana"
      },
      "application/vnd.dvb.esgcontainer": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcdftnotifaccess": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcesgaccess": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcesgaccess2": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcesgpdd": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcroaming": {
        source: "iana"
      },
      "application/vnd.dvb.iptv.alfec-base": {
        source: "iana"
      },
      "application/vnd.dvb.iptv.alfec-enhancement": {
        source: "iana"
      },
      "application/vnd.dvb.notif-aggregate-root+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dvb.notif-container+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dvb.notif-generic+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dvb.notif-ia-msglist+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dvb.notif-ia-registration-request+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dvb.notif-ia-registration-response+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dvb.notif-init+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.dvb.pfr": {
        source: "iana"
      },
      "application/vnd.dvb.service": {
        source: "iana",
        extensions: ["svc"]
      },
      "application/vnd.dxr": {
        source: "iana"
      },
      "application/vnd.dynageo": {
        source: "iana",
        extensions: ["geo"]
      },
      "application/vnd.dzr": {
        source: "iana"
      },
      "application/vnd.easykaraoke.cdgdownload": {
        source: "iana"
      },
      "application/vnd.ecdis-update": {
        source: "iana"
      },
      "application/vnd.ecip.rlp": {
        source: "iana"
      },
      "application/vnd.ecowin.chart": {
        source: "iana",
        extensions: ["mag"]
      },
      "application/vnd.ecowin.filerequest": {
        source: "iana"
      },
      "application/vnd.ecowin.fileupdate": {
        source: "iana"
      },
      "application/vnd.ecowin.series": {
        source: "iana"
      },
      "application/vnd.ecowin.seriesrequest": {
        source: "iana"
      },
      "application/vnd.ecowin.seriesupdate": {
        source: "iana"
      },
      "application/vnd.efi.img": {
        source: "iana"
      },
      "application/vnd.efi.iso": {
        source: "iana"
      },
      "application/vnd.emclient.accessrequest+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.enliven": {
        source: "iana",
        extensions: ["nml"]
      },
      "application/vnd.enphase.envoy": {
        source: "iana"
      },
      "application/vnd.eprints.data+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.epson.esf": {
        source: "iana",
        extensions: ["esf"]
      },
      "application/vnd.epson.msf": {
        source: "iana",
        extensions: ["msf"]
      },
      "application/vnd.epson.quickanime": {
        source: "iana",
        extensions: ["qam"]
      },
      "application/vnd.epson.salt": {
        source: "iana",
        extensions: ["slt"]
      },
      "application/vnd.epson.ssf": {
        source: "iana",
        extensions: ["ssf"]
      },
      "application/vnd.ericsson.quickcall": {
        source: "iana"
      },
      "application/vnd.espass-espass+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.eszigno3+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["es3", "et3"]
      },
      "application/vnd.etsi.aoc+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.asic-e+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.etsi.asic-s+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.etsi.cug+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvcommand+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvdiscovery+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvprofile+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvsad-bc+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvsad-cod+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvsad-npvr+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvservice+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvsync+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.iptvueprofile+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.mcid+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.mheg5": {
        source: "iana"
      },
      "application/vnd.etsi.overload-control-policy-dataset+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.pstn+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.sci+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.simservs+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.timestamp-token": {
        source: "iana"
      },
      "application/vnd.etsi.tsl+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.etsi.tsl.der": {
        source: "iana"
      },
      "application/vnd.eudora.data": {
        source: "iana"
      },
      "application/vnd.evolv.ecig.profile": {
        source: "iana"
      },
      "application/vnd.evolv.ecig.settings": {
        source: "iana"
      },
      "application/vnd.evolv.ecig.theme": {
        source: "iana"
      },
      "application/vnd.exstream-empower+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.ezpix-album": {
        source: "iana",
        extensions: ["ez2"]
      },
      "application/vnd.ezpix-package": {
        source: "iana",
        extensions: ["ez3"]
      },
      "application/vnd.f-secure.mobile": {
        source: "iana"
      },
      "application/vnd.fastcopy-disk-image": {
        source: "iana"
      },
      "application/vnd.fdf": {
        source: "iana",
        extensions: ["fdf"]
      },
      "application/vnd.fdsn.mseed": {
        source: "iana",
        extensions: ["mseed"]
      },
      "application/vnd.fdsn.seed": {
        source: "iana",
        extensions: ["seed", "dataless"]
      },
      "application/vnd.ffsns": {
        source: "iana"
      },
      "application/vnd.filmit.zfc": {
        source: "iana"
      },
      "application/vnd.fints": {
        source: "iana"
      },
      "application/vnd.firemonkeys.cloudcell": {
        source: "iana"
      },
      "application/vnd.flographit": {
        source: "iana",
        extensions: ["gph"]
      },
      "application/vnd.fluxtime.clip": {
        source: "iana",
        extensions: ["ftc"]
      },
      "application/vnd.font-fontforge-sfd": {
        source: "iana"
      },
      "application/vnd.framemaker": {
        source: "iana",
        extensions: ["fm", "frame", "maker", "book"]
      },
      "application/vnd.frogans.fnc": {
        source: "iana",
        extensions: ["fnc"]
      },
      "application/vnd.frogans.ltf": {
        source: "iana",
        extensions: ["ltf"]
      },
      "application/vnd.fsc.weblaunch": {
        source: "iana",
        extensions: ["fsc"]
      },
      "application/vnd.fujitsu.oasys": {
        source: "iana",
        extensions: ["oas"]
      },
      "application/vnd.fujitsu.oasys2": {
        source: "iana",
        extensions: ["oa2"]
      },
      "application/vnd.fujitsu.oasys3": {
        source: "iana",
        extensions: ["oa3"]
      },
      "application/vnd.fujitsu.oasysgp": {
        source: "iana",
        extensions: ["fg5"]
      },
      "application/vnd.fujitsu.oasysprs": {
        source: "iana",
        extensions: ["bh2"]
      },
      "application/vnd.fujixerox.art-ex": {
        source: "iana"
      },
      "application/vnd.fujixerox.art4": {
        source: "iana"
      },
      "application/vnd.fujixerox.ddd": {
        source: "iana",
        extensions: ["ddd"]
      },
      "application/vnd.fujixerox.docuworks": {
        source: "iana",
        extensions: ["xdw"]
      },
      "application/vnd.fujixerox.docuworks.binder": {
        source: "iana",
        extensions: ["xbd"]
      },
      "application/vnd.fujixerox.docuworks.container": {
        source: "iana"
      },
      "application/vnd.fujixerox.hbpl": {
        source: "iana"
      },
      "application/vnd.fut-misnet": {
        source: "iana"
      },
      "application/vnd.futoin+cbor": {
        source: "iana"
      },
      "application/vnd.futoin+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.fuzzysheet": {
        source: "iana",
        extensions: ["fzs"]
      },
      "application/vnd.genomatix.tuxedo": {
        source: "iana",
        extensions: ["txd"]
      },
      "application/vnd.geo+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.geocube+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.geogebra.file": {
        source: "iana",
        extensions: ["ggb"]
      },
      "application/vnd.geogebra.tool": {
        source: "iana",
        extensions: ["ggt"]
      },
      "application/vnd.geometry-explorer": {
        source: "iana",
        extensions: ["gex", "gre"]
      },
      "application/vnd.geonext": {
        source: "iana",
        extensions: ["gxt"]
      },
      "application/vnd.geoplan": {
        source: "iana",
        extensions: ["g2w"]
      },
      "application/vnd.geospace": {
        source: "iana",
        extensions: ["g3w"]
      },
      "application/vnd.gerber": {
        source: "iana"
      },
      "application/vnd.globalplatform.card-content-mgt": {
        source: "iana"
      },
      "application/vnd.globalplatform.card-content-mgt-response": {
        source: "iana"
      },
      "application/vnd.gmx": {
        source: "iana",
        extensions: ["gmx"]
      },
      "application/vnd.google-apps.document": {
        compressible: !1,
        extensions: ["gdoc"]
      },
      "application/vnd.google-apps.presentation": {
        compressible: !1,
        extensions: ["gslides"]
      },
      "application/vnd.google-apps.spreadsheet": {
        compressible: !1,
        extensions: ["gsheet"]
      },
      "application/vnd.google-earth.kml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["kml"]
      },
      "application/vnd.google-earth.kmz": {
        source: "iana",
        compressible: !1,
        extensions: ["kmz"]
      },
      "application/vnd.gov.sk.e-form+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.gov.sk.e-form+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.gov.sk.xmldatacontainer+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.grafeq": {
        source: "iana",
        extensions: ["gqf", "gqs"]
      },
      "application/vnd.gridmp": {
        source: "iana"
      },
      "application/vnd.groove-account": {
        source: "iana",
        extensions: ["gac"]
      },
      "application/vnd.groove-help": {
        source: "iana",
        extensions: ["ghf"]
      },
      "application/vnd.groove-identity-message": {
        source: "iana",
        extensions: ["gim"]
      },
      "application/vnd.groove-injector": {
        source: "iana",
        extensions: ["grv"]
      },
      "application/vnd.groove-tool-message": {
        source: "iana",
        extensions: ["gtm"]
      },
      "application/vnd.groove-tool-template": {
        source: "iana",
        extensions: ["tpl"]
      },
      "application/vnd.groove-vcard": {
        source: "iana",
        extensions: ["vcg"]
      },
      "application/vnd.hal+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.hal+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["hal"]
      },
      "application/vnd.handheld-entertainment+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["zmm"]
      },
      "application/vnd.hbci": {
        source: "iana",
        extensions: ["hbci"]
      },
      "application/vnd.hc+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.hcl-bireports": {
        source: "iana"
      },
      "application/vnd.hdt": {
        source: "iana"
      },
      "application/vnd.heroku+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.hhe.lesson-player": {
        source: "iana",
        extensions: ["les"]
      },
      "application/vnd.hp-hpgl": {
        source: "iana",
        extensions: ["hpgl"]
      },
      "application/vnd.hp-hpid": {
        source: "iana",
        extensions: ["hpid"]
      },
      "application/vnd.hp-hps": {
        source: "iana",
        extensions: ["hps"]
      },
      "application/vnd.hp-jlyt": {
        source: "iana",
        extensions: ["jlt"]
      },
      "application/vnd.hp-pcl": {
        source: "iana",
        extensions: ["pcl"]
      },
      "application/vnd.hp-pclxl": {
        source: "iana",
        extensions: ["pclxl"]
      },
      "application/vnd.httphone": {
        source: "iana"
      },
      "application/vnd.hydrostatix.sof-data": {
        source: "iana",
        extensions: ["sfd-hdstx"]
      },
      "application/vnd.hyper+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.hyper-item+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.hyperdrive+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.hzn-3d-crossword": {
        source: "iana"
      },
      "application/vnd.ibm.afplinedata": {
        source: "iana"
      },
      "application/vnd.ibm.electronic-media": {
        source: "iana"
      },
      "application/vnd.ibm.minipay": {
        source: "iana",
        extensions: ["mpy"]
      },
      "application/vnd.ibm.modcap": {
        source: "iana",
        extensions: ["afp", "listafp", "list3820"]
      },
      "application/vnd.ibm.rights-management": {
        source: "iana",
        extensions: ["irm"]
      },
      "application/vnd.ibm.secure-container": {
        source: "iana",
        extensions: ["sc"]
      },
      "application/vnd.iccprofile": {
        source: "iana",
        extensions: ["icc", "icm"]
      },
      "application/vnd.ieee.1905": {
        source: "iana"
      },
      "application/vnd.igloader": {
        source: "iana",
        extensions: ["igl"]
      },
      "application/vnd.imagemeter.folder+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.imagemeter.image+zip": {
        source: "iana",
        compressible: !1
      },
      "application/vnd.immervision-ivp": {
        source: "iana",
        extensions: ["ivp"]
      },
      "application/vnd.immervision-ivu": {
        source: "iana",
        extensions: ["ivu"]
      },
      "application/vnd.ims.imsccv1p1": {
        source: "iana"
      },
      "application/vnd.ims.imsccv1p2": {
        source: "iana"
      },
      "application/vnd.ims.imsccv1p3": {
        source: "iana"
      },
      "application/vnd.ims.lis.v2.result+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ims.lti.v2.toolconsumerprofile+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ims.lti.v2.toolproxy+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ims.lti.v2.toolproxy.id+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ims.lti.v2.toolsettings+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ims.lti.v2.toolsettings.simple+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.informedcontrol.rms+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.informix-visionary": {
        source: "iana"
      },
      "application/vnd.infotech.project": {
        source: "iana"
      },
      "application/vnd.infotech.project+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.innopath.wamp.notification": {
        source: "iana"
      },
      "application/vnd.insors.igm": {
        source: "iana",
        extensions: ["igm"]
      },
      "application/vnd.intercon.formnet": {
        source: "iana",
        extensions: ["xpw", "xpx"]
      },
      "application/vnd.intergeo": {
        source: "iana",
        extensions: ["i2g"]
      },
      "application/vnd.intertrust.digibox": {
        source: "iana"
      },
      "application/vnd.intertrust.nncp": {
        source: "iana"
      },
      "application/vnd.intu.qbo": {
        source: "iana",
        extensions: ["qbo"]
      },
      "application/vnd.intu.qfx": {
        source: "iana",
        extensions: ["qfx"]
      },
      "application/vnd.iptc.g2.catalogitem+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.iptc.g2.conceptitem+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.iptc.g2.knowledgeitem+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.iptc.g2.newsitem+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.iptc.g2.newsmessage+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.iptc.g2.packageitem+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.iptc.g2.planningitem+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ipunplugged.rcprofile": {
        source: "iana",
        extensions: ["rcprofile"]
      },
      "application/vnd.irepository.package+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["irp"]
      },
      "application/vnd.is-xpr": {
        source: "iana",
        extensions: ["xpr"]
      },
      "application/vnd.isac.fcs": {
        source: "iana",
        extensions: ["fcs"]
      },
      "application/vnd.jam": {
        source: "iana",
        extensions: ["jam"]
      },
      "application/vnd.japannet-directory-service": {
        source: "iana"
      },
      "application/vnd.japannet-jpnstore-wakeup": {
        source: "iana"
      },
      "application/vnd.japannet-payment-wakeup": {
        source: "iana"
      },
      "application/vnd.japannet-registration": {
        source: "iana"
      },
      "application/vnd.japannet-registration-wakeup": {
        source: "iana"
      },
      "application/vnd.japannet-setstore-wakeup": {
        source: "iana"
      },
      "application/vnd.japannet-verification": {
        source: "iana"
      },
      "application/vnd.japannet-verification-wakeup": {
        source: "iana"
      },
      "application/vnd.jcp.javame.midlet-rms": {
        source: "iana",
        extensions: ["rms"]
      },
      "application/vnd.jisp": {
        source: "iana",
        extensions: ["jisp"]
      },
      "application/vnd.joost.joda-archive": {
        source: "iana",
        extensions: ["joda"]
      },
      "application/vnd.jsk.isdn-ngn": {
        source: "iana"
      },
      "application/vnd.kahootz": {
        source: "iana",
        extensions: ["ktz", "ktr"]
      },
      "application/vnd.kde.karbon": {
        source: "iana",
        extensions: ["karbon"]
      },
      "application/vnd.kde.kchart": {
        source: "iana",
        extensions: ["chrt"]
      },
      "application/vnd.kde.kformula": {
        source: "iana",
        extensions: ["kfo"]
      },
      "application/vnd.kde.kivio": {
        source: "iana",
        extensions: ["flw"]
      },
      "application/vnd.kde.kontour": {
        source: "iana",
        extensions: ["kon"]
      },
      "application/vnd.kde.kpresenter": {
        source: "iana",
        extensions: ["kpr", "kpt"]
      },
      "application/vnd.kde.kspread": {
        source: "iana",
        extensions: ["ksp"]
      },
      "application/vnd.kde.kword": {
        source: "iana",
        extensions: ["kwd", "kwt"]
      },
      "application/vnd.kenameaapp": {
        source: "iana",
        extensions: ["htke"]
      },
      "application/vnd.kidspiration": {
        source: "iana",
        extensions: ["kia"]
      },
      "application/vnd.kinar": {
        source: "iana",
        extensions: ["kne", "knp"]
      },
      "application/vnd.koan": {
        source: "iana",
        extensions: ["skp", "skd", "skt", "skm"]
      },
      "application/vnd.kodak-descriptor": {
        source: "iana",
        extensions: ["sse"]
      },
      "application/vnd.las.las+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.las.las+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["lasxml"]
      },
      "application/vnd.leap+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.liberty-request+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.llamagraphics.life-balance.desktop": {
        source: "iana",
        extensions: ["lbd"]
      },
      "application/vnd.llamagraphics.life-balance.exchange+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["lbe"]
      },
      "application/vnd.lotus-1-2-3": {
        source: "iana",
        extensions: ["123"]
      },
      "application/vnd.lotus-approach": {
        source: "iana",
        extensions: ["apr"]
      },
      "application/vnd.lotus-freelance": {
        source: "iana",
        extensions: ["pre"]
      },
      "application/vnd.lotus-notes": {
        source: "iana",
        extensions: ["nsf"]
      },
      "application/vnd.lotus-organizer": {
        source: "iana",
        extensions: ["org"]
      },
      "application/vnd.lotus-screencam": {
        source: "iana",
        extensions: ["scm"]
      },
      "application/vnd.lotus-wordpro": {
        source: "iana",
        extensions: ["lwp"]
      },
      "application/vnd.macports.portpkg": {
        source: "iana",
        extensions: ["portpkg"]
      },
      "application/vnd.mapbox-vector-tile": {
        source: "iana"
      },
      "application/vnd.marlin.drm.actiontoken+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.marlin.drm.conftoken+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.marlin.drm.license+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.marlin.drm.mdcf": {
        source: "iana"
      },
      "application/vnd.mason+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.maxmind.maxmind-db": {
        source: "iana"
      },
      "application/vnd.mcd": {
        source: "iana",
        extensions: ["mcd"]
      },
      "application/vnd.medcalcdata": {
        source: "iana",
        extensions: ["mc1"]
      },
      "application/vnd.mediastation.cdkey": {
        source: "iana",
        extensions: ["cdkey"]
      },
      "application/vnd.meridian-slingshot": {
        source: "iana"
      },
      "application/vnd.mfer": {
        source: "iana",
        extensions: ["mwf"]
      },
      "application/vnd.mfmp": {
        source: "iana",
        extensions: ["mfm"]
      },
      "application/vnd.micro+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.micrografx.flo": {
        source: "iana",
        extensions: ["flo"]
      },
      "application/vnd.micrografx.igx": {
        source: "iana",
        extensions: ["igx"]
      },
      "application/vnd.microsoft.portable-executable": {
        source: "iana"
      },
      "application/vnd.microsoft.windows.thumbnail-cache": {
        source: "iana"
      },
      "application/vnd.miele+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.mif": {
        source: "iana",
        extensions: ["mif"]
      },
      "application/vnd.minisoft-hp3000-save": {
        source: "iana"
      },
      "application/vnd.mitsubishi.misty-guard.trustweb": {
        source: "iana"
      },
      "application/vnd.mobius.daf": {
        source: "iana",
        extensions: ["daf"]
      },
      "application/vnd.mobius.dis": {
        source: "iana",
        extensions: ["dis"]
      },
      "application/vnd.mobius.mbk": {
        source: "iana",
        extensions: ["mbk"]
      },
      "application/vnd.mobius.mqy": {
        source: "iana",
        extensions: ["mqy"]
      },
      "application/vnd.mobius.msl": {
        source: "iana",
        extensions: ["msl"]
      },
      "application/vnd.mobius.plc": {
        source: "iana",
        extensions: ["plc"]
      },
      "application/vnd.mobius.txf": {
        source: "iana",
        extensions: ["txf"]
      },
      "application/vnd.mophun.application": {
        source: "iana",
        extensions: ["mpn"]
      },
      "application/vnd.mophun.certificate": {
        source: "iana",
        extensions: ["mpc"]
      },
      "application/vnd.motorola.flexsuite": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.adsi": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.fis": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.gotap": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.kmr": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.ttc": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.wem": {
        source: "iana"
      },
      "application/vnd.motorola.iprm": {
        source: "iana"
      },
      "application/vnd.mozilla.xul+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xul"]
      },
      "application/vnd.ms-3mfdocument": {
        source: "iana"
      },
      "application/vnd.ms-artgalry": {
        source: "iana",
        extensions: ["cil"]
      },
      "application/vnd.ms-asf": {
        source: "iana"
      },
      "application/vnd.ms-cab-compressed": {
        source: "iana",
        extensions: ["cab"]
      },
      "application/vnd.ms-color.iccprofile": {
        source: "apache"
      },
      "application/vnd.ms-excel": {
        source: "iana",
        compressible: !1,
        extensions: ["xls", "xlm", "xla", "xlc", "xlt", "xlw"]
      },
      "application/vnd.ms-excel.addin.macroenabled.12": {
        source: "iana",
        extensions: ["xlam"]
      },
      "application/vnd.ms-excel.sheet.binary.macroenabled.12": {
        source: "iana",
        extensions: ["xlsb"]
      },
      "application/vnd.ms-excel.sheet.macroenabled.12": {
        source: "iana",
        extensions: ["xlsm"]
      },
      "application/vnd.ms-excel.template.macroenabled.12": {
        source: "iana",
        extensions: ["xltm"]
      },
      "application/vnd.ms-fontobject": {
        source: "iana",
        compressible: !0,
        extensions: ["eot"]
      },
      "application/vnd.ms-htmlhelp": {
        source: "iana",
        extensions: ["chm"]
      },
      "application/vnd.ms-ims": {
        source: "iana",
        extensions: ["ims"]
      },
      "application/vnd.ms-lrm": {
        source: "iana",
        extensions: ["lrm"]
      },
      "application/vnd.ms-office.activex+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ms-officetheme": {
        source: "iana",
        extensions: ["thmx"]
      },
      "application/vnd.ms-opentype": {
        source: "apache",
        compressible: !0
      },
      "application/vnd.ms-outlook": {
        compressible: !1,
        extensions: ["msg"]
      },
      "application/vnd.ms-package.obfuscated-opentype": {
        source: "apache"
      },
      "application/vnd.ms-pki.seccat": {
        source: "apache",
        extensions: ["cat"]
      },
      "application/vnd.ms-pki.stl": {
        source: "apache",
        extensions: ["stl"]
      },
      "application/vnd.ms-playready.initiator+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ms-powerpoint": {
        source: "iana",
        compressible: !1,
        extensions: ["ppt", "pps", "pot"]
      },
      "application/vnd.ms-powerpoint.addin.macroenabled.12": {
        source: "iana",
        extensions: ["ppam"]
      },
      "application/vnd.ms-powerpoint.presentation.macroenabled.12": {
        source: "iana",
        extensions: ["pptm"]
      },
      "application/vnd.ms-powerpoint.slide.macroenabled.12": {
        source: "iana",
        extensions: ["sldm"]
      },
      "application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
        source: "iana",
        extensions: ["ppsm"]
      },
      "application/vnd.ms-powerpoint.template.macroenabled.12": {
        source: "iana",
        extensions: ["potm"]
      },
      "application/vnd.ms-printdevicecapabilities+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ms-printing.printticket+xml": {
        source: "apache",
        compressible: !0
      },
      "application/vnd.ms-printschematicket+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.ms-project": {
        source: "iana",
        extensions: ["mpp", "mpt"]
      },
      "application/vnd.ms-tnef": {
        source: "iana"
      },
      "application/vnd.ms-windows.devicepairing": {
        source: "iana"
      },
      "application/vnd.ms-windows.nwprinting.oob": {
        source: "iana"
      },
      "application/vnd.ms-windows.printerpairing": {
        source: "iana"
      },
      "application/vnd.ms-windows.wsd.oob": {
        source: "iana"
      },
      "application/vnd.ms-wmdrm.lic-chlg-req": {
        source: "iana"
      },
      "application/vnd.ms-wmdrm.lic-resp": {
        source: "iana"
      },
      "application/vnd.ms-wmdrm.meter-chlg-req": {
        source: "iana"
      },
      "application/vnd.ms-wmdrm.meter-resp": {
        source: "iana"
      },
      "application/vnd.ms-word.document.macroenabled.12": {
        source: "iana",
        extensions: ["docm"]
      },
      "application/vnd.ms-word.template.macroenabled.12": {
        source: "iana",
        extensions: ["dotm"]
      },
      "application/vnd.ms-works": {
        source: "iana",
        extensions: ["wps", "wks", "wcm", "wdb"]
      },
      "application/vnd.ms-wpl": {
        source: "iana",
        extensions: ["wpl"]
      },
      "application/vnd.ms-xpsdocument": {
        source: "iana",
        compressible: !1,
        extensions: ["xps"]
      },
      "application/vnd.msa-disk-image": {
        source: "iana"
      },
      "application/vnd.mseq": {
        source: "iana",
        extensions: ["mseq"]
      },
      "application/vnd.msign": {
        source: "iana"
      },
      "application/vnd.multiad.creator": {
        source: "iana"
      },
      "application/vnd.multiad.creator.cif": {
        source: "iana"
      },
      "application/vnd.music-niff": {
        source: "iana"
      },
      "application/vnd.musician": {
        source: "iana",
        extensions: ["mus"]
      },
      "application/vnd.muvee.style": {
        source: "iana",
        extensions: ["msty"]
      },
      "application/vnd.mynfc": {
        source: "iana",
        extensions: ["taglet"]
      },
      "application/vnd.ncd.control": {
        source: "iana"
      },
      "application/vnd.ncd.reference": {
        source: "iana"
      },
      "application/vnd.nearst.inv+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.nervana": {
        source: "iana"
      },
      "application/vnd.netfpx": {
        source: "iana"
      },
      "application/vnd.neurolanguage.nlu": {
        source: "iana",
        extensions: ["nlu"]
      },
      "application/vnd.nimn": {
        source: "iana"
      },
      "application/vnd.nintendo.nitro.rom": {
        source: "iana"
      },
      "application/vnd.nintendo.snes.rom": {
        source: "iana"
      },
      "application/vnd.nitf": {
        source: "iana",
        extensions: ["ntf", "nitf"]
      },
      "application/vnd.noblenet-directory": {
        source: "iana",
        extensions: ["nnd"]
      },
      "application/vnd.noblenet-sealer": {
        source: "iana",
        extensions: ["nns"]
      },
      "application/vnd.noblenet-web": {
        source: "iana",
        extensions: ["nnw"]
      },
      "application/vnd.nokia.catalogs": {
        source: "iana"
      },
      "application/vnd.nokia.conml+wbxml": {
        source: "iana"
      },
      "application/vnd.nokia.conml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.nokia.iptv.config+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.nokia.isds-radio-presets": {
        source: "iana"
      },
      "application/vnd.nokia.landmark+wbxml": {
        source: "iana"
      },
      "application/vnd.nokia.landmark+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.nokia.landmarkcollection+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.nokia.n-gage.ac+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.nokia.n-gage.data": {
        source: "iana",
        extensions: ["ngdat"]
      },
      "application/vnd.nokia.n-gage.symbian.install": {
        source: "iana",
        extensions: ["n-gage"]
      },
      "application/vnd.nokia.ncd": {
        source: "iana"
      },
      "application/vnd.nokia.pcd+wbxml": {
        source: "iana"
      },
      "application/vnd.nokia.pcd+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.nokia.radio-preset": {
        source: "iana",
        extensions: ["rpst"]
      },
      "application/vnd.nokia.radio-presets": {
        source: "iana",
        extensions: ["rpss"]
      },
      "application/vnd.novadigm.edm": {
        source: "iana",
        extensions: ["edm"]
      },
      "application/vnd.novadigm.edx": {
        source: "iana",
        extensions: ["edx"]
      },
      "application/vnd.novadigm.ext": {
        source: "iana",
        extensions: ["ext"]
      },
      "application/vnd.ntt-local.content-share": {
        source: "iana"
      },
      "application/vnd.ntt-local.file-transfer": {
        source: "iana"
      },
      "application/vnd.ntt-local.ogw_remote-access": {
        source: "iana"
      },
      "application/vnd.ntt-local.sip-ta_remote": {
        source: "iana"
      },
      "application/vnd.ntt-local.sip-ta_tcp_stream": {
        source: "iana"
      },
      "application/vnd.oasis.opendocument.chart": {
        source: "iana",
        extensions: ["odc"]
      },
      "application/vnd.oasis.opendocument.chart-template": {
        source: "iana",
        extensions: ["otc"]
      },
      "application/vnd.oasis.opendocument.database": {
        source: "iana",
        extensions: ["odb"]
      },
      "application/vnd.oasis.opendocument.formula": {
        source: "iana",
        extensions: ["odf"]
      },
      "application/vnd.oasis.opendocument.formula-template": {
        source: "iana",
        extensions: ["odft"]
      },
      "application/vnd.oasis.opendocument.graphics": {
        source: "iana",
        compressible: !1,
        extensions: ["odg"]
      },
      "application/vnd.oasis.opendocument.graphics-template": {
        source: "iana",
        extensions: ["otg"]
      },
      "application/vnd.oasis.opendocument.image": {
        source: "iana",
        extensions: ["odi"]
      },
      "application/vnd.oasis.opendocument.image-template": {
        source: "iana",
        extensions: ["oti"]
      },
      "application/vnd.oasis.opendocument.presentation": {
        source: "iana",
        compressible: !1,
        extensions: ["odp"]
      },
      "application/vnd.oasis.opendocument.presentation-template": {
        source: "iana",
        extensions: ["otp"]
      },
      "application/vnd.oasis.opendocument.spreadsheet": {
        source: "iana",
        compressible: !1,
        extensions: ["ods"]
      },
      "application/vnd.oasis.opendocument.spreadsheet-template": {
        source: "iana",
        extensions: ["ots"]
      },
      "application/vnd.oasis.opendocument.text": {
        source: "iana",
        compressible: !1,
        extensions: ["odt"]
      },
      "application/vnd.oasis.opendocument.text-master": {
        source: "iana",
        extensions: ["odm"]
      },
      "application/vnd.oasis.opendocument.text-template": {
        source: "iana",
        extensions: ["ott"]
      },
      "application/vnd.oasis.opendocument.text-web": {
        source: "iana",
        extensions: ["oth"]
      },
      "application/vnd.obn": {
        source: "iana"
      },
      "application/vnd.ocf+cbor": {
        source: "iana"
      },
      "application/vnd.oftn.l10n+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.contentaccessdownload+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.contentaccessstreaming+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.cspg-hexbinary": {
        source: "iana"
      },
      "application/vnd.oipf.dae.svg+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.dae.xhtml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.mippvcontrolmessage+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.pae.gem": {
        source: "iana"
      },
      "application/vnd.oipf.spdiscovery+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.spdlist+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.ueprofile+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oipf.userprofile+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.olpc-sugar": {
        source: "iana",
        extensions: ["xo"]
      },
      "application/vnd.oma-scws-config": {
        source: "iana"
      },
      "application/vnd.oma-scws-http-request": {
        source: "iana"
      },
      "application/vnd.oma-scws-http-response": {
        source: "iana"
      },
      "application/vnd.oma.bcast.associated-procedure-parameter+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.bcast.drm-trigger+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.bcast.imd+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.bcast.ltkm": {
        source: "iana"
      },
      "application/vnd.oma.bcast.notification+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.bcast.provisioningtrigger": {
        source: "iana"
      },
      "application/vnd.oma.bcast.sgboot": {
        source: "iana"
      },
      "application/vnd.oma.bcast.sgdd+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.bcast.sgdu": {
        source: "iana"
      },
      "application/vnd.oma.bcast.simple-symbol-container": {
        source: "iana"
      },
      "application/vnd.oma.bcast.smartcard-trigger+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.bcast.sprov+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.bcast.stkm": {
        source: "iana"
      },
      "application/vnd.oma.cab-address-book+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.cab-feature-handler+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.cab-pcc+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.cab-subs-invite+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.cab-user-prefs+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.dcd": {
        source: "iana"
      },
      "application/vnd.oma.dcdc": {
        source: "iana"
      },
      "application/vnd.oma.dd2+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["dd2"]
      },
      "application/vnd.oma.drm.risd+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.group-usage-list+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.lwm2m+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.lwm2m+tlv": {
        source: "iana"
      },
      "application/vnd.oma.pal+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.poc.detailed-progress-report+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.poc.final-report+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.poc.groups+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.poc.invocation-descriptor+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.poc.optimized-progress-report+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.push": {
        source: "iana"
      },
      "application/vnd.oma.scidm.messages+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oma.xcap-directory+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.omads-email+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.omads-file+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.omads-folder+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.omaloc-supl-init": {
        source: "iana"
      },
      "application/vnd.onepager": {
        source: "iana"
      },
      "application/vnd.onepagertamp": {
        source: "iana"
      },
      "application/vnd.onepagertamx": {
        source: "iana"
      },
      "application/vnd.onepagertat": {
        source: "iana"
      },
      "application/vnd.onepagertatp": {
        source: "iana"
      },
      "application/vnd.onepagertatx": {
        source: "iana"
      },
      "application/vnd.openblox.game+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openblox.game-binary": {
        source: "iana"
      },
      "application/vnd.openeye.oeb": {
        source: "iana"
      },
      "application/vnd.openofficeorg.extension": {
        source: "apache",
        extensions: ["oxt"]
      },
      "application/vnd.openstreetmap.data+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.custom-properties+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.drawing+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.extended-properties+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
        source: "iana",
        compressible: !1,
        extensions: ["pptx"]
      },
      "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slide": {
        source: "iana",
        extensions: ["sldx"]
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
        source: "iana",
        extensions: ["ppsx"]
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.template": {
        source: "iana",
        extensions: ["potx"]
      },
      "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
        source: "iana",
        compressible: !1,
        extensions: ["xlsx"]
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
        source: "iana",
        extensions: ["xltx"]
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.theme+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.themeoverride+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.vmldrawing": {
        source: "iana"
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
        source: "iana",
        compressible: !1,
        extensions: ["docx"]
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
        source: "iana",
        extensions: ["dotx"]
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-package.core-properties+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.openxmlformats-package.relationships+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oracle.resource+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.orange.indata": {
        source: "iana"
      },
      "application/vnd.osa.netdeploy": {
        source: "iana"
      },
      "application/vnd.osgeo.mapguide.package": {
        source: "iana",
        extensions: ["mgp"]
      },
      "application/vnd.osgi.bundle": {
        source: "iana"
      },
      "application/vnd.osgi.dp": {
        source: "iana",
        extensions: ["dp"]
      },
      "application/vnd.osgi.subsystem": {
        source: "iana",
        extensions: ["esa"]
      },
      "application/vnd.otps.ct-kip+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.oxli.countgraph": {
        source: "iana"
      },
      "application/vnd.pagerduty+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.palm": {
        source: "iana",
        extensions: ["pdb", "pqa", "oprc"]
      },
      "application/vnd.panoply": {
        source: "iana"
      },
      "application/vnd.paos.xml": {
        source: "iana"
      },
      "application/vnd.patentdive": {
        source: "iana"
      },
      "application/vnd.pawaafile": {
        source: "iana",
        extensions: ["paw"]
      },
      "application/vnd.pcos": {
        source: "iana"
      },
      "application/vnd.pg.format": {
        source: "iana",
        extensions: ["str"]
      },
      "application/vnd.pg.osasli": {
        source: "iana",
        extensions: ["ei6"]
      },
      "application/vnd.piaccess.application-licence": {
        source: "iana"
      },
      "application/vnd.picsel": {
        source: "iana",
        extensions: ["efif"]
      },
      "application/vnd.pmi.widget": {
        source: "iana",
        extensions: ["wg"]
      },
      "application/vnd.poc.group-advertisement+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.pocketlearn": {
        source: "iana",
        extensions: ["plf"]
      },
      "application/vnd.powerbuilder6": {
        source: "iana",
        extensions: ["pbd"]
      },
      "application/vnd.powerbuilder6-s": {
        source: "iana"
      },
      "application/vnd.powerbuilder7": {
        source: "iana"
      },
      "application/vnd.powerbuilder7-s": {
        source: "iana"
      },
      "application/vnd.powerbuilder75": {
        source: "iana"
      },
      "application/vnd.powerbuilder75-s": {
        source: "iana"
      },
      "application/vnd.preminet": {
        source: "iana"
      },
      "application/vnd.previewsystems.box": {
        source: "iana",
        extensions: ["box"]
      },
      "application/vnd.proteus.magazine": {
        source: "iana",
        extensions: ["mgz"]
      },
      "application/vnd.psfs": {
        source: "iana"
      },
      "application/vnd.publishare-delta-tree": {
        source: "iana",
        extensions: ["qps"]
      },
      "application/vnd.pvi.ptid1": {
        source: "iana",
        extensions: ["ptid"]
      },
      "application/vnd.pwg-multiplexed": {
        source: "iana"
      },
      "application/vnd.pwg-xhtml-print+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.qualcomm.brew-app-res": {
        source: "iana"
      },
      "application/vnd.quarantainenet": {
        source: "iana"
      },
      "application/vnd.quark.quarkxpress": {
        source: "iana",
        extensions: ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"]
      },
      "application/vnd.quobject-quoxdocument": {
        source: "iana"
      },
      "application/vnd.radisys.moml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-audit+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-audit-conf+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-audit-conn+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-audit-dialog+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-audit-stream+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-conf+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-dialog+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-dialog-base+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-dialog-fax-detect+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-dialog-group+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-dialog-speech+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.radisys.msml-dialog-transform+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.rainstor.data": {
        source: "iana"
      },
      "application/vnd.rapid": {
        source: "iana"
      },
      "application/vnd.rar": {
        source: "iana"
      },
      "application/vnd.realvnc.bed": {
        source: "iana",
        extensions: ["bed"]
      },
      "application/vnd.recordare.musicxml": {
        source: "iana",
        extensions: ["mxl"]
      },
      "application/vnd.recordare.musicxml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["musicxml"]
      },
      "application/vnd.renlearn.rlprint": {
        source: "iana"
      },
      "application/vnd.restful+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.rig.cryptonote": {
        source: "iana",
        extensions: ["cryptonote"]
      },
      "application/vnd.rim.cod": {
        source: "apache",
        extensions: ["cod"]
      },
      "application/vnd.rn-realmedia": {
        source: "apache",
        extensions: ["rm"]
      },
      "application/vnd.rn-realmedia-vbr": {
        source: "apache",
        extensions: ["rmvb"]
      },
      "application/vnd.route66.link66+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["link66"]
      },
      "application/vnd.rs-274x": {
        source: "iana"
      },
      "application/vnd.ruckus.download": {
        source: "iana"
      },
      "application/vnd.s3sms": {
        source: "iana"
      },
      "application/vnd.sailingtracker.track": {
        source: "iana",
        extensions: ["st"]
      },
      "application/vnd.sbm.cid": {
        source: "iana"
      },
      "application/vnd.sbm.mid2": {
        source: "iana"
      },
      "application/vnd.scribus": {
        source: "iana"
      },
      "application/vnd.sealed.3df": {
        source: "iana"
      },
      "application/vnd.sealed.csf": {
        source: "iana"
      },
      "application/vnd.sealed.doc": {
        source: "iana"
      },
      "application/vnd.sealed.eml": {
        source: "iana"
      },
      "application/vnd.sealed.mht": {
        source: "iana"
      },
      "application/vnd.sealed.net": {
        source: "iana"
      },
      "application/vnd.sealed.ppt": {
        source: "iana"
      },
      "application/vnd.sealed.tiff": {
        source: "iana"
      },
      "application/vnd.sealed.xls": {
        source: "iana"
      },
      "application/vnd.sealedmedia.softseal.html": {
        source: "iana"
      },
      "application/vnd.sealedmedia.softseal.pdf": {
        source: "iana"
      },
      "application/vnd.seemail": {
        source: "iana",
        extensions: ["see"]
      },
      "application/vnd.sema": {
        source: "iana",
        extensions: ["sema"]
      },
      "application/vnd.semd": {
        source: "iana",
        extensions: ["semd"]
      },
      "application/vnd.semf": {
        source: "iana",
        extensions: ["semf"]
      },
      "application/vnd.shana.informed.formdata": {
        source: "iana",
        extensions: ["ifm"]
      },
      "application/vnd.shana.informed.formtemplate": {
        source: "iana",
        extensions: ["itp"]
      },
      "application/vnd.shana.informed.interchange": {
        source: "iana",
        extensions: ["iif"]
      },
      "application/vnd.shana.informed.package": {
        source: "iana",
        extensions: ["ipk"]
      },
      "application/vnd.shootproof+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.sigrok.session": {
        source: "iana"
      },
      "application/vnd.simtech-mindmapper": {
        source: "iana",
        extensions: ["twd", "twds"]
      },
      "application/vnd.siren+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.smaf": {
        source: "iana",
        extensions: ["mmf"]
      },
      "application/vnd.smart.notebook": {
        source: "iana"
      },
      "application/vnd.smart.teacher": {
        source: "iana",
        extensions: ["teacher"]
      },
      "application/vnd.software602.filler.form+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.software602.filler.form-xml-zip": {
        source: "iana"
      },
      "application/vnd.solent.sdkm+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["sdkm", "sdkd"]
      },
      "application/vnd.spotfire.dxp": {
        source: "iana",
        extensions: ["dxp"]
      },
      "application/vnd.spotfire.sfs": {
        source: "iana",
        extensions: ["sfs"]
      },
      "application/vnd.sqlite3": {
        source: "iana"
      },
      "application/vnd.sss-cod": {
        source: "iana"
      },
      "application/vnd.sss-dtf": {
        source: "iana"
      },
      "application/vnd.sss-ntf": {
        source: "iana"
      },
      "application/vnd.stardivision.calc": {
        source: "apache",
        extensions: ["sdc"]
      },
      "application/vnd.stardivision.draw": {
        source: "apache",
        extensions: ["sda"]
      },
      "application/vnd.stardivision.impress": {
        source: "apache",
        extensions: ["sdd"]
      },
      "application/vnd.stardivision.math": {
        source: "apache",
        extensions: ["smf"]
      },
      "application/vnd.stardivision.writer": {
        source: "apache",
        extensions: ["sdw", "vor"]
      },
      "application/vnd.stardivision.writer-global": {
        source: "apache",
        extensions: ["sgl"]
      },
      "application/vnd.stepmania.package": {
        source: "iana",
        extensions: ["smzip"]
      },
      "application/vnd.stepmania.stepchart": {
        source: "iana",
        extensions: ["sm"]
      },
      "application/vnd.street-stream": {
        source: "iana"
      },
      "application/vnd.sun.wadl+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["wadl"]
      },
      "application/vnd.sun.xml.calc": {
        source: "apache",
        extensions: ["sxc"]
      },
      "application/vnd.sun.xml.calc.template": {
        source: "apache",
        extensions: ["stc"]
      },
      "application/vnd.sun.xml.draw": {
        source: "apache",
        extensions: ["sxd"]
      },
      "application/vnd.sun.xml.draw.template": {
        source: "apache",
        extensions: ["std"]
      },
      "application/vnd.sun.xml.impress": {
        source: "apache",
        extensions: ["sxi"]
      },
      "application/vnd.sun.xml.impress.template": {
        source: "apache",
        extensions: ["sti"]
      },
      "application/vnd.sun.xml.math": {
        source: "apache",
        extensions: ["sxm"]
      },
      "application/vnd.sun.xml.writer": {
        source: "apache",
        extensions: ["sxw"]
      },
      "application/vnd.sun.xml.writer.global": {
        source: "apache",
        extensions: ["sxg"]
      },
      "application/vnd.sun.xml.writer.template": {
        source: "apache",
        extensions: ["stw"]
      },
      "application/vnd.sus-calendar": {
        source: "iana",
        extensions: ["sus", "susp"]
      },
      "application/vnd.svd": {
        source: "iana",
        extensions: ["svd"]
      },
      "application/vnd.swiftview-ics": {
        source: "iana"
      },
      "application/vnd.symbian.install": {
        source: "apache",
        extensions: ["sis", "sisx"]
      },
      "application/vnd.syncml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xsm"]
      },
      "application/vnd.syncml.dm+wbxml": {
        source: "iana",
        extensions: ["bdm"]
      },
      "application/vnd.syncml.dm+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xdm"]
      },
      "application/vnd.syncml.dm.notification": {
        source: "iana"
      },
      "application/vnd.syncml.dmddf+wbxml": {
        source: "iana"
      },
      "application/vnd.syncml.dmddf+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.syncml.dmtnds+wbxml": {
        source: "iana"
      },
      "application/vnd.syncml.dmtnds+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.syncml.ds.notification": {
        source: "iana"
      },
      "application/vnd.tableschema+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.tao.intent-module-archive": {
        source: "iana",
        extensions: ["tao"]
      },
      "application/vnd.tcpdump.pcap": {
        source: "iana",
        extensions: ["pcap", "cap", "dmp"]
      },
      "application/vnd.think-cell.ppttc+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.tmd.mediaflex.api+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.tml": {
        source: "iana"
      },
      "application/vnd.tmobile-livetv": {
        source: "iana",
        extensions: ["tmo"]
      },
      "application/vnd.tri.onesource": {
        source: "iana"
      },
      "application/vnd.trid.tpt": {
        source: "iana",
        extensions: ["tpt"]
      },
      "application/vnd.triscape.mxs": {
        source: "iana",
        extensions: ["mxs"]
      },
      "application/vnd.trueapp": {
        source: "iana",
        extensions: ["tra"]
      },
      "application/vnd.truedoc": {
        source: "iana"
      },
      "application/vnd.ubisoft.webplayer": {
        source: "iana"
      },
      "application/vnd.ufdl": {
        source: "iana",
        extensions: ["ufd", "ufdl"]
      },
      "application/vnd.uiq.theme": {
        source: "iana",
        extensions: ["utz"]
      },
      "application/vnd.umajin": {
        source: "iana",
        extensions: ["umj"]
      },
      "application/vnd.unity": {
        source: "iana",
        extensions: ["unityweb"]
      },
      "application/vnd.uoml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["uoml"]
      },
      "application/vnd.uplanet.alert": {
        source: "iana"
      },
      "application/vnd.uplanet.alert-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.bearer-choice": {
        source: "iana"
      },
      "application/vnd.uplanet.bearer-choice-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.cacheop": {
        source: "iana"
      },
      "application/vnd.uplanet.cacheop-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.channel": {
        source: "iana"
      },
      "application/vnd.uplanet.channel-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.list": {
        source: "iana"
      },
      "application/vnd.uplanet.list-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.listcmd": {
        source: "iana"
      },
      "application/vnd.uplanet.listcmd-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.signal": {
        source: "iana"
      },
      "application/vnd.uri-map": {
        source: "iana"
      },
      "application/vnd.valve.source.material": {
        source: "iana"
      },
      "application/vnd.vcx": {
        source: "iana",
        extensions: ["vcx"]
      },
      "application/vnd.vd-study": {
        source: "iana"
      },
      "application/vnd.vectorworks": {
        source: "iana"
      },
      "application/vnd.vel+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.verimatrix.vcas": {
        source: "iana"
      },
      "application/vnd.vidsoft.vidconference": {
        source: "iana"
      },
      "application/vnd.visio": {
        source: "iana",
        extensions: ["vsd", "vst", "vss", "vsw"]
      },
      "application/vnd.visionary": {
        source: "iana",
        extensions: ["vis"]
      },
      "application/vnd.vividence.scriptfile": {
        source: "iana"
      },
      "application/vnd.vsf": {
        source: "iana",
        extensions: ["vsf"]
      },
      "application/vnd.wap.sic": {
        source: "iana"
      },
      "application/vnd.wap.slc": {
        source: "iana"
      },
      "application/vnd.wap.wbxml": {
        source: "iana",
        extensions: ["wbxml"]
      },
      "application/vnd.wap.wmlc": {
        source: "iana",
        extensions: ["wmlc"]
      },
      "application/vnd.wap.wmlscriptc": {
        source: "iana",
        extensions: ["wmlsc"]
      },
      "application/vnd.webturbo": {
        source: "iana",
        extensions: ["wtb"]
      },
      "application/vnd.wfa.p2p": {
        source: "iana"
      },
      "application/vnd.wfa.wsc": {
        source: "iana"
      },
      "application/vnd.windows.devicepairing": {
        source: "iana"
      },
      "application/vnd.wmc": {
        source: "iana"
      },
      "application/vnd.wmf.bootstrap": {
        source: "iana"
      },
      "application/vnd.wolfram.mathematica": {
        source: "iana"
      },
      "application/vnd.wolfram.mathematica.package": {
        source: "iana"
      },
      "application/vnd.wolfram.player": {
        source: "iana",
        extensions: ["nbp"]
      },
      "application/vnd.wordperfect": {
        source: "iana",
        extensions: ["wpd"]
      },
      "application/vnd.wqd": {
        source: "iana",
        extensions: ["wqd"]
      },
      "application/vnd.wrq-hp3000-labelled": {
        source: "iana"
      },
      "application/vnd.wt.stf": {
        source: "iana",
        extensions: ["stf"]
      },
      "application/vnd.wv.csp+wbxml": {
        source: "iana"
      },
      "application/vnd.wv.csp+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.wv.ssp+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.xacml+json": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.xara": {
        source: "iana",
        extensions: ["xar"]
      },
      "application/vnd.xfdl": {
        source: "iana",
        extensions: ["xfdl"]
      },
      "application/vnd.xfdl.webform": {
        source: "iana"
      },
      "application/vnd.xmi+xml": {
        source: "iana",
        compressible: !0
      },
      "application/vnd.xmpie.cpkg": {
        source: "iana"
      },
      "application/vnd.xmpie.dpkg": {
        source: "iana"
      },
      "application/vnd.xmpie.plan": {
        source: "iana"
      },
      "application/vnd.xmpie.ppkg": {
        source: "iana"
      },
      "application/vnd.xmpie.xlim": {
        source: "iana"
      },
      "application/vnd.yamaha.hv-dic": {
        source: "iana",
        extensions: ["hvd"]
      },
      "application/vnd.yamaha.hv-script": {
        source: "iana",
        extensions: ["hvs"]
      },
      "application/vnd.yamaha.hv-voice": {
        source: "iana",
        extensions: ["hvp"]
      },
      "application/vnd.yamaha.openscoreformat": {
        source: "iana",
        extensions: ["osf"]
      },
      "application/vnd.yamaha.openscoreformat.osfpvg+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["osfpvg"]
      },
      "application/vnd.yamaha.remote-setup": {
        source: "iana"
      },
      "application/vnd.yamaha.smaf-audio": {
        source: "iana",
        extensions: ["saf"]
      },
      "application/vnd.yamaha.smaf-phrase": {
        source: "iana",
        extensions: ["spf"]
      },
      "application/vnd.yamaha.through-ngn": {
        source: "iana"
      },
      "application/vnd.yamaha.tunnel-udpencap": {
        source: "iana"
      },
      "application/vnd.yaoweme": {
        source: "iana"
      },
      "application/vnd.yellowriver-custom-menu": {
        source: "iana",
        extensions: ["cmp"]
      },
      "application/vnd.youtube.yt": {
        source: "iana"
      },
      "application/vnd.zul": {
        source: "iana",
        extensions: ["zir", "zirz"]
      },
      "application/vnd.zzazz.deck+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["zaz"]
      },
      "application/voicexml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["vxml"]
      },
      "application/voucher-cms+json": {
        source: "iana",
        compressible: !0
      },
      "application/vq-rtcpxr": {
        source: "iana"
      },
      "application/wasm": {
        compressible: !0,
        extensions: ["wasm"]
      },
      "application/watcherinfo+xml": {
        source: "iana",
        compressible: !0
      },
      "application/webpush-options+json": {
        source: "iana",
        compressible: !0
      },
      "application/whoispp-query": {
        source: "iana"
      },
      "application/whoispp-response": {
        source: "iana"
      },
      "application/widget": {
        source: "iana",
        extensions: ["wgt"]
      },
      "application/winhlp": {
        source: "apache",
        extensions: ["hlp"]
      },
      "application/wita": {
        source: "iana"
      },
      "application/wordperfect5.1": {
        source: "iana"
      },
      "application/wsdl+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["wsdl"]
      },
      "application/wspolicy+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["wspolicy"]
      },
      "application/x-7z-compressed": {
        source: "apache",
        compressible: !1,
        extensions: ["7z"]
      },
      "application/x-abiword": {
        source: "apache",
        extensions: ["abw"]
      },
      "application/x-ace-compressed": {
        source: "apache",
        extensions: ["ace"]
      },
      "application/x-amf": {
        source: "apache"
      },
      "application/x-apple-diskimage": {
        source: "apache",
        extensions: ["dmg"]
      },
      "application/x-arj": {
        compressible: !1,
        extensions: ["arj"]
      },
      "application/x-authorware-bin": {
        source: "apache",
        extensions: ["aab", "x32", "u32", "vox"]
      },
      "application/x-authorware-map": {
        source: "apache",
        extensions: ["aam"]
      },
      "application/x-authorware-seg": {
        source: "apache",
        extensions: ["aas"]
      },
      "application/x-bcpio": {
        source: "apache",
        extensions: ["bcpio"]
      },
      "application/x-bdoc": {
        compressible: !1,
        extensions: ["bdoc"]
      },
      "application/x-bittorrent": {
        source: "apache",
        extensions: ["torrent"]
      },
      "application/x-blorb": {
        source: "apache",
        extensions: ["blb", "blorb"]
      },
      "application/x-bzip": {
        source: "apache",
        compressible: !1,
        extensions: ["bz"]
      },
      "application/x-bzip2": {
        source: "apache",
        compressible: !1,
        extensions: ["bz2", "boz"]
      },
      "application/x-cbr": {
        source: "apache",
        extensions: ["cbr", "cba", "cbt", "cbz", "cb7"]
      },
      "application/x-cdlink": {
        source: "apache",
        extensions: ["vcd"]
      },
      "application/x-cfs-compressed": {
        source: "apache",
        extensions: ["cfs"]
      },
      "application/x-chat": {
        source: "apache",
        extensions: ["chat"]
      },
      "application/x-chess-pgn": {
        source: "apache",
        extensions: ["pgn"]
      },
      "application/x-chrome-extension": {
        extensions: ["crx"]
      },
      "application/x-cocoa": {
        source: "nginx",
        extensions: ["cco"]
      },
      "application/x-compress": {
        source: "apache"
      },
      "application/x-conference": {
        source: "apache",
        extensions: ["nsc"]
      },
      "application/x-cpio": {
        source: "apache",
        extensions: ["cpio"]
      },
      "application/x-csh": {
        source: "apache",
        extensions: ["csh"]
      },
      "application/x-deb": {
        compressible: !1
      },
      "application/x-debian-package": {
        source: "apache",
        extensions: ["deb", "udeb"]
      },
      "application/x-dgc-compressed": {
        source: "apache",
        extensions: ["dgc"]
      },
      "application/x-director": {
        source: "apache",
        extensions: ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"]
      },
      "application/x-doom": {
        source: "apache",
        extensions: ["wad"]
      },
      "application/x-dtbncx+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["ncx"]
      },
      "application/x-dtbook+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["dtb"]
      },
      "application/x-dtbresource+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["res"]
      },
      "application/x-dvi": {
        source: "apache",
        compressible: !1,
        extensions: ["dvi"]
      },
      "application/x-envoy": {
        source: "apache",
        extensions: ["evy"]
      },
      "application/x-eva": {
        source: "apache",
        extensions: ["eva"]
      },
      "application/x-font-bdf": {
        source: "apache",
        extensions: ["bdf"]
      },
      "application/x-font-dos": {
        source: "apache"
      },
      "application/x-font-framemaker": {
        source: "apache"
      },
      "application/x-font-ghostscript": {
        source: "apache",
        extensions: ["gsf"]
      },
      "application/x-font-libgrx": {
        source: "apache"
      },
      "application/x-font-linux-psf": {
        source: "apache",
        extensions: ["psf"]
      },
      "application/x-font-pcf": {
        source: "apache",
        extensions: ["pcf"]
      },
      "application/x-font-snf": {
        source: "apache",
        extensions: ["snf"]
      },
      "application/x-font-speedo": {
        source: "apache"
      },
      "application/x-font-sunos-news": {
        source: "apache"
      },
      "application/x-font-type1": {
        source: "apache",
        extensions: ["pfa", "pfb", "pfm", "afm"]
      },
      "application/x-font-vfont": {
        source: "apache"
      },
      "application/x-freearc": {
        source: "apache",
        extensions: ["arc"]
      },
      "application/x-futuresplash": {
        source: "apache",
        extensions: ["spl"]
      },
      "application/x-gca-compressed": {
        source: "apache",
        extensions: ["gca"]
      },
      "application/x-glulx": {
        source: "apache",
        extensions: ["ulx"]
      },
      "application/x-gnumeric": {
        source: "apache",
        extensions: ["gnumeric"]
      },
      "application/x-gramps-xml": {
        source: "apache",
        extensions: ["gramps"]
      },
      "application/x-gtar": {
        source: "apache",
        extensions: ["gtar"]
      },
      "application/x-gzip": {
        source: "apache"
      },
      "application/x-hdf": {
        source: "apache",
        extensions: ["hdf"]
      },
      "application/x-httpd-php": {
        compressible: !0,
        extensions: ["php"]
      },
      "application/x-install-instructions": {
        source: "apache",
        extensions: ["install"]
      },
      "application/x-iso9660-image": {
        source: "apache",
        extensions: ["iso"]
      },
      "application/x-java-archive-diff": {
        source: "nginx",
        extensions: ["jardiff"]
      },
      "application/x-java-jnlp-file": {
        source: "apache",
        compressible: !1,
        extensions: ["jnlp"]
      },
      "application/x-javascript": {
        compressible: !0
      },
      "application/x-latex": {
        source: "apache",
        compressible: !1,
        extensions: ["latex"]
      },
      "application/x-lua-bytecode": {
        extensions: ["luac"]
      },
      "application/x-lzh-compressed": {
        source: "apache",
        extensions: ["lzh", "lha"]
      },
      "application/x-makeself": {
        source: "nginx",
        extensions: ["run"]
      },
      "application/x-mie": {
        source: "apache",
        extensions: ["mie"]
      },
      "application/x-mobipocket-ebook": {
        source: "apache",
        extensions: ["prc", "mobi"]
      },
      "application/x-mpegurl": {
        compressible: !1
      },
      "application/x-ms-application": {
        source: "apache",
        extensions: ["application"]
      },
      "application/x-ms-shortcut": {
        source: "apache",
        extensions: ["lnk"]
      },
      "application/x-ms-wmd": {
        source: "apache",
        extensions: ["wmd"]
      },
      "application/x-ms-wmz": {
        source: "apache",
        extensions: ["wmz"]
      },
      "application/x-ms-xbap": {
        source: "apache",
        extensions: ["xbap"]
      },
      "application/x-msaccess": {
        source: "apache",
        extensions: ["mdb"]
      },
      "application/x-msbinder": {
        source: "apache",
        extensions: ["obd"]
      },
      "application/x-mscardfile": {
        source: "apache",
        extensions: ["crd"]
      },
      "application/x-msclip": {
        source: "apache",
        extensions: ["clp"]
      },
      "application/x-msdos-program": {
        extensions: ["exe"]
      },
      "application/x-msdownload": {
        source: "apache",
        extensions: ["exe", "dll", "com", "bat", "msi"]
      },
      "application/x-msmediaview": {
        source: "apache",
        extensions: ["mvb", "m13", "m14"]
      },
      "application/x-msmetafile": {
        source: "apache",
        extensions: ["wmf", "wmz", "emf", "emz"]
      },
      "application/x-msmoney": {
        source: "apache",
        extensions: ["mny"]
      },
      "application/x-mspublisher": {
        source: "apache",
        extensions: ["pub"]
      },
      "application/x-msschedule": {
        source: "apache",
        extensions: ["scd"]
      },
      "application/x-msterminal": {
        source: "apache",
        extensions: ["trm"]
      },
      "application/x-mswrite": {
        source: "apache",
        extensions: ["wri"]
      },
      "application/x-netcdf": {
        source: "apache",
        extensions: ["nc", "cdf"]
      },
      "application/x-ns-proxy-autoconfig": {
        compressible: !0,
        extensions: ["pac"]
      },
      "application/x-nzb": {
        source: "apache",
        extensions: ["nzb"]
      },
      "application/x-perl": {
        source: "nginx",
        extensions: ["pl", "pm"]
      },
      "application/x-pilot": {
        source: "nginx",
        extensions: ["prc", "pdb"]
      },
      "application/x-pkcs12": {
        source: "apache",
        compressible: !1,
        extensions: ["p12", "pfx"]
      },
      "application/x-pkcs7-certificates": {
        source: "apache",
        extensions: ["p7b", "spc"]
      },
      "application/x-pkcs7-certreqresp": {
        source: "apache",
        extensions: ["p7r"]
      },
      "application/x-rar-compressed": {
        source: "apache",
        compressible: !1,
        extensions: ["rar"]
      },
      "application/x-redhat-package-manager": {
        source: "nginx",
        extensions: ["rpm"]
      },
      "application/x-research-info-systems": {
        source: "apache",
        extensions: ["ris"]
      },
      "application/x-sea": {
        source: "nginx",
        extensions: ["sea"]
      },
      "application/x-sh": {
        source: "apache",
        compressible: !0,
        extensions: ["sh"]
      },
      "application/x-shar": {
        source: "apache",
        extensions: ["shar"]
      },
      "application/x-shockwave-flash": {
        source: "apache",
        compressible: !1,
        extensions: ["swf"]
      },
      "application/x-silverlight-app": {
        source: "apache",
        extensions: ["xap"]
      },
      "application/x-sql": {
        source: "apache",
        extensions: ["sql"]
      },
      "application/x-stuffit": {
        source: "apache",
        compressible: !1,
        extensions: ["sit"]
      },
      "application/x-stuffitx": {
        source: "apache",
        extensions: ["sitx"]
      },
      "application/x-subrip": {
        source: "apache",
        extensions: ["srt"]
      },
      "application/x-sv4cpio": {
        source: "apache",
        extensions: ["sv4cpio"]
      },
      "application/x-sv4crc": {
        source: "apache",
        extensions: ["sv4crc"]
      },
      "application/x-t3vm-image": {
        source: "apache",
        extensions: ["t3"]
      },
      "application/x-tads": {
        source: "apache",
        extensions: ["gam"]
      },
      "application/x-tar": {
        source: "apache",
        compressible: !0,
        extensions: ["tar"]
      },
      "application/x-tcl": {
        source: "apache",
        extensions: ["tcl", "tk"]
      },
      "application/x-tex": {
        source: "apache",
        extensions: ["tex"]
      },
      "application/x-tex-tfm": {
        source: "apache",
        extensions: ["tfm"]
      },
      "application/x-texinfo": {
        source: "apache",
        extensions: ["texinfo", "texi"]
      },
      "application/x-tgif": {
        source: "apache",
        extensions: ["obj"]
      },
      "application/x-ustar": {
        source: "apache",
        extensions: ["ustar"]
      },
      "application/x-virtualbox-hdd": {
        compressible: !0,
        extensions: ["hdd"]
      },
      "application/x-virtualbox-ova": {
        compressible: !0,
        extensions: ["ova"]
      },
      "application/x-virtualbox-ovf": {
        compressible: !0,
        extensions: ["ovf"]
      },
      "application/x-virtualbox-vbox": {
        compressible: !0,
        extensions: ["vbox"]
      },
      "application/x-virtualbox-vbox-extpack": {
        compressible: !1,
        extensions: ["vbox-extpack"]
      },
      "application/x-virtualbox-vdi": {
        compressible: !0,
        extensions: ["vdi"]
      },
      "application/x-virtualbox-vhd": {
        compressible: !0,
        extensions: ["vhd"]
      },
      "application/x-virtualbox-vmdk": {
        compressible: !0,
        extensions: ["vmdk"]
      },
      "application/x-wais-source": {
        source: "apache",
        extensions: ["src"]
      },
      "application/x-web-app-manifest+json": {
        compressible: !0,
        extensions: ["webapp"]
      },
      "application/x-www-form-urlencoded": {
        source: "iana",
        compressible: !0
      },
      "application/x-x509-ca-cert": {
        source: "apache",
        extensions: ["der", "crt", "pem"]
      },
      "application/x-xfig": {
        source: "apache",
        extensions: ["fig"]
      },
      "application/x-xliff+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["xlf"]
      },
      "application/x-xpinstall": {
        source: "apache",
        compressible: !1,
        extensions: ["xpi"]
      },
      "application/x-xz": {
        source: "apache",
        extensions: ["xz"]
      },
      "application/x-zmachine": {
        source: "apache",
        extensions: ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"]
      },
      "application/x400-bp": {
        source: "iana"
      },
      "application/xacml+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xaml+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["xaml"]
      },
      "application/xcap-att+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xcap-caps+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xcap-diff+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xdf"]
      },
      "application/xcap-el+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xcap-error+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xcap-ns+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xcon-conference-info+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xcon-conference-info-diff+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xenc+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xenc"]
      },
      "application/xhtml+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xhtml", "xht"]
      },
      "application/xhtml-voice+xml": {
        source: "apache",
        compressible: !0
      },
      "application/xliff+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xml", "xsl", "xsd", "rng"]
      },
      "application/xml-dtd": {
        source: "iana",
        compressible: !0,
        extensions: ["dtd"]
      },
      "application/xml-external-parsed-entity": {
        source: "iana"
      },
      "application/xml-patch+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xmpp+xml": {
        source: "iana",
        compressible: !0
      },
      "application/xop+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xop"]
      },
      "application/xproc+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["xpl"]
      },
      "application/xslt+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xslt"]
      },
      "application/xspf+xml": {
        source: "apache",
        compressible: !0,
        extensions: ["xspf"]
      },
      "application/xv+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["mxml", "xhvml", "xvml", "xvm"]
      },
      "application/yang": {
        source: "iana",
        extensions: ["yang"]
      },
      "application/yang-data+json": {
        source: "iana",
        compressible: !0
      },
      "application/yang-data+xml": {
        source: "iana",
        compressible: !0
      },
      "application/yang-patch+json": {
        source: "iana",
        compressible: !0
      },
      "application/yang-patch+xml": {
        source: "iana",
        compressible: !0
      },
      "application/yin+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["yin"]
      },
      "application/zip": {
        source: "iana",
        compressible: !1,
        extensions: ["zip"]
      },
      "application/zlib": {
        source: "iana"
      },
      "application/zstd": {
        source: "iana"
      },
      "audio/1d-interleaved-parityfec": {
        source: "iana"
      },
      "audio/32kadpcm": {
        source: "iana"
      },
      "audio/3gpp": {
        source: "iana",
        compressible: !1,
        extensions: ["3gpp"]
      },
      "audio/3gpp2": {
        source: "iana"
      },
      "audio/aac": {
        source: "iana"
      },
      "audio/ac3": {
        source: "iana"
      },
      "audio/adpcm": {
        source: "apache",
        extensions: ["adp"]
      },
      "audio/amr": {
        source: "iana"
      },
      "audio/amr-wb": {
        source: "iana"
      },
      "audio/amr-wb+": {
        source: "iana"
      },
      "audio/aptx": {
        source: "iana"
      },
      "audio/asc": {
        source: "iana"
      },
      "audio/atrac-advanced-lossless": {
        source: "iana"
      },
      "audio/atrac-x": {
        source: "iana"
      },
      "audio/atrac3": {
        source: "iana"
      },
      "audio/basic": {
        source: "iana",
        compressible: !1,
        extensions: ["au", "snd"]
      },
      "audio/bv16": {
        source: "iana"
      },
      "audio/bv32": {
        source: "iana"
      },
      "audio/clearmode": {
        source: "iana"
      },
      "audio/cn": {
        source: "iana"
      },
      "audio/dat12": {
        source: "iana"
      },
      "audio/dls": {
        source: "iana"
      },
      "audio/dsr-es201108": {
        source: "iana"
      },
      "audio/dsr-es202050": {
        source: "iana"
      },
      "audio/dsr-es202211": {
        source: "iana"
      },
      "audio/dsr-es202212": {
        source: "iana"
      },
      "audio/dv": {
        source: "iana"
      },
      "audio/dvi4": {
        source: "iana"
      },
      "audio/eac3": {
        source: "iana"
      },
      "audio/encaprtp": {
        source: "iana"
      },
      "audio/evrc": {
        source: "iana"
      },
      "audio/evrc-qcp": {
        source: "iana"
      },
      "audio/evrc0": {
        source: "iana"
      },
      "audio/evrc1": {
        source: "iana"
      },
      "audio/evrcb": {
        source: "iana"
      },
      "audio/evrcb0": {
        source: "iana"
      },
      "audio/evrcb1": {
        source: "iana"
      },
      "audio/evrcnw": {
        source: "iana"
      },
      "audio/evrcnw0": {
        source: "iana"
      },
      "audio/evrcnw1": {
        source: "iana"
      },
      "audio/evrcwb": {
        source: "iana"
      },
      "audio/evrcwb0": {
        source: "iana"
      },
      "audio/evrcwb1": {
        source: "iana"
      },
      "audio/evs": {
        source: "iana"
      },
      "audio/fwdred": {
        source: "iana"
      },
      "audio/g711-0": {
        source: "iana"
      },
      "audio/g719": {
        source: "iana"
      },
      "audio/g722": {
        source: "iana"
      },
      "audio/g7221": {
        source: "iana"
      },
      "audio/g723": {
        source: "iana"
      },
      "audio/g726-16": {
        source: "iana"
      },
      "audio/g726-24": {
        source: "iana"
      },
      "audio/g726-32": {
        source: "iana"
      },
      "audio/g726-40": {
        source: "iana"
      },
      "audio/g728": {
        source: "iana"
      },
      "audio/g729": {
        source: "iana"
      },
      "audio/g7291": {
        source: "iana"
      },
      "audio/g729d": {
        source: "iana"
      },
      "audio/g729e": {
        source: "iana"
      },
      "audio/gsm": {
        source: "iana"
      },
      "audio/gsm-efr": {
        source: "iana"
      },
      "audio/gsm-hr-08": {
        source: "iana"
      },
      "audio/ilbc": {
        source: "iana"
      },
      "audio/ip-mr_v2.5": {
        source: "iana"
      },
      "audio/isac": {
        source: "apache"
      },
      "audio/l16": {
        source: "iana"
      },
      "audio/l20": {
        source: "iana"
      },
      "audio/l24": {
        source: "iana",
        compressible: !1
      },
      "audio/l8": {
        source: "iana"
      },
      "audio/lpc": {
        source: "iana"
      },
      "audio/melp": {
        source: "iana"
      },
      "audio/melp1200": {
        source: "iana"
      },
      "audio/melp2400": {
        source: "iana"
      },
      "audio/melp600": {
        source: "iana"
      },
      "audio/midi": {
        source: "apache",
        extensions: ["mid", "midi", "kar", "rmi"]
      },
      "audio/mobile-xmf": {
        source: "iana"
      },
      "audio/mp3": {
        compressible: !1,
        extensions: ["mp3"]
      },
      "audio/mp4": {
        source: "iana",
        compressible: !1,
        extensions: ["m4a", "mp4a"]
      },
      "audio/mp4a-latm": {
        source: "iana"
      },
      "audio/mpa": {
        source: "iana"
      },
      "audio/mpa-robust": {
        source: "iana"
      },
      "audio/mpeg": {
        source: "iana",
        compressible: !1,
        extensions: ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"]
      },
      "audio/mpeg4-generic": {
        source: "iana"
      },
      "audio/musepack": {
        source: "apache"
      },
      "audio/ogg": {
        source: "iana",
        compressible: !1,
        extensions: ["oga", "ogg", "spx"]
      },
      "audio/opus": {
        source: "iana"
      },
      "audio/parityfec": {
        source: "iana"
      },
      "audio/pcma": {
        source: "iana"
      },
      "audio/pcma-wb": {
        source: "iana"
      },
      "audio/pcmu": {
        source: "iana"
      },
      "audio/pcmu-wb": {
        source: "iana"
      },
      "audio/prs.sid": {
        source: "iana"
      },
      "audio/qcelp": {
        source: "iana"
      },
      "audio/raptorfec": {
        source: "iana"
      },
      "audio/red": {
        source: "iana"
      },
      "audio/rtp-enc-aescm128": {
        source: "iana"
      },
      "audio/rtp-midi": {
        source: "iana"
      },
      "audio/rtploopback": {
        source: "iana"
      },
      "audio/rtx": {
        source: "iana"
      },
      "audio/s3m": {
        source: "apache",
        extensions: ["s3m"]
      },
      "audio/silk": {
        source: "apache",
        extensions: ["sil"]
      },
      "audio/smv": {
        source: "iana"
      },
      "audio/smv-qcp": {
        source: "iana"
      },
      "audio/smv0": {
        source: "iana"
      },
      "audio/sp-midi": {
        source: "iana"
      },
      "audio/speex": {
        source: "iana"
      },
      "audio/t140c": {
        source: "iana"
      },
      "audio/t38": {
        source: "iana"
      },
      "audio/telephone-event": {
        source: "iana"
      },
      "audio/tone": {
        source: "iana"
      },
      "audio/uemclip": {
        source: "iana"
      },
      "audio/ulpfec": {
        source: "iana"
      },
      "audio/usac": {
        source: "iana"
      },
      "audio/vdvi": {
        source: "iana"
      },
      "audio/vmr-wb": {
        source: "iana"
      },
      "audio/vnd.3gpp.iufp": {
        source: "iana"
      },
      "audio/vnd.4sb": {
        source: "iana"
      },
      "audio/vnd.audiokoz": {
        source: "iana"
      },
      "audio/vnd.celp": {
        source: "iana"
      },
      "audio/vnd.cisco.nse": {
        source: "iana"
      },
      "audio/vnd.cmles.radio-events": {
        source: "iana"
      },
      "audio/vnd.cns.anp1": {
        source: "iana"
      },
      "audio/vnd.cns.inf1": {
        source: "iana"
      },
      "audio/vnd.dece.audio": {
        source: "iana",
        extensions: ["uva", "uvva"]
      },
      "audio/vnd.digital-winds": {
        source: "iana",
        extensions: ["eol"]
      },
      "audio/vnd.dlna.adts": {
        source: "iana"
      },
      "audio/vnd.dolby.heaac.1": {
        source: "iana"
      },
      "audio/vnd.dolby.heaac.2": {
        source: "iana"
      },
      "audio/vnd.dolby.mlp": {
        source: "iana"
      },
      "audio/vnd.dolby.mps": {
        source: "iana"
      },
      "audio/vnd.dolby.pl2": {
        source: "iana"
      },
      "audio/vnd.dolby.pl2x": {
        source: "iana"
      },
      "audio/vnd.dolby.pl2z": {
        source: "iana"
      },
      "audio/vnd.dolby.pulse.1": {
        source: "iana"
      },
      "audio/vnd.dra": {
        source: "iana",
        extensions: ["dra"]
      },
      "audio/vnd.dts": {
        source: "iana",
        extensions: ["dts"]
      },
      "audio/vnd.dts.hd": {
        source: "iana",
        extensions: ["dtshd"]
      },
      "audio/vnd.dvb.file": {
        source: "iana"
      },
      "audio/vnd.everad.plj": {
        source: "iana"
      },
      "audio/vnd.hns.audio": {
        source: "iana"
      },
      "audio/vnd.lucent.voice": {
        source: "iana",
        extensions: ["lvp"]
      },
      "audio/vnd.ms-playready.media.pya": {
        source: "iana",
        extensions: ["pya"]
      },
      "audio/vnd.nokia.mobile-xmf": {
        source: "iana"
      },
      "audio/vnd.nortel.vbk": {
        source: "iana"
      },
      "audio/vnd.nuera.ecelp4800": {
        source: "iana",
        extensions: ["ecelp4800"]
      },
      "audio/vnd.nuera.ecelp7470": {
        source: "iana",
        extensions: ["ecelp7470"]
      },
      "audio/vnd.nuera.ecelp9600": {
        source: "iana",
        extensions: ["ecelp9600"]
      },
      "audio/vnd.octel.sbc": {
        source: "iana"
      },
      "audio/vnd.presonus.multitrack": {
        source: "iana"
      },
      "audio/vnd.qcelp": {
        source: "iana"
      },
      "audio/vnd.rhetorex.32kadpcm": {
        source: "iana"
      },
      "audio/vnd.rip": {
        source: "iana",
        extensions: ["rip"]
      },
      "audio/vnd.rn-realaudio": {
        compressible: !1
      },
      "audio/vnd.sealedmedia.softseal.mpeg": {
        source: "iana"
      },
      "audio/vnd.vmx.cvsd": {
        source: "iana"
      },
      "audio/vnd.wave": {
        compressible: !1
      },
      "audio/vorbis": {
        source: "iana",
        compressible: !1
      },
      "audio/vorbis-config": {
        source: "iana"
      },
      "audio/wav": {
        compressible: !1,
        extensions: ["wav"]
      },
      "audio/wave": {
        compressible: !1,
        extensions: ["wav"]
      },
      "audio/webm": {
        source: "apache",
        compressible: !1,
        extensions: ["weba"]
      },
      "audio/x-aac": {
        source: "apache",
        compressible: !1,
        extensions: ["aac"]
      },
      "audio/x-aiff": {
        source: "apache",
        extensions: ["aif", "aiff", "aifc"]
      },
      "audio/x-caf": {
        source: "apache",
        compressible: !1,
        extensions: ["caf"]
      },
      "audio/x-flac": {
        source: "apache",
        extensions: ["flac"]
      },
      "audio/x-m4a": {
        source: "nginx",
        extensions: ["m4a"]
      },
      "audio/x-matroska": {
        source: "apache",
        extensions: ["mka"]
      },
      "audio/x-mpegurl": {
        source: "apache",
        extensions: ["m3u"]
      },
      "audio/x-ms-wax": {
        source: "apache",
        extensions: ["wax"]
      },
      "audio/x-ms-wma": {
        source: "apache",
        extensions: ["wma"]
      },
      "audio/x-pn-realaudio": {
        source: "apache",
        extensions: ["ram", "ra"]
      },
      "audio/x-pn-realaudio-plugin": {
        source: "apache",
        extensions: ["rmp"]
      },
      "audio/x-realaudio": {
        source: "nginx",
        extensions: ["ra"]
      },
      "audio/x-tta": {
        source: "apache"
      },
      "audio/x-wav": {
        source: "apache",
        extensions: ["wav"]
      },
      "audio/xm": {
        source: "apache",
        extensions: ["xm"]
      },
      "chemical/x-cdx": {
        source: "apache",
        extensions: ["cdx"]
      },
      "chemical/x-cif": {
        source: "apache",
        extensions: ["cif"]
      },
      "chemical/x-cmdf": {
        source: "apache",
        extensions: ["cmdf"]
      },
      "chemical/x-cml": {
        source: "apache",
        extensions: ["cml"]
      },
      "chemical/x-csml": {
        source: "apache",
        extensions: ["csml"]
      },
      "chemical/x-pdb": {
        source: "apache"
      },
      "chemical/x-xyz": {
        source: "apache",
        extensions: ["xyz"]
      },
      "font/collection": {
        source: "iana",
        extensions: ["ttc"]
      },
      "font/otf": {
        source: "iana",
        compressible: !0,
        extensions: ["otf"]
      },
      "font/sfnt": {
        source: "iana"
      },
      "font/ttf": {
        source: "iana",
        extensions: ["ttf"]
      },
      "font/woff": {
        source: "iana",
        extensions: ["woff"]
      },
      "font/woff2": {
        source: "iana",
        extensions: ["woff2"]
      },
      "image/aces": {
        source: "iana",
        extensions: ["exr"]
      },
      "image/apng": {
        compressible: !1,
        extensions: ["apng"]
      },
      "image/avci": {
        source: "iana"
      },
      "image/avcs": {
        source: "iana"
      },
      "image/bmp": {
        source: "iana",
        compressible: !0,
        extensions: ["bmp"]
      },
      "image/cgm": {
        source: "iana",
        extensions: ["cgm"]
      },
      "image/dicom-rle": {
        source: "iana",
        extensions: ["drle"]
      },
      "image/emf": {
        source: "iana",
        extensions: ["emf"]
      },
      "image/fits": {
        source: "iana",
        extensions: ["fits"]
      },
      "image/g3fax": {
        source: "iana",
        extensions: ["g3"]
      },
      "image/gif": {
        source: "iana",
        compressible: !1,
        extensions: ["gif"]
      },
      "image/heic": {
        source: "iana",
        extensions: ["heic"]
      },
      "image/heic-sequence": {
        source: "iana",
        extensions: ["heics"]
      },
      "image/heif": {
        source: "iana",
        extensions: ["heif"]
      },
      "image/heif-sequence": {
        source: "iana",
        extensions: ["heifs"]
      },
      "image/ief": {
        source: "iana",
        extensions: ["ief"]
      },
      "image/jls": {
        source: "iana",
        extensions: ["jls"]
      },
      "image/jp2": {
        source: "iana",
        compressible: !1,
        extensions: ["jp2", "jpg2"]
      },
      "image/jpeg": {
        source: "iana",
        compressible: !1,
        extensions: ["jpeg", "jpg", "jpe"]
      },
      "image/jpm": {
        source: "iana",
        compressible: !1,
        extensions: ["jpm"]
      },
      "image/jpx": {
        source: "iana",
        compressible: !1,
        extensions: ["jpx", "jpf"]
      },
      "image/ktx": {
        source: "iana",
        extensions: ["ktx"]
      },
      "image/naplps": {
        source: "iana"
      },
      "image/pjpeg": {
        compressible: !1
      },
      "image/png": {
        source: "iana",
        compressible: !1,
        extensions: ["png"]
      },
      "image/prs.btif": {
        source: "iana",
        extensions: ["btif"]
      },
      "image/prs.pti": {
        source: "iana",
        extensions: ["pti"]
      },
      "image/pwg-raster": {
        source: "iana"
      },
      "image/sgi": {
        source: "apache",
        extensions: ["sgi"]
      },
      "image/svg+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["svg", "svgz"]
      },
      "image/t38": {
        source: "iana",
        extensions: ["t38"]
      },
      "image/tiff": {
        source: "iana",
        compressible: !1,
        extensions: ["tif", "tiff"]
      },
      "image/tiff-fx": {
        source: "iana",
        extensions: ["tfx"]
      },
      "image/vnd.adobe.photoshop": {
        source: "iana",
        compressible: !0,
        extensions: ["psd"]
      },
      "image/vnd.airzip.accelerator.azv": {
        source: "iana",
        extensions: ["azv"]
      },
      "image/vnd.cns.inf2": {
        source: "iana"
      },
      "image/vnd.dece.graphic": {
        source: "iana",
        extensions: ["uvi", "uvvi", "uvg", "uvvg"]
      },
      "image/vnd.djvu": {
        source: "iana",
        extensions: ["djvu", "djv"]
      },
      "image/vnd.dvb.subtitle": {
        source: "iana",
        extensions: ["sub"]
      },
      "image/vnd.dwg": {
        source: "iana",
        extensions: ["dwg"]
      },
      "image/vnd.dxf": {
        source: "iana",
        extensions: ["dxf"]
      },
      "image/vnd.fastbidsheet": {
        source: "iana",
        extensions: ["fbs"]
      },
      "image/vnd.fpx": {
        source: "iana",
        extensions: ["fpx"]
      },
      "image/vnd.fst": {
        source: "iana",
        extensions: ["fst"]
      },
      "image/vnd.fujixerox.edmics-mmr": {
        source: "iana",
        extensions: ["mmr"]
      },
      "image/vnd.fujixerox.edmics-rlc": {
        source: "iana",
        extensions: ["rlc"]
      },
      "image/vnd.globalgraphics.pgb": {
        source: "iana"
      },
      "image/vnd.microsoft.icon": {
        source: "iana",
        extensions: ["ico"]
      },
      "image/vnd.mix": {
        source: "iana"
      },
      "image/vnd.mozilla.apng": {
        source: "iana"
      },
      "image/vnd.ms-modi": {
        source: "iana",
        extensions: ["mdi"]
      },
      "image/vnd.ms-photo": {
        source: "apache",
        extensions: ["wdp"]
      },
      "image/vnd.net-fpx": {
        source: "iana",
        extensions: ["npx"]
      },
      "image/vnd.radiance": {
        source: "iana"
      },
      "image/vnd.sealed.png": {
        source: "iana"
      },
      "image/vnd.sealedmedia.softseal.gif": {
        source: "iana"
      },
      "image/vnd.sealedmedia.softseal.jpg": {
        source: "iana"
      },
      "image/vnd.svf": {
        source: "iana"
      },
      "image/vnd.tencent.tap": {
        source: "iana",
        extensions: ["tap"]
      },
      "image/vnd.valve.source.texture": {
        source: "iana",
        extensions: ["vtf"]
      },
      "image/vnd.wap.wbmp": {
        source: "iana",
        extensions: ["wbmp"]
      },
      "image/vnd.xiff": {
        source: "iana",
        extensions: ["xif"]
      },
      "image/vnd.zbrush.pcx": {
        source: "iana",
        extensions: ["pcx"]
      },
      "image/webp": {
        source: "apache",
        extensions: ["webp"]
      },
      "image/wmf": {
        source: "iana",
        extensions: ["wmf"]
      },
      "image/x-3ds": {
        source: "apache",
        extensions: ["3ds"]
      },
      "image/x-cmu-raster": {
        source: "apache",
        extensions: ["ras"]
      },
      "image/x-cmx": {
        source: "apache",
        extensions: ["cmx"]
      },
      "image/x-freehand": {
        source: "apache",
        extensions: ["fh", "fhc", "fh4", "fh5", "fh7"]
      },
      "image/x-icon": {
        source: "apache",
        compressible: !0,
        extensions: ["ico"]
      },
      "image/x-jng": {
        source: "nginx",
        extensions: ["jng"]
      },
      "image/x-mrsid-image": {
        source: "apache",
        extensions: ["sid"]
      },
      "image/x-ms-bmp": {
        source: "nginx",
        compressible: !0,
        extensions: ["bmp"]
      },
      "image/x-pcx": {
        source: "apache",
        extensions: ["pcx"]
      },
      "image/x-pict": {
        source: "apache",
        extensions: ["pic", "pct"]
      },
      "image/x-portable-anymap": {
        source: "apache",
        extensions: ["pnm"]
      },
      "image/x-portable-bitmap": {
        source: "apache",
        extensions: ["pbm"]
      },
      "image/x-portable-graymap": {
        source: "apache",
        extensions: ["pgm"]
      },
      "image/x-portable-pixmap": {
        source: "apache",
        extensions: ["ppm"]
      },
      "image/x-rgb": {
        source: "apache",
        extensions: ["rgb"]
      },
      "image/x-tga": {
        source: "apache",
        extensions: ["tga"]
      },
      "image/x-xbitmap": {
        source: "apache",
        extensions: ["xbm"]
      },
      "image/x-xcf": {
        compressible: !1
      },
      "image/x-xpixmap": {
        source: "apache",
        extensions: ["xpm"]
      },
      "image/x-xwindowdump": {
        source: "apache",
        extensions: ["xwd"]
      },
      "message/cpim": {
        source: "iana"
      },
      "message/delivery-status": {
        source: "iana"
      },
      "message/disposition-notification": {
        source: "iana",
        extensions: ["disposition-notification"]
      },
      "message/external-body": {
        source: "iana"
      },
      "message/feedback-report": {
        source: "iana"
      },
      "message/global": {
        source: "iana",
        extensions: ["u8msg"]
      },
      "message/global-delivery-status": {
        source: "iana",
        extensions: ["u8dsn"]
      },
      "message/global-disposition-notification": {
        source: "iana",
        extensions: ["u8mdn"]
      },
      "message/global-headers": {
        source: "iana",
        extensions: ["u8hdr"]
      },
      "message/http": {
        source: "iana",
        compressible: !1
      },
      "message/imdn+xml": {
        source: "iana",
        compressible: !0
      },
      "message/news": {
        source: "iana"
      },
      "message/partial": {
        source: "iana",
        compressible: !1
      },
      "message/rfc822": {
        source: "iana",
        compressible: !0,
        extensions: ["eml", "mime"]
      },
      "message/s-http": {
        source: "iana"
      },
      "message/sip": {
        source: "iana"
      },
      "message/sipfrag": {
        source: "iana"
      },
      "message/tracking-status": {
        source: "iana"
      },
      "message/vnd.si.simp": {
        source: "iana"
      },
      "message/vnd.wfa.wsc": {
        source: "iana",
        extensions: ["wsc"]
      },
      "model/3mf": {
        source: "iana"
      },
      "model/gltf+json": {
        source: "iana",
        compressible: !0,
        extensions: ["gltf"]
      },
      "model/gltf-binary": {
        source: "iana",
        compressible: !0,
        extensions: ["glb"]
      },
      "model/iges": {
        source: "iana",
        compressible: !1,
        extensions: ["igs", "iges"]
      },
      "model/mesh": {
        source: "iana",
        compressible: !1,
        extensions: ["msh", "mesh", "silo"]
      },
      "model/stl": {
        source: "iana"
      },
      "model/vnd.collada+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["dae"]
      },
      "model/vnd.dwf": {
        source: "iana",
        extensions: ["dwf"]
      },
      "model/vnd.flatland.3dml": {
        source: "iana"
      },
      "model/vnd.gdl": {
        source: "iana",
        extensions: ["gdl"]
      },
      "model/vnd.gs-gdl": {
        source: "apache"
      },
      "model/vnd.gs.gdl": {
        source: "iana"
      },
      "model/vnd.gtw": {
        source: "iana",
        extensions: ["gtw"]
      },
      "model/vnd.moml+xml": {
        source: "iana",
        compressible: !0
      },
      "model/vnd.mts": {
        source: "iana",
        extensions: ["mts"]
      },
      "model/vnd.opengex": {
        source: "iana"
      },
      "model/vnd.parasolid.transmit.binary": {
        source: "iana"
      },
      "model/vnd.parasolid.transmit.text": {
        source: "iana"
      },
      "model/vnd.rosette.annotated-data-model": {
        source: "iana"
      },
      "model/vnd.usdz+zip": {
        source: "iana",
        compressible: !1
      },
      "model/vnd.valve.source.compiled-map": {
        source: "iana"
      },
      "model/vnd.vtu": {
        source: "iana",
        extensions: ["vtu"]
      },
      "model/vrml": {
        source: "iana",
        compressible: !1,
        extensions: ["wrl", "vrml"]
      },
      "model/x3d+binary": {
        source: "apache",
        compressible: !1,
        extensions: ["x3db", "x3dbz"]
      },
      "model/x3d+fastinfoset": {
        source: "iana"
      },
      "model/x3d+vrml": {
        source: "apache",
        compressible: !1,
        extensions: ["x3dv", "x3dvz"]
      },
      "model/x3d+xml": {
        source: "iana",
        compressible: !0,
        extensions: ["x3d", "x3dz"]
      },
      "model/x3d-vrml": {
        source: "iana"
      },
      "multipart/alternative": {
        source: "iana",
        compressible: !1
      },
      "multipart/appledouble": {
        source: "iana"
      },
      "multipart/byteranges": {
        source: "iana"
      },
      "multipart/digest": {
        source: "iana"
      },
      "multipart/encrypted": {
        source: "iana",
        compressible: !1
      },
      "multipart/form-data": {
        source: "iana",
        compressible: !1
      },
      "multipart/header-set": {
        source: "iana"
      },
      "multipart/mixed": {
        source: "iana",
        compressible: !1
      },
      "multipart/multilingual": {
        source: "iana"
      },
      "multipart/parallel": {
        source: "iana"
      },
      "multipart/related": {
        source: "iana",
        compressible: !1
      },
      "multipart/report": {
        source: "iana"
      },
      "multipart/signed": {
        source: "iana",
        compressible: !1
      },
      "multipart/vnd.bint.med-plus": {
        source: "iana"
      },
      "multipart/voice-message": {
        source: "iana"
      },
      "multipart/x-mixed-replace": {
        source: "iana"
      },
      "text/1d-interleaved-parityfec": {
        source: "iana"
      },
      "text/cache-manifest": {
        source: "iana",
        compressible: !0,
        extensions: ["appcache", "manifest"]
      },
      "text/calendar": {
        source: "iana",
        extensions: ["ics", "ifb"]
      },
      "text/calender": {
        compressible: !0
      },
      "text/cmd": {
        compressible: !0
      },
      "text/coffeescript": {
        extensions: ["coffee", "litcoffee"]
      },
      "text/css": {
        source: "iana",
        charset: "UTF-8",
        compressible: !0,
        extensions: ["css"]
      },
      "text/csv": {
        source: "iana",
        compressible: !0,
        extensions: ["csv"]
      },
      "text/csv-schema": {
        source: "iana"
      },
      "text/directory": {
        source: "iana"
      },
      "text/dns": {
        source: "iana"
      },
      "text/ecmascript": {
        source: "iana"
      },
      "text/encaprtp": {
        source: "iana"
      },
      "text/enriched": {
        source: "iana"
      },
      "text/fwdred": {
        source: "iana"
      },
      "text/grammar-ref-list": {
        source: "iana"
      },
      "text/html": {
        source: "iana",
        compressible: !0,
        extensions: ["html", "htm", "shtml"]
      },
      "text/jade": {
        extensions: ["jade"]
      },
      "text/javascript": {
        source: "iana",
        compressible: !0
      },
      "text/jcr-cnd": {
        source: "iana"
      },
      "text/jsx": {
        compressible: !0,
        extensions: ["jsx"]
      },
      "text/less": {
        extensions: ["less"]
      },
      "text/markdown": {
        source: "iana",
        compressible: !0,
        extensions: ["markdown", "md"]
      },
      "text/mathml": {
        source: "nginx",
        extensions: ["mml"]
      },
      "text/mizar": {
        source: "iana"
      },
      "text/n3": {
        source: "iana",
        compressible: !0,
        extensions: ["n3"]
      },
      "text/parameters": {
        source: "iana"
      },
      "text/parityfec": {
        source: "iana"
      },
      "text/plain": {
        source: "iana",
        compressible: !0,
        extensions: ["txt", "text", "conf", "def", "list", "log", "in", "ini"]
      },
      "text/provenance-notation": {
        source: "iana"
      },
      "text/prs.fallenstein.rst": {
        source: "iana"
      },
      "text/prs.lines.tag": {
        source: "iana",
        extensions: ["dsc"]
      },
      "text/prs.prop.logic": {
        source: "iana"
      },
      "text/raptorfec": {
        source: "iana"
      },
      "text/red": {
        source: "iana"
      },
      "text/rfc822-headers": {
        source: "iana"
      },
      "text/richtext": {
        source: "iana",
        compressible: !0,
        extensions: ["rtx"]
      },
      "text/rtf": {
        source: "iana",
        compressible: !0,
        extensions: ["rtf"]
      },
      "text/rtp-enc-aescm128": {
        source: "iana"
      },
      "text/rtploopback": {
        source: "iana"
      },
      "text/rtx": {
        source: "iana"
      },
      "text/sgml": {
        source: "iana",
        extensions: ["sgml", "sgm"]
      },
      "text/shex": {
        extensions: ["shex"]
      },
      "text/slim": {
        extensions: ["slim", "slm"]
      },
      "text/strings": {
        source: "iana"
      },
      "text/stylus": {
        extensions: ["stylus", "styl"]
      },
      "text/t140": {
        source: "iana"
      },
      "text/tab-separated-values": {
        source: "iana",
        compressible: !0,
        extensions: ["tsv"]
      },
      "text/troff": {
        source: "iana",
        extensions: ["t", "tr", "roff", "man", "me", "ms"]
      },
      "text/turtle": {
        source: "iana",
        charset: "UTF-8",
        extensions: ["ttl"]
      },
      "text/ulpfec": {
        source: "iana"
      },
      "text/uri-list": {
        source: "iana",
        compressible: !0,
        extensions: ["uri", "uris", "urls"]
      },
      "text/vcard": {
        source: "iana",
        compressible: !0,
        extensions: ["vcard"]
      },
      "text/vnd.a": {
        source: "iana"
      },
      "text/vnd.abc": {
        source: "iana"
      },
      "text/vnd.ascii-art": {
        source: "iana"
      },
      "text/vnd.curl": {
        source: "iana",
        extensions: ["curl"]
      },
      "text/vnd.curl.dcurl": {
        source: "apache",
        extensions: ["dcurl"]
      },
      "text/vnd.curl.mcurl": {
        source: "apache",
        extensions: ["mcurl"]
      },
      "text/vnd.curl.scurl": {
        source: "apache",
        extensions: ["scurl"]
      },
      "text/vnd.debian.copyright": {
        source: "iana"
      },
      "text/vnd.dmclientscript": {
        source: "iana"
      },
      "text/vnd.dvb.subtitle": {
        source: "iana",
        extensions: ["sub"]
      },
      "text/vnd.esmertec.theme-descriptor": {
        source: "iana"
      },
      "text/vnd.fly": {
        source: "iana",
        extensions: ["fly"]
      },
      "text/vnd.fmi.flexstor": {
        source: "iana",
        extensions: ["flx"]
      },
      "text/vnd.gml": {
        source: "iana"
      },
      "text/vnd.graphviz": {
        source: "iana",
        extensions: ["gv"]
      },
      "text/vnd.hgl": {
        source: "iana"
      },
      "text/vnd.in3d.3dml": {
        source: "iana",
        extensions: ["3dml"]
      },
      "text/vnd.in3d.spot": {
        source: "iana",
        extensions: ["spot"]
      },
      "text/vnd.iptc.newsml": {
        source: "iana"
      },
      "text/vnd.iptc.nitf": {
        source: "iana"
      },
      "text/vnd.latex-z": {
        source: "iana"
      },
      "text/vnd.motorola.reflex": {
        source: "iana"
      },
      "text/vnd.ms-mediapackage": {
        source: "iana"
      },
      "text/vnd.net2phone.commcenter.command": {
        source: "iana"
      },
      "text/vnd.radisys.msml-basic-layout": {
        source: "iana"
      },
      "text/vnd.si.uricatalogue": {
        source: "iana"
      },
      "text/vnd.sun.j2me.app-descriptor": {
        source: "iana",
        extensions: ["jad"]
      },
      "text/vnd.trolltech.linguist": {
        source: "iana"
      },
      "text/vnd.wap.si": {
        source: "iana"
      },
      "text/vnd.wap.sl": {
        source: "iana"
      },
      "text/vnd.wap.wml": {
        source: "iana",
        extensions: ["wml"]
      },
      "text/vnd.wap.wmlscript": {
        source: "iana",
        extensions: ["wmls"]
      },
      "text/vtt": {
        charset: "UTF-8",
        compressible: !0,
        extensions: ["vtt"]
      },
      "text/x-asm": {
        source: "apache",
        extensions: ["s", "asm"]
      },
      "text/x-c": {
        source: "apache",
        extensions: ["c", "cc", "cxx", "cpp", "h", "hh", "dic"]
      },
      "text/x-component": {
        source: "nginx",
        extensions: ["htc"]
      },
      "text/x-fortran": {
        source: "apache",
        extensions: ["f", "for", "f77", "f90"]
      },
      "text/x-gwt-rpc": {
        compressible: !0
      },
      "text/x-handlebars-template": {
        extensions: ["hbs"]
      },
      "text/x-java-source": {
        source: "apache",
        extensions: ["java"]
      },
      "text/x-jquery-tmpl": {
        compressible: !0
      },
      "text/x-lua": {
        extensions: ["lua"]
      },
      "text/x-markdown": {
        compressible: !0,
        extensions: ["mkd"]
      },
      "text/x-nfo": {
        source: "apache",
        extensions: ["nfo"]
      },
      "text/x-opml": {
        source: "apache",
        extensions: ["opml"]
      },
      "text/x-org": {
        compressible: !0,
        extensions: ["org"]
      },
      "text/x-pascal": {
        source: "apache",
        extensions: ["p", "pas"]
      },
      "text/x-processing": {
        compressible: !0,
        extensions: ["pde"]
      },
      "text/x-sass": {
        extensions: ["sass"]
      },
      "text/x-scss": {
        extensions: ["scss"]
      },
      "text/x-setext": {
        source: "apache",
        extensions: ["etx"]
      },
      "text/x-sfv": {
        source: "apache",
        extensions: ["sfv"]
      },
      "text/x-suse-ymp": {
        compressible: !0,
        extensions: ["ymp"]
      },
      "text/x-uuencode": {
        source: "apache",
        extensions: ["uu"]
      },
      "text/x-vcalendar": {
        source: "apache",
        extensions: ["vcs"]
      },
      "text/x-vcard": {
        source: "apache",
        extensions: ["vcf"]
      },
      "text/xml": {
        source: "iana",
        compressible: !0,
        extensions: ["xml"]
      },
      "text/xml-external-parsed-entity": {
        source: "iana"
      },
      "text/yaml": {
        extensions: ["yaml", "yml"]
      },
      "video/1d-interleaved-parityfec": {
        source: "iana"
      },
      "video/3gpp": {
        source: "iana",
        extensions: ["3gp", "3gpp"]
      },
      "video/3gpp-tt": {
        source: "iana"
      },
      "video/3gpp2": {
        source: "iana",
        extensions: ["3g2"]
      },
      "video/bmpeg": {
        source: "iana"
      },
      "video/bt656": {
        source: "iana"
      },
      "video/celb": {
        source: "iana"
      },
      "video/dv": {
        source: "iana"
      },
      "video/encaprtp": {
        source: "iana"
      },
      "video/h261": {
        source: "iana",
        extensions: ["h261"]
      },
      "video/h263": {
        source: "iana",
        extensions: ["h263"]
      },
      "video/h263-1998": {
        source: "iana"
      },
      "video/h263-2000": {
        source: "iana"
      },
      "video/h264": {
        source: "iana",
        extensions: ["h264"]
      },
      "video/h264-rcdo": {
        source: "iana"
      },
      "video/h264-svc": {
        source: "iana"
      },
      "video/h265": {
        source: "iana"
      },
      "video/iso.segment": {
        source: "iana"
      },
      "video/jpeg": {
        source: "iana",
        extensions: ["jpgv"]
      },
      "video/jpeg2000": {
        source: "iana"
      },
      "video/jpm": {
        source: "apache",
        extensions: ["jpm", "jpgm"]
      },
      "video/mj2": {
        source: "iana",
        extensions: ["mj2", "mjp2"]
      },
      "video/mp1s": {
        source: "iana"
      },
      "video/mp2p": {
        source: "iana"
      },
      "video/mp2t": {
        source: "iana",
        extensions: ["ts"]
      },
      "video/mp4": {
        source: "iana",
        compressible: !1,
        extensions: ["mp4", "mp4v", "mpg4"]
      },
      "video/mp4v-es": {
        source: "iana"
      },
      "video/mpeg": {
        source: "iana",
        compressible: !1,
        extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"]
      },
      "video/mpeg4-generic": {
        source: "iana"
      },
      "video/mpv": {
        source: "iana"
      },
      "video/nv": {
        source: "iana"
      },
      "video/ogg": {
        source: "iana",
        compressible: !1,
        extensions: ["ogv"]
      },
      "video/parityfec": {
        source: "iana"
      },
      "video/pointer": {
        source: "iana"
      },
      "video/quicktime": {
        source: "iana",
        compressible: !1,
        extensions: ["qt", "mov"]
      },
      "video/raptorfec": {
        source: "iana"
      },
      "video/raw": {
        source: "iana"
      },
      "video/rtp-enc-aescm128": {
        source: "iana"
      },
      "video/rtploopback": {
        source: "iana"
      },
      "video/rtx": {
        source: "iana"
      },
      "video/smpte291": {
        source: "iana"
      },
      "video/smpte292m": {
        source: "iana"
      },
      "video/ulpfec": {
        source: "iana"
      },
      "video/vc1": {
        source: "iana"
      },
      "video/vc2": {
        source: "iana"
      },
      "video/vnd.cctv": {
        source: "iana"
      },
      "video/vnd.dece.hd": {
        source: "iana",
        extensions: ["uvh", "uvvh"]
      },
      "video/vnd.dece.mobile": {
        source: "iana",
        extensions: ["uvm", "uvvm"]
      },
      "video/vnd.dece.mp4": {
        source: "iana"
      },
      "video/vnd.dece.pd": {
        source: "iana",
        extensions: ["uvp", "uvvp"]
      },
      "video/vnd.dece.sd": {
        source: "iana",
        extensions: ["uvs", "uvvs"]
      },
      "video/vnd.dece.video": {
        source: "iana",
        extensions: ["uvv", "uvvv"]
      },
      "video/vnd.directv.mpeg": {
        source: "iana"
      },
      "video/vnd.directv.mpeg-tts": {
        source: "iana"
      },
      "video/vnd.dlna.mpeg-tts": {
        source: "iana"
      },
      "video/vnd.dvb.file": {
        source: "iana",
        extensions: ["dvb"]
      },
      "video/vnd.fvt": {
        source: "iana",
        extensions: ["fvt"]
      },
      "video/vnd.hns.video": {
        source: "iana"
      },
      "video/vnd.iptvforum.1dparityfec-1010": {
        source: "iana"
      },
      "video/vnd.iptvforum.1dparityfec-2005": {
        source: "iana"
      },
      "video/vnd.iptvforum.2dparityfec-1010": {
        source: "iana"
      },
      "video/vnd.iptvforum.2dparityfec-2005": {
        source: "iana"
      },
      "video/vnd.iptvforum.ttsavc": {
        source: "iana"
      },
      "video/vnd.iptvforum.ttsmpeg2": {
        source: "iana"
      },
      "video/vnd.motorola.video": {
        source: "iana"
      },
      "video/vnd.motorola.videop": {
        source: "iana"
      },
      "video/vnd.mpegurl": {
        source: "iana",
        extensions: ["mxu", "m4u"]
      },
      "video/vnd.ms-playready.media.pyv": {
        source: "iana",
        extensions: ["pyv"]
      },
      "video/vnd.nokia.interleaved-multimedia": {
        source: "iana"
      },
      "video/vnd.nokia.mp4vr": {
        source: "iana"
      },
      "video/vnd.nokia.videovoip": {
        source: "iana"
      },
      "video/vnd.objectvideo": {
        source: "iana"
      },
      "video/vnd.radgamettools.bink": {
        source: "iana"
      },
      "video/vnd.radgamettools.smacker": {
        source: "iana"
      },
      "video/vnd.sealed.mpeg1": {
        source: "iana"
      },
      "video/vnd.sealed.mpeg4": {
        source: "iana"
      },
      "video/vnd.sealed.swf": {
        source: "iana"
      },
      "video/vnd.sealedmedia.softseal.mov": {
        source: "iana"
      },
      "video/vnd.uvvu.mp4": {
        source: "iana",
        extensions: ["uvu", "uvvu"]
      },
      "video/vnd.vivo": {
        source: "iana",
        extensions: ["viv"]
      },
      "video/vp8": {
        source: "iana"
      },
      "video/webm": {
        source: "apache",
        compressible: !1,
        extensions: ["webm"]
      },
      "video/x-f4v": {
        source: "apache",
        extensions: ["f4v"]
      },
      "video/x-fli": {
        source: "apache",
        extensions: ["fli"]
      },
      "video/x-flv": {
        source: "apache",
        compressible: !1,
        extensions: ["flv"]
      },
      "video/x-m4v": {
        source: "apache",
        extensions: ["m4v"]
      },
      "video/x-matroska": {
        source: "apache",
        compressible: !1,
        extensions: ["mkv", "mk3d", "mks"]
      },
      "video/x-mng": {
        source: "apache",
        extensions: ["mng"]
      },
      "video/x-ms-asf": {
        source: "apache",
        extensions: ["asf", "asx"]
      },
      "video/x-ms-vob": {
        source: "apache",
        extensions: ["vob"]
      },
      "video/x-ms-wm": {
        source: "apache",
        extensions: ["wm"]
      },
      "video/x-ms-wmv": {
        source: "apache",
        compressible: !1,
        extensions: ["wmv"]
      },
      "video/x-ms-wmx": {
        source: "apache",
        extensions: ["wmx"]
      },
      "video/x-ms-wvx": {
        source: "apache",
        extensions: ["wvx"]
      },
      "video/x-msvideo": {
        source: "apache",
        extensions: ["avi"]
      },
      "video/x-sgi-movie": {
        source: "apache",
        extensions: ["movie"]
      },
      "video/x-smv": {
        source: "apache",
        extensions: ["smv"]
      },
      "x-conference/x-cooltalk": {
        source: "apache",
        extensions: ["ice"]
      },
      "x-shader/x-fragment": {
        compressible: !0
      },
      "x-shader/x-vertex": {
        compressible: !0
      }
    };
  }, function (e, n, a) {
    (function (e) {
      function a(e, n) {
        for (var a = 0, t = e.length - 1; t >= 0; t--) {
          var i = e[t];
          "." === i ? e.splice(t, 1) : ".." === i ? (e.splice(t, 1), a++) : a && (e.splice(t, 1), a--);
        }

        if (n) for (; a--; a) {
          e.unshift("..");
        }
        return e;
      }

      var t = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,
          i = function i(e) {
        return t.exec(e).slice(1);
      };

      function o(e, n) {
        if (e.filter) return e.filter(n);

        for (var a = [], t = 0; t < e.length; t++) {
          n(e[t], t, e) && a.push(e[t]);
        }

        return a;
      }

      n.resolve = function () {
        for (var n = "", t = !1, i = arguments.length - 1; i >= -1 && !t; i--) {
          var s = i >= 0 ? arguments[i] : e.cwd();
          if ("string" !== typeof s) throw new TypeError("Arguments to path.resolve must be strings");
          s && (n = s + "/" + n, t = "/" === s.charAt(0));
        }

        return (t ? "/" : "") + (n = a(o(n.split("/"), function (e) {
          return !!e;
        }), !t).join("/")) || ".";
      }, n.normalize = function (e) {
        var t = n.isAbsolute(e),
            i = "/" === s(e, -1);
        return (e = a(o(e.split("/"), function (e) {
          return !!e;
        }), !t).join("/")) || t || (e = "."), e && i && (e += "/"), (t ? "/" : "") + e;
      }, n.isAbsolute = function (e) {
        return "/" === e.charAt(0);
      }, n.join = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return n.normalize(o(e, function (e, n) {
          if ("string" !== typeof e) throw new TypeError("Arguments to path.join must be strings");
          return e;
        }).join("/"));
      }, n.relative = function (e, a) {
        function t(e) {
          for (var n = 0; n < e.length && "" === e[n]; n++) {
            ;
          }

          for (var a = e.length - 1; a >= 0 && "" === e[a]; a--) {
            ;
          }

          return n > a ? [] : e.slice(n, a - n + 1);
        }

        e = n.resolve(e).substr(1), a = n.resolve(a).substr(1);

        for (var i = t(e.split("/")), o = t(a.split("/")), s = Math.min(i.length, o.length), r = s, c = 0; c < s; c++) {
          if (i[c] !== o[c]) {
            r = c;
            break;
          }
        }

        var p = [];

        for (c = r; c < i.length; c++) {
          p.push("..");
        }

        return (p = p.concat(o.slice(r))).join("/");
      }, n.sep = "/", n.delimiter = ":", n.dirname = function (e) {
        var n = i(e),
            a = n[0],
            t = n[1];
        return a || t ? (t && (t = t.substr(0, t.length - 1)), a + t) : ".";
      }, n.basename = function (e, n) {
        var a = i(e)[2];
        return n && a.substr(-1 * n.length) === n && (a = a.substr(0, a.length - n.length)), a;
      }, n.extname = function (e) {
        return i(e)[3];
      };
      var s = "b" === "ab".substr(-1) ? function (e, n, a) {
        return e.substr(n, a);
      } : function (e, n, a) {
        return n < 0 && (n = e.length + n), e.substr(n, a);
      };
    }).call(this, a(49));
  }, function (e, n, a) {
    "use strict";

    a.r(n);
    var t = a(6);

    function i(e, n) {
      if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, n) {
      for (var a = 0; a < n.length; a++) {
        var t = n[a];
        t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }

    function s(e, n, a) {
      return n && o(e.prototype, n), a && o(e, a), e;
    }

    function r(e) {
      return (r = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function c(e) {
      return (c = "function" === typeof Symbol && "symbol" === r(Symbol.iterator) ? function (e) {
        return r(e);
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : r(e);
      })(e);
    }

    function p(e, n) {
      return !n || "object" !== c(n) && "function" !== typeof n ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : n;
    }

    function u(e) {
      return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function l(e, n) {
      return (l = Object.setPrototypeOf || function (e, n) {
        return e.__proto__ = n, e;
      })(e, n);
    }

    function d(e, n) {
      if ("function" !== typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && l(e, n);
    }

    function m(e, n) {
      if (null == e) return {};

      var a,
          t,
          i = function (e, n) {
        if (null == e) return {};
        var a,
            t,
            i = {},
            o = Object.keys(e);

        for (t = 0; t < o.length; t++) {
          a = o[t], n.indexOf(a) >= 0 || (i[a] = e[a]);
        }

        return i;
      }(e, n);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (t = 0; t < o.length; t++) {
          a = o[t], n.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (i[a] = e[a]);
        }
      }

      return i;
    }

    var f = a(0),
        v = a.n(f),
        h = a(54),
        x = a.n(h),
        b = a(13),
        g = a(1),
        y = a.n(g);

    var w = function () {
      function e(e) {
        this.isSpeedy = void 0 === e.speedy || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
      }

      var n = e.prototype;
      return n.insert = function (e) {
        if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
          var n,
              a = function (e) {
            var n = document.createElement("style");
            return n.setAttribute("data-emotion", e.key), void 0 !== e.nonce && n.setAttribute("nonce", e.nonce), n.appendChild(document.createTextNode("")), n;
          }(this);

          n = 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling, this.container.insertBefore(a, n), this.tags.push(a);
        }

        var t = this.tags[this.tags.length - 1];

        if (this.isSpeedy) {
          var i = function (e) {
            if (e.sheet) return e.sheet;

            for (var n = 0; n < document.styleSheets.length; n++) {
              if (document.styleSheets[n].ownerNode === e) return document.styleSheets[n];
            }
          }(t);

          try {
            var o = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
            i.insertRule(e, o ? 0 : i.cssRules.length);
          } catch (s) {
            0;
          }
        } else t.appendChild(document.createTextNode(e));

        this.ctr++;
      }, n.flush = function () {
        this.tags.forEach(function (e) {
          return e.parentNode.removeChild(e);
        }), this.tags = [], this.ctr = 0;
      }, e;
    }();

    var E = function E(e) {
      function n(e, n, t) {
        var i = n.trim().split(f);
        n = i;
        var o = i.length,
            s = e.length;

        switch (s) {
          case 0:
          case 1:
            var r = 0;

            for (e = 0 === s ? "" : e[0] + " "; r < o; ++r) {
              n[r] = a(e, n[r], t).trim();
            }

            break;

          default:
            var c = r = 0;

            for (n = []; r < o; ++r) {
              for (var p = 0; p < s; ++p) {
                n[c++] = a(e[p] + " ", i[r], t).trim();
              }
            }

        }

        return n;
      }

      function a(e, n, a) {
        var t = n.charCodeAt(0);

        switch (33 > t && (t = (n = n.trim()).charCodeAt(0)), t) {
          case 38:
            return n.replace(v, "$1" + e.trim());

          case 58:
            return e.trim() + n.replace(v, "$1" + e.trim());

          default:
            if (0 < 1 * a && 0 < n.indexOf("\f")) return n.replace(v, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
        }

        return e + n;
      }

      function t(e, n, a, o) {
        var s = e + ";",
            r = 2 * n + 3 * a + 4 * o;

        if (944 === r) {
          e = s.indexOf(":", 9) + 1;
          var c = s.substring(e, s.length - 1).trim();
          return c = s.substring(0, e).trim() + c + ";", 1 === F || 2 === F && i(c, 1) ? "-webkit-" + c + c : c;
        }

        if (0 === F || 2 === F && !i(s, 1)) return s;

        switch (r) {
          case 1015:
            return 97 === s.charCodeAt(10) ? "-webkit-" + s + s : s;

          case 951:
            return 116 === s.charCodeAt(3) ? "-webkit-" + s + s : s;

          case 963:
            return 110 === s.charCodeAt(5) ? "-webkit-" + s + s : s;

          case 1009:
            if (100 !== s.charCodeAt(4)) break;

          case 969:
          case 942:
            return "-webkit-" + s + s;

          case 978:
            return "-webkit-" + s + "-moz-" + s + s;

          case 1019:
          case 983:
            return "-webkit-" + s + "-moz-" + s + "-ms-" + s + s;

          case 883:
            if (45 === s.charCodeAt(8)) return "-webkit-" + s + s;
            if (0 < s.indexOf("image-set(", 11)) return s.replace(C, "$1-webkit-$2") + s;
            break;

          case 932:
            if (45 === s.charCodeAt(4)) switch (s.charCodeAt(5)) {
              case 103:
                return "-webkit-box-" + s.replace("-grow", "") + "-webkit-" + s + "-ms-" + s.replace("grow", "positive") + s;

              case 115:
                return "-webkit-" + s + "-ms-" + s.replace("shrink", "negative") + s;

              case 98:
                return "-webkit-" + s + "-ms-" + s.replace("basis", "preferred-size") + s;
            }
            return "-webkit-" + s + "-ms-" + s + s;

          case 964:
            return "-webkit-" + s + "-ms-flex-" + s + s;

          case 1023:
            if (99 !== s.charCodeAt(8)) break;
            return "-webkit-box-pack" + (c = s.substring(s.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + s + "-ms-flex-pack" + c + s;

          case 1005:
            return d.test(s) ? s.replace(l, ":-webkit-") + s.replace(l, ":-moz-") + s : s;

          case 1e3:
            switch (n = (c = s.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(n)) {
              case 226:
                c = s.replace(g, "tb");
                break;

              case 232:
                c = s.replace(g, "tb-rl");
                break;

              case 220:
                c = s.replace(g, "lr");
                break;

              default:
                return s;
            }

            return "-webkit-" + s + "-ms-" + c + s;

          case 1017:
            if (-1 === s.indexOf("sticky", 9)) break;

          case 975:
            switch (n = (s = e).length - 10, r = (c = (33 === s.charCodeAt(n) ? s.substring(0, n) : s).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))) {
              case 203:
                if (111 > c.charCodeAt(8)) break;

              case 115:
                s = s.replace(c, "-webkit-" + c) + ";" + s;
                break;

              case 207:
              case 102:
                s = s.replace(c, "-webkit-" + (102 < r ? "inline-" : "") + "box") + ";" + s.replace(c, "-webkit-" + c) + ";" + s.replace(c, "-ms-" + c + "box") + ";" + s;
            }

            return s + ";";

          case 938:
            if (45 === s.charCodeAt(5)) switch (s.charCodeAt(6)) {
              case 105:
                return c = s.replace("-items", ""), "-webkit-" + s + "-webkit-box-" + c + "-ms-flex-" + c + s;

              case 115:
                return "-webkit-" + s + "-ms-flex-item-" + s.replace(E, "") + s;

              default:
                return "-webkit-" + s + "-ms-flex-line-pack" + s.replace("align-content", "").replace(E, "") + s;
            }
            break;

          case 973:
          case 989:
            if (45 !== s.charCodeAt(3) || 122 === s.charCodeAt(4)) break;

          case 931:
          case 953:
            if (!0 === O.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? t(e.replace("stretch", "fill-available"), n, a, o).replace(":fill-available", ":stretch") : s.replace(c, "-webkit-" + c) + s.replace(c, "-moz-" + c.replace("fill-", "")) + s;
            break;

          case 962:
            if (s = "-webkit-" + s + (102 === s.charCodeAt(5) ? "-ms-" + s : "") + s, 211 === a + o && 105 === s.charCodeAt(13) && 0 < s.indexOf("transform", 10)) return s.substring(0, s.indexOf(";", 27) + 1).replace(m, "$1-webkit-$2") + s;
        }

        return s;
      }

      function i(e, n) {
        var a = e.indexOf(1 === n ? ":" : "{"),
            t = e.substring(0, 3 !== n ? a : 10);
        return a = e.substring(a + 1, e.length - 1), I(2 !== n ? t : t.replace(k, "$1"), a, n);
      }

      function o(e, n) {
        var a = t(n, n.charCodeAt(0), n.charCodeAt(1), n.charCodeAt(2));
        return a !== n + ";" ? a.replace(w, " or ($1)").substring(4) : "(" + n + ")";
      }

      function s(e, n, a, t, i, o, s, r, p, u) {
        for (var l, d = 0, m = n; d < M; ++d) {
          switch (l = P[d].call(c, e, m, a, t, i, o, s, r, p, u)) {
            case void 0:
            case !1:
            case !0:
            case null:
              break;

            default:
              m = l;
          }
        }

        if (m !== n) return m;
      }

      function r(e) {
        return void 0 !== (e = e.prefix) && (I = null, e ? "function" !== typeof e ? F = 1 : (F = 2, I = e) : F = 0), r;
      }

      function c(e, a) {
        var r = e;

        if (33 > r.charCodeAt(0) && (r = r.trim()), r = [r], 0 < M) {
          var c = s(-1, a, r, r, j, A, 0, 0, 0, 0);
          void 0 !== c && "string" === typeof c && (a = c);
        }

        var l = function e(a, r, c, l, d) {
          for (var m, f, v, g, w, E = 0, k = 0, O = 0, C = 0, P = 0, I = 0, L = v = m = 0, R = 0, N = 0, V = 0, z = 0, _ = c.length, B = _ - 1, q = "", U = "", W = "", H = ""; R < _;) {
            if (f = c.charCodeAt(R), R === B && 0 !== k + C + O + E && (0 !== k && (f = 47 === k ? 10 : 47), C = O = E = 0, _++, B++), 0 === k + C + O + E) {
              if (R === B && (0 < N && (q = q.replace(u, "")), 0 < q.trim().length)) {
                switch (f) {
                  case 32:
                  case 9:
                  case 59:
                  case 13:
                  case 10:
                    break;

                  default:
                    q += c.charAt(R);
                }

                f = 59;
              }

              switch (f) {
                case 123:
                  for (m = (q = q.trim()).charCodeAt(0), v = 1, z = ++R; R < _;) {
                    switch (f = c.charCodeAt(R)) {
                      case 123:
                        v++;
                        break;

                      case 125:
                        v--;
                        break;

                      case 47:
                        switch (f = c.charCodeAt(R + 1)) {
                          case 42:
                          case 47:
                            e: {
                              for (L = R + 1; L < B; ++L) {
                                switch (c.charCodeAt(L)) {
                                  case 47:
                                    if (42 === f && 42 === c.charCodeAt(L - 1) && R + 2 !== L) {
                                      R = L + 1;
                                      break e;
                                    }

                                    break;

                                  case 10:
                                    if (47 === f) {
                                      R = L + 1;
                                      break e;
                                    }

                                }
                              }

                              R = L;
                            }

                        }

                        break;

                      case 91:
                        f++;

                      case 40:
                        f++;

                      case 34:
                      case 39:
                        for (; R++ < B && c.charCodeAt(R) !== f;) {
                          ;
                        }

                    }

                    if (0 === v) break;
                    R++;
                  }

                  switch (v = c.substring(z, R), 0 === m && (m = (q = q.replace(p, "").trim()).charCodeAt(0)), m) {
                    case 64:
                      switch (0 < N && (q = q.replace(u, "")), f = q.charCodeAt(1)) {
                        case 100:
                        case 109:
                        case 115:
                        case 45:
                          N = r;
                          break;

                        default:
                          N = D;
                      }

                      if (z = (v = e(r, N, v, f, d + 1)).length, 0 < M && (w = s(3, v, N = n(D, q, V), r, j, A, z, f, d, l), q = N.join(""), void 0 !== w && 0 === (z = (v = w.trim()).length) && (f = 0, v = "")), 0 < z) switch (f) {
                        case 115:
                          q = q.replace(y, o);

                        case 100:
                        case 109:
                        case 45:
                          v = q + "{" + v + "}";
                          break;

                        case 107:
                          v = (q = q.replace(h, "$1 $2")) + "{" + v + "}", v = 1 === F || 2 === F && i("@" + v, 3) ? "@-webkit-" + v + "@" + v : "@" + v;
                          break;

                        default:
                          v = q + v, 112 === l && (U += v, v = "");
                      } else v = "";
                      break;

                    default:
                      v = e(r, n(r, q, V), v, l, d + 1);
                  }

                  W += v, v = V = N = L = m = 0, q = "", f = c.charCodeAt(++R);
                  break;

                case 125:
                case 59:
                  if (1 < (z = (q = (0 < N ? q.replace(u, "") : q).trim()).length)) switch (0 === L && (m = q.charCodeAt(0), 45 === m || 96 < m && 123 > m) && (z = (q = q.replace(" ", ":")).length), 0 < M && void 0 !== (w = s(1, q, r, a, j, A, U.length, l, d, l)) && 0 === (z = (q = w.trim()).length) && (q = "\0\0"), m = q.charCodeAt(0), f = q.charCodeAt(1), m) {
                    case 0:
                      break;

                    case 64:
                      if (105 === f || 99 === f) {
                        H += q + c.charAt(R);
                        break;
                      }

                    default:
                      58 !== q.charCodeAt(z - 1) && (U += t(q, m, f, q.charCodeAt(2)));
                  }
                  V = N = L = m = 0, q = "", f = c.charCodeAt(++R);
              }
            }

            switch (f) {
              case 13:
              case 10:
                47 === k ? k = 0 : 0 === 1 + m && 107 !== l && 0 < q.length && (N = 1, q += "\0"), 0 < M * T && s(0, q, r, a, j, A, U.length, l, d, l), A = 1, j++;
                break;

              case 59:
              case 125:
                if (0 === k + C + O + E) {
                  A++;
                  break;
                }

              default:
                switch (A++, g = c.charAt(R), f) {
                  case 9:
                  case 32:
                    if (0 === C + E + k) switch (P) {
                      case 44:
                      case 58:
                      case 9:
                      case 32:
                        g = "";
                        break;

                      default:
                        32 !== f && (g = " ");
                    }
                    break;

                  case 0:
                    g = "\\0";
                    break;

                  case 12:
                    g = "\\f";
                    break;

                  case 11:
                    g = "\\v";
                    break;

                  case 38:
                    0 === C + k + E && (N = V = 1, g = "\f" + g);
                    break;

                  case 108:
                    if (0 === C + k + E + S && 0 < L) switch (R - L) {
                      case 2:
                        112 === P && 58 === c.charCodeAt(R - 3) && (S = P);

                      case 8:
                        111 === I && (S = I);
                    }
                    break;

                  case 58:
                    0 === C + k + E && (L = R);
                    break;

                  case 44:
                    0 === k + O + C + E && (N = 1, g += "\r");
                    break;

                  case 34:
                  case 39:
                    0 === k && (C = C === f ? 0 : 0 === C ? f : C);
                    break;

                  case 91:
                    0 === C + k + O && E++;
                    break;

                  case 93:
                    0 === C + k + O && E--;
                    break;

                  case 41:
                    0 === C + k + E && O--;
                    break;

                  case 40:
                    if (0 === C + k + E) {
                      if (0 === m) switch (2 * P + 3 * I) {
                        case 533:
                          break;

                        default:
                          m = 1;
                      }
                      O++;
                    }

                    break;

                  case 64:
                    0 === k + O + C + E + L + v && (v = 1);
                    break;

                  case 42:
                  case 47:
                    if (!(0 < C + E + O)) switch (k) {
                      case 0:
                        switch (2 * f + 3 * c.charCodeAt(R + 1)) {
                          case 235:
                            k = 47;
                            break;

                          case 220:
                            z = R, k = 42;
                        }

                        break;

                      case 42:
                        47 === f && 42 === P && z + 2 !== R && (33 === c.charCodeAt(z + 2) && (U += c.substring(z, R + 1)), g = "", k = 0);
                    }
                }

                0 === k && (q += g);
            }

            I = P, P = f, R++;
          }

          if (0 < (z = U.length)) {
            if (N = r, 0 < M && void 0 !== (w = s(2, U, N, a, j, A, z, l, d, l)) && 0 === (U = w).length) return H + U + W;

            if (U = N.join(",") + "{" + U + "}", 0 !== F * S) {
              switch (2 !== F || i(U, 2) || (S = 0), S) {
                case 111:
                  U = U.replace(b, ":-moz-$1") + U;
                  break;

                case 112:
                  U = U.replace(x, "::-webkit-input-$1") + U.replace(x, "::-moz-$1") + U.replace(x, ":-ms-input-$1") + U;
              }

              S = 0;
            }
          }

          return H + U + W;
        }(D, r, a, 0, 0);

        return 0 < M && void 0 !== (c = s(-2, l, r, r, j, A, l.length, 0, 0, 0)) && (l = c), S = 0, A = j = 1, l;
      }

      var p = /^\0+/g,
          u = /[\0\r\f]/g,
          l = /: */g,
          d = /zoo|gra/,
          m = /([,: ])(transform)/g,
          f = /,\r+?/g,
          v = /([\t\r\n ])*\f?&/g,
          h = /@(k\w+)\s*(\S*)\s*/,
          x = /::(place)/g,
          b = /:(read-only)/g,
          g = /[svh]\w+-[tblr]{2}/,
          y = /\(\s*(.*)\s*\)/g,
          w = /([\s\S]*?);/g,
          E = /-self|flex-/g,
          k = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
          O = /stretch|:\s*\w+\-(?:conte|avail)/,
          C = /([^-])(image-set\()/,
          A = 1,
          j = 1,
          S = 0,
          F = 1,
          D = [],
          P = [],
          M = 0,
          I = null,
          T = 0;
      return c.use = function e(n) {
        switch (n) {
          case void 0:
          case null:
            M = P.length = 0;
            break;

          default:
            if ("function" === typeof n) P[M++] = n;else if ("object" === typeof n) for (var a = 0, t = n.length; a < t; ++a) {
              e(n[a]);
            } else T = 0 | !!n;
        }

        return e;
      }, c.set = r, void 0 !== e && r(e), c;
    };

    function k(e) {
      e && O.current.insert(e + "}");
    }

    var O = {
      current: null
    },
        C = function C(e, n, a, t, i, o, s, r, c, p) {
      switch (e) {
        case 1:
          switch (n.charCodeAt(0)) {
            case 64:
              return O.current.insert(n + ";"), "";

            case 108:
              if (98 === n.charCodeAt(2)) return "";
          }

          break;

        case 2:
          if (0 === r) return n + "/*|*/";
          break;

        case 3:
          switch (r) {
            case 102:
            case 112:
              return O.current.insert(a[0] + n), "";

            default:
              return n + (0 === p ? "/*|*/" : "");
          }

        case -2:
          n.split("/*|*/}").forEach(k);
      }
    },
        A = function A(e) {
      void 0 === e && (e = {});
      var n,
          a = e.key || "css";
      void 0 !== e.prefix && (n = {
        prefix: e.prefix
      });
      var t = new E(n);
      var i,
          o = {};
      i = e.container || document.head;
      var s,
          r = document.querySelectorAll("style[data-emotion-" + a + "]");
      Array.prototype.forEach.call(r, function (e) {
        e.getAttribute("data-emotion-" + a).split(" ").forEach(function (e) {
          o[e] = !0;
        }), e.parentNode !== i && i.appendChild(e);
      }), t.use(e.stylisPlugins)(C), s = function s(e, n, a, i) {
        var o = n.name;
        O.current = a, t(e, n.styles), i && (c.inserted[o] = !0);
      };
      var c = {
        key: a,
        sheet: new w({
          key: a,
          container: i,
          nonce: e.nonce,
          speedy: e.speedy
        }),
        nonce: e.nonce,
        inserted: o,
        registered: {},
        insert: s
      };
      return c;
    };

    var j = function j(e) {
      for (var n, a = e.length, t = a ^ a, i = 0; a >= 4;) {
        n = 1540483477 * (65535 & (n = 255 & e.charCodeAt(i) | (255 & e.charCodeAt(++i)) << 8 | (255 & e.charCodeAt(++i)) << 16 | (255 & e.charCodeAt(++i)) << 24)) + ((1540483477 * (n >>> 16) & 65535) << 16), t = 1540483477 * (65535 & t) + ((1540483477 * (t >>> 16) & 65535) << 16) ^ (n = 1540483477 * (65535 & (n ^= n >>> 24)) + ((1540483477 * (n >>> 16) & 65535) << 16)), a -= 4, ++i;
      }

      switch (a) {
        case 3:
          t ^= (255 & e.charCodeAt(i + 2)) << 16;

        case 2:
          t ^= (255 & e.charCodeAt(i + 1)) << 8;

        case 1:
          t = 1540483477 * (65535 & (t ^= 255 & e.charCodeAt(i))) + ((1540483477 * (t >>> 16) & 65535) << 16);
      }

      return t = 1540483477 * (65535 & (t ^= t >>> 13)) + ((1540483477 * (t >>> 16) & 65535) << 16), ((t ^= t >>> 15) >>> 0).toString(36);
    },
        S = {
      animationIterationCount: 1,
      borderImageOutset: 1,
      borderImageSlice: 1,
      borderImageWidth: 1,
      boxFlex: 1,
      boxFlexGroup: 1,
      boxOrdinalGroup: 1,
      columnCount: 1,
      columns: 1,
      flex: 1,
      flexGrow: 1,
      flexPositive: 1,
      flexShrink: 1,
      flexNegative: 1,
      flexOrder: 1,
      gridRow: 1,
      gridRowEnd: 1,
      gridRowSpan: 1,
      gridRowStart: 1,
      gridColumn: 1,
      gridColumnEnd: 1,
      gridColumnSpan: 1,
      gridColumnStart: 1,
      msGridRow: 1,
      msGridRowSpan: 1,
      msGridColumn: 1,
      msGridColumnSpan: 1,
      fontWeight: 1,
      lineHeight: 1,
      opacity: 1,
      order: 1,
      orphans: 1,
      tabSize: 1,
      widows: 1,
      zIndex: 1,
      zoom: 1,
      WebkitLineClamp: 1,
      fillOpacity: 1,
      floodOpacity: 1,
      stopOpacity: 1,
      strokeDasharray: 1,
      strokeDashoffset: 1,
      strokeMiterlimit: 1,
      strokeOpacity: 1,
      strokeWidth: 1
    };

    var F = /[A-Z]|^ms/g,
        D = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
        P = function (e) {
      var n = {};
      return function (a) {
        return void 0 === n[a] && (n[a] = e(a)), n[a];
      };
    }(function (e) {
      return e.replace(F, "-$&").toLowerCase();
    }),
        M = function M(e, n) {
      if (null == n || "boolean" === typeof n) return "";

      switch (e) {
        case "animation":
        case "animationName":
          "string" === typeof n && (n = n.replace(D, function (e, n, a) {
            return T = {
              name: n,
              styles: a,
              next: T
            }, n;
          }));
      }

      return 1 !== S[e] && 45 !== e.charCodeAt(1) && "number" === typeof n && 0 !== n ? n + "px" : n;
    };

    function I(e, n, a, t) {
      if (null == a) return "";
      if (void 0 !== a.__emotion_styles) return a;

      switch (typeof a) {
        case "boolean":
          return "";

        case "object":
          if (1 === a.anim) return T = {
            name: a.name,
            styles: a.styles,
            next: T
          }, a.name;

          if (void 0 !== a.styles) {
            var i = a.next;
            if (void 0 !== i) for (; void 0 !== i;) {
              T = {
                name: i.name,
                styles: i.styles,
                next: T
              }, i = i.next;
            }
            return a.styles;
          }

          return function (e, n, a) {
            var t = "";
            if (Array.isArray(a)) for (var i = 0; i < a.length; i++) {
              t += I(e, n, a[i], !1);
            } else for (var o in a) {
              var s = a[o];
              if ("object" !== typeof s) null != n && void 0 !== n[s] ? t += o + "{" + n[s] + "}" : t += P(o) + ":" + M(o, s) + ";";else if (!Array.isArray(s) || "string" !== typeof s[0] || null != n && void 0 !== n[s[0]]) t += o + "{" + I(e, n, s, !1) + "}";else for (var r = 0; r < s.length; r++) {
                t += P(o) + ":" + M(o, s[r]) + ";";
              }
            }
            return t;
          }(e, n, a);

        case "function":
          if (void 0 !== e) {
            var o = T,
                s = a(e);
            return T = o, I(e, n, s, t);
          }

        default:
          if (null == n) return a;
          var r = n[a];
          return void 0 === r || t ? a : r;
      }
    }

    var T,
        L = /label:\s*([^\s;\n{]+)\s*;/g;

    var R = function R(e, n, a) {
      if (1 === e.length && "object" === typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
      var t = !0,
          i = "";
      T = void 0;
      var o = e[0];
      null == o || void 0 === o.raw ? (t = !1, i += I(a, n, o, !1)) : i += o[0];

      for (var s = 1; s < e.length; s++) {
        i += I(a, n, e[s], 46 === i.charCodeAt(i.length - 1)), t && (i += o[s]);
      }

      L.lastIndex = 0;

      for (var r, c = ""; null !== (r = L.exec(i));) {
        c += "-" + r[1];
      }

      return {
        name: j(i) + c,
        styles: i,
        next: T
      };
    };

    function N(e, n, a) {
      var t = "";
      return a.split(" ").forEach(function (a) {
        void 0 !== e[a] ? n.push(e[a]) : t += a + " ";
      }), t;
    }

    function V(e, n) {
      if (void 0 === e.inserted[n.name]) return e.insert("", n, e.sheet, !0);
    }

    function z(e, n, a) {
      var t = [],
          i = N(e, t, a);
      return t.length < 2 ? a : i + n(t);
    }

    var _ = function e(n) {
      for (var a = "", t = 0; t < n.length; t++) {
        var i = n[t];

        if (null != i) {
          var o = void 0;

          switch (typeof i) {
            case "boolean":
              break;

            case "object":
              if (Array.isArray(i)) o = e(i);else for (var s in o = "", i) {
                i[s] && s && (o && (o += " "), o += s);
              }
              break;

            default:
              o = i;
          }

          o && (a && (a += " "), a += o);
        }
      }

      return a;
    },
        B = function B(e) {
      var n = A(e);
      n.sheet.speedy = function (e) {
        this.isSpeedy = e;
      }, n.compat = !0;

      var a = function a() {
        for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
          a[t] = arguments[t];
        }

        var i = R(a, n.registered, void 0 !== this ? this.mergedProps : void 0);
        return function (e, n, a) {
          var t = e.key + "-" + n.name;

          if (!1 === a && void 0 === e.registered[t] && (e.registered[t] = n.styles), void 0 === e.inserted[n.name]) {
            var i = n;

            do {
              e.insert("." + t, i, e.sheet, !0), i = i.next;
            } while (void 0 !== i);
          }
        }(n, i, !1), n.key + "-" + i.name;
      };

      return {
        css: a,
        cx: function cx() {
          for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
            t[i] = arguments[i];
          }

          return z(n.registered, a, _(t));
        },
        injectGlobal: function injectGlobal() {
          for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
            a[t] = arguments[t];
          }

          var i = R(a, n.registered);
          V(n, i);
        },
        keyframes: function keyframes() {
          for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++) {
            a[t] = arguments[t];
          }

          var i = R(a, n.registered),
              o = "animation-" + i.name;
          return V(n, {
            name: i.name,
            styles: "@keyframes " + o + "{" + i.styles + "}"
          }), o;
        },
        hydrate: function hydrate(e) {
          e.forEach(function (e) {
            n.inserted[e] = !0;
          });
        },
        flush: function flush() {
          n.registered = {}, n.inserted = {}, n.sheet.flush();
        },
        sheet: n.sheet,
        cache: n,
        getRegisteredStyles: N.bind(null, n.registered),
        merge: z.bind(null, n.registered, a)
      };
    },
        q = a(55),
        U = a.n(q),
        W = function W(e, n) {
      return e === n;
    };

    var H = function H(e, n) {
      var a;
      void 0 === n && (n = W);

      var t,
          i = [],
          o = !1,
          s = function s(e, a) {
        return n(e, i[a]);
      };

      return function () {
        for (var n = arguments.length, r = new Array(n), c = 0; c < n; c++) {
          r[c] = arguments[c];
        }

        return o && a === this && r.length === i.length && r.every(s) ? t : (t = e.apply(this, r), o = !0, a = this, i = r, t);
      };
    },
        G = a(23),
        Y = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        X = function X(e, n) {
      if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
    },
        J = function () {
      function e(e, n) {
        for (var a = 0; a < n.length; a++) {
          var t = n[a];
          t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
        }
      }

      return function (n, a, t) {
        return a && e(n.prototype, a), t && e(n, t), n;
      };
    }(),
        Q = function Q(e, n, a) {
      return n in e ? Object.defineProperty(e, n, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = a, e;
    },
        Z = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var a = arguments[n];

        for (var t in a) {
          Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
        }
      }

      return e;
    },
        K = function K(e, n) {
      if ("function" !== typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    },
        $ = function $(e, n) {
      var a = {};

      for (var t in e) {
        n.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(e, t) && (a[t] = e[t]);
      }

      return a;
    },
        ee = function ee(e, n) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !n || "object" !== typeof n && "function" !== typeof n ? e : n;
    },
        ne = function ne(e) {
      if (Array.isArray(e)) {
        for (var n = 0, a = Array(e.length); n < e.length; n++) {
          a[n] = e[n];
        }

        return a;
      }

      return Array.from(e);
    },
        ae = function ae() {};

    function te(e, n) {
      return n ? "-" === n[0] ? e + n : e + "__" + n : e;
    }

    var ie = function ie(e) {
      return Array.isArray(e) ? e.filter(Boolean) : "object" === ("undefined" === typeof e ? "undefined" : Y(e)) && null !== e ? [e] : [];
    };

    function oe(e) {
      return [document.documentElement, document.body, window].indexOf(e) > -1;
    }

    function se(e) {
      return oe(e) ? window.pageYOffset : e.scrollTop;
    }

    function re(e, n) {
      oe(e) ? window.scrollTo(0, n) : e.scrollTop = n;
    }

    function ce(e, n) {
      var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 200,
          t = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ae,
          i = se(e),
          o = n - i,
          s = 10,
          r = 0;
      !function n() {
        var c,
            p = o * ((c = (c = r += s) / a - 1) * c * c + 1) + i;
        re(e, p), r < a ? x()(n) : t(e);
      }();
    }

    function pe() {
      try {
        return document.createEvent("TouchEvent"), !0;
      } catch (e) {
        return !1;
      }
    }

    function ue(e) {
      var n = e.maxHeight,
          a = e.menuEl,
          t = e.minHeight,
          i = e.placement,
          o = e.shouldScroll,
          s = e.isFixedPosition,
          r = e.theme.spacing,
          c = function (e) {
        var n = getComputedStyle(e),
            a = "absolute" === n.position,
            t = /(auto|scroll)/,
            i = document.documentElement;
        if ("fixed" === n.position) return i;

        for (var o = e; o = o.parentElement;) {
          if (n = getComputedStyle(o), (!a || "static" !== n.position) && t.test(n.overflow + n.overflowY + n.overflowX)) return o;
        }

        return i;
      }(a),
          p = {
        placement: "bottom",
        maxHeight: n
      };

      if (!a || !a.offsetParent) return p;
      var u = c.getBoundingClientRect().height,
          l = a.getBoundingClientRect(),
          d = l.bottom,
          m = l.height,
          f = l.top,
          v = a.offsetParent.getBoundingClientRect().top,
          h = window.innerHeight,
          x = se(c),
          b = parseInt(getComputedStyle(a).marginBottom, 10),
          g = parseInt(getComputedStyle(a).marginTop, 10),
          y = v - g,
          w = h - f,
          E = y + x,
          k = u - x - f,
          O = d - h + x + b,
          C = x + f - g;

      switch (i) {
        case "auto":
        case "bottom":
          if (w >= m) return {
            placement: "bottom",
            maxHeight: n
          };
          if (k >= m && !s) return o && ce(c, O, 160), {
            placement: "bottom",
            maxHeight: n
          };
          if (!s && k >= t || s && w >= t) return o && ce(c, O, 160), {
            placement: "bottom",
            maxHeight: s ? w - b : k - b
          };

          if ("auto" === i || s) {
            var A = n;
            return (!s && E >= t || s && y >= t) && (A = s ? y - b - r.controlHeight : E - b - r.controlHeight), {
              placement: "top",
              maxHeight: A
            };
          }

          if ("bottom" === i) return re(c, O), {
            placement: "bottom",
            maxHeight: n
          };
          break;

        case "top":
          if (y >= m) return {
            placement: "top",
            maxHeight: n
          };
          if (E >= m && !s) return o && ce(c, C, 160), {
            placement: "top",
            maxHeight: n
          };

          if (!s && E >= t || s && y >= t) {
            var j = n;
            return (!s && E >= t || s && y >= t) && (j = s ? y - g : E - g), o && ce(c, C, 160), {
              placement: "top",
              maxHeight: j
            };
          }

          return {
            placement: "bottom",
            maxHeight: n
          };

        default:
          throw new Error('Invalid placement provided "' + i + '".');
      }

      return p;
    }

    var le = function le(e) {
      return "auto" === e ? "bottom" : e;
    },
        de = function (e) {
      function n() {
        var e, a, t;
        X(this, n);

        for (var i = arguments.length, o = Array(i), s = 0; s < i; s++) {
          o[s] = arguments[s];
        }

        return a = t = ee(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(o))), t.state = {
          maxHeight: t.props.maxMenuHeight,
          placement: null
        }, t.getPlacement = function (e) {
          var n = t.props,
              a = n.minMenuHeight,
              i = n.maxMenuHeight,
              o = n.menuPlacement,
              s = n.menuPosition,
              r = n.menuShouldScrollIntoView,
              c = n.theme,
              p = t.context.getPortalPlacement;

          if (e) {
            var u = "fixed" === s,
                l = ue({
              maxHeight: i,
              menuEl: e,
              minHeight: a,
              placement: o,
              shouldScroll: r && !u,
              isFixedPosition: u,
              theme: c
            });
            p && p(l), t.setState(l);
          }
        }, t.getUpdatedProps = function () {
          var e = t.props.menuPlacement,
              n = t.state.placement || le(e);
          return Z({}, t.props, {
            placement: n,
            maxHeight: t.state.maxHeight
          });
        }, ee(t, a);
      }

      return K(n, e), J(n, [{
        key: "render",
        value: function value() {
          return (0, this.props.children)({
            ref: this.getPlacement,
            placerProps: this.getUpdatedProps()
          });
        }
      }]), n;
    }(f.Component);

    de.contextTypes = {
      getPortalPlacement: y.a.func
    };

    var me = function me(e) {
      var n = e.theme,
          a = n.spacing.baseUnit;
      return {
        color: n.colors.neutral40,
        padding: 2 * a + "px " + 3 * a + "px",
        textAlign: "center"
      };
    },
        fe = me,
        ve = me,
        he = function he(e) {
      var n = e.children,
          a = e.className,
          t = e.cx,
          i = e.getStyles,
          o = e.innerProps,
          s = e.emotion;
      return v.a.createElement("div", Z({
        className: t(s.css(i("noOptionsMessage", e)), {
          "menu-notice": !0,
          "menu-notice--no-options": !0
        }, a)
      }, o), n);
    };

    he.defaultProps = {
      children: "No options"
    };

    var xe = function xe(e) {
      var n = e.children,
          a = e.className,
          t = e.cx,
          i = e.getStyles,
          o = e.innerProps,
          s = e.emotion;
      return v.a.createElement("div", Z({
        className: t(s.css(i("loadingMessage", e)), {
          "menu-notice": !0,
          "menu-notice--loading": !0
        }, a)
      }, o), n);
    };

    xe.defaultProps = {
      children: "Loading..."
    };

    var be = function (e) {
      function n() {
        var e, a, t;
        X(this, n);

        for (var i = arguments.length, o = Array(i), s = 0; s < i; s++) {
          o[s] = arguments[s];
        }

        return a = t = ee(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(o))), t.state = {
          placement: null
        }, t.getPortalPlacement = function (e) {
          var n = e.placement;
          n !== le(t.props.menuPlacement) && t.setState({
            placement: n
          });
        }, ee(t, a);
      }

      return K(n, e), J(n, [{
        key: "getChildContext",
        value: function value() {
          return {
            getPortalPlacement: this.getPortalPlacement
          };
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.appendTo,
              a = e.children,
              t = e.controlElement,
              i = e.menuPlacement,
              o = e.menuPosition,
              s = e.getStyles,
              r = e.emotion,
              c = "fixed" === o;
          if (!n && !c || !t) return null;

          var p = this.state.placement || le(i),
              u = function (e) {
            var n = e.getBoundingClientRect();
            return {
              bottom: n.bottom,
              height: n.height,
              left: n.left,
              right: n.right,
              top: n.top,
              width: n.width
            };
          }(t),
              l = c ? 0 : window.pageYOffset,
              d = {
            offset: u[p] + l,
            position: o,
            rect: u
          },
              m = v.a.createElement("div", {
            className: r.css(s("menuPortal", d))
          }, a);

          return n ? Object(b.createPortal)(m, n) : m;
        }
      }]), n;
    }(f.Component);

    be.childContextTypes = {
      getPortalPlacement: y.a.func
    };
    var ge = Array.isArray,
        ye = Object.keys,
        we = Object.prototype.hasOwnProperty;

    function Ee(e, n) {
      try {
        return function e(n, a) {
          if (n === a) return !0;

          if (n && a && "object" == ("undefined" === typeof n ? "undefined" : Y(n)) && "object" == ("undefined" === typeof a ? "undefined" : Y(a))) {
            var t,
                i,
                o,
                s = ge(n),
                r = ge(a);

            if (s && r) {
              if ((i = n.length) != a.length) return !1;

              for (t = i; 0 !== t--;) {
                if (!e(n[t], a[t])) return !1;
              }

              return !0;
            }

            if (s != r) return !1;
            var c = n instanceof Date,
                p = a instanceof Date;
            if (c != p) return !1;
            if (c && p) return n.getTime() == a.getTime();
            var u = n instanceof RegExp,
                l = a instanceof RegExp;
            if (u != l) return !1;
            if (u && l) return n.toString() == a.toString();
            var d = ye(n);
            if ((i = d.length) !== ye(a).length) return !1;

            for (t = i; 0 !== t--;) {
              if (!we.call(a, d[t])) return !1;
            }

            for (t = i; 0 !== t--;) {
              if (("_owner" !== (o = d[t]) || !n.$$typeof) && !e(n[o], a[o])) return !1;
            }

            return !0;
          }

          return n !== n && a !== a;
        }(e, n);
      } catch (a) {
        if (a.message && a.message.match(/stack|recursion/i)) return console.warn("Warning: react-fast-compare does not handle circular references.", a.name, a.message), !1;
        throw a;
      }
    }

    var ke = [{
      base: "A",
      letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
    }, {
      base: "AA",
      letters: /[\uA732]/g
    }, {
      base: "AE",
      letters: /[\u00C6\u01FC\u01E2]/g
    }, {
      base: "AO",
      letters: /[\uA734]/g
    }, {
      base: "AU",
      letters: /[\uA736]/g
    }, {
      base: "AV",
      letters: /[\uA738\uA73A]/g
    }, {
      base: "AY",
      letters: /[\uA73C]/g
    }, {
      base: "B",
      letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
    }, {
      base: "C",
      letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
    }, {
      base: "D",
      letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
    }, {
      base: "DZ",
      letters: /[\u01F1\u01C4]/g
    }, {
      base: "Dz",
      letters: /[\u01F2\u01C5]/g
    }, {
      base: "E",
      letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
    }, {
      base: "F",
      letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
    }, {
      base: "G",
      letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
    }, {
      base: "H",
      letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
    }, {
      base: "I",
      letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
    }, {
      base: "J",
      letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
    }, {
      base: "K",
      letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
    }, {
      base: "L",
      letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
    }, {
      base: "LJ",
      letters: /[\u01C7]/g
    }, {
      base: "Lj",
      letters: /[\u01C8]/g
    }, {
      base: "M",
      letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
    }, {
      base: "N",
      letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
    }, {
      base: "NJ",
      letters: /[\u01CA]/g
    }, {
      base: "Nj",
      letters: /[\u01CB]/g
    }, {
      base: "O",
      letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
    }, {
      base: "OI",
      letters: /[\u01A2]/g
    }, {
      base: "OO",
      letters: /[\uA74E]/g
    }, {
      base: "OU",
      letters: /[\u0222]/g
    }, {
      base: "P",
      letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
    }, {
      base: "Q",
      letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
    }, {
      base: "R",
      letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
    }, {
      base: "S",
      letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
    }, {
      base: "T",
      letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
    }, {
      base: "TZ",
      letters: /[\uA728]/g
    }, {
      base: "U",
      letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
    }, {
      base: "V",
      letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
    }, {
      base: "VY",
      letters: /[\uA760]/g
    }, {
      base: "W",
      letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
    }, {
      base: "X",
      letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
    }, {
      base: "Y",
      letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
    }, {
      base: "Z",
      letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
    }, {
      base: "a",
      letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
    }, {
      base: "aa",
      letters: /[\uA733]/g
    }, {
      base: "ae",
      letters: /[\u00E6\u01FD\u01E3]/g
    }, {
      base: "ao",
      letters: /[\uA735]/g
    }, {
      base: "au",
      letters: /[\uA737]/g
    }, {
      base: "av",
      letters: /[\uA739\uA73B]/g
    }, {
      base: "ay",
      letters: /[\uA73D]/g
    }, {
      base: "b",
      letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
    }, {
      base: "c",
      letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
    }, {
      base: "d",
      letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
    }, {
      base: "dz",
      letters: /[\u01F3\u01C6]/g
    }, {
      base: "e",
      letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
    }, {
      base: "f",
      letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
    }, {
      base: "g",
      letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
    }, {
      base: "h",
      letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
    }, {
      base: "hv",
      letters: /[\u0195]/g
    }, {
      base: "i",
      letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
    }, {
      base: "j",
      letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
    }, {
      base: "k",
      letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
    }, {
      base: "l",
      letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
    }, {
      base: "lj",
      letters: /[\u01C9]/g
    }, {
      base: "m",
      letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
    }, {
      base: "n",
      letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
    }, {
      base: "nj",
      letters: /[\u01CC]/g
    }, {
      base: "o",
      letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
    }, {
      base: "oi",
      letters: /[\u01A3]/g
    }, {
      base: "ou",
      letters: /[\u0223]/g
    }, {
      base: "oo",
      letters: /[\uA74F]/g
    }, {
      base: "p",
      letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
    }, {
      base: "q",
      letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
    }, {
      base: "r",
      letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
    }, {
      base: "s",
      letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
    }, {
      base: "t",
      letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
    }, {
      base: "tz",
      letters: /[\uA729]/g
    }, {
      base: "u",
      letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
    }, {
      base: "v",
      letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
    }, {
      base: "vy",
      letters: /[\uA761]/g
    }, {
      base: "w",
      letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
    }, {
      base: "x",
      letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
    }, {
      base: "y",
      letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
    }, {
      base: "z",
      letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
    }],
        Oe = function Oe(e) {
      for (var n = 0; n < ke.length; n++) {
        e = e.replace(ke[n].letters, ke[n].base);
      }

      return e;
    },
        Ce = function Ce(e) {
      return e.replace(/^\s+|\s+$/g, "");
    },
        Ae = function Ae(e) {
      return e.label + " " + e.value;
    },
        je = function je(e) {
      return v.a.createElement("span", Z({
        className: e.emotion.css({
          zIndex: 9999,
          border: 0,
          clip: "rect(1px, 1px, 1px, 1px)",
          height: 1,
          width: 1,
          position: "absolute",
          overflow: "hidden",
          padding: 0,
          whiteSpace: "nowrap",
          backgroundColor: "red",
          color: "blue"
        })
      }, e));
    },
        Se = function (e) {
      function n() {
        return X(this, n), ee(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
      }

      return K(n, e), J(n, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = (e.in, e.out, e.onExited, e.appear, e.enter, e.exit, e.innerRef),
              a = e.emotion,
              t = $(e, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
          return v.a.createElement("input", Z({
            ref: n
          }, t, {
            className: a.css({
              background: 0,
              border: 0,
              fontSize: "inherit",
              outline: 0,
              padding: 0,
              width: 1,
              color: "transparent",
              left: -100,
              opacity: 0,
              position: "relative",
              transform: "scale(0)"
            })
          }));
        }
      }]), n;
    }(f.Component),
        Fe = function (e) {
      function n() {
        return X(this, n), ee(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
      }

      return K(n, e), J(n, [{
        key: "componentDidMount",
        value: function value() {
          this.props.innerRef(Object(b.findDOMNode)(this));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.props.innerRef(null);
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.children;
        }
      }]), n;
    }(f.Component),
        De = ["boxSizing", "height", "overflow", "paddingRight", "position"],
        Pe = {
      boxSizing: "border-box",
      overflow: "hidden",
      position: "relative",
      height: "100%"
    };

    function Me(e) {
      e.preventDefault();
    }

    function Ie(e) {
      e.stopPropagation();
    }

    function Te() {
      var e = this.scrollTop,
          n = this.scrollHeight,
          a = e + this.offsetHeight;
      0 === e ? this.scrollTop = 1 : a === n && (this.scrollTop = e - 1);
    }

    function Le() {
      return "ontouchstart" in window || navigator.maxTouchPoints;
    }

    var Re = !("undefined" === typeof window || !window.document || !window.document.createElement),
        Ne = 0,
        Ve = function (e) {
      function n() {
        var e, a, t;
        X(this, n);

        for (var i = arguments.length, o = Array(i), s = 0; s < i; s++) {
          o[s] = arguments[s];
        }

        return a = t = ee(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(o))), t.originalStyles = {}, t.listenerOptions = {
          capture: !1,
          passive: !1
        }, ee(t, a);
      }

      return K(n, e), J(n, [{
        key: "componentDidMount",
        value: function value() {
          var e = this;

          if (Re) {
            var n = this.props,
                a = n.accountForScrollbars,
                t = n.touchScrollTarget,
                i = document.body,
                o = i && i.style;

            if (a && De.forEach(function (n) {
              var a = o && o[n];
              e.originalStyles[n] = a;
            }), a && Ne < 1) {
              var s = parseInt(this.originalStyles.paddingRight, 10) || 0,
                  r = document.body ? document.body.clientWidth : 0,
                  c = window.innerWidth - r + s || 0;
              Object.keys(Pe).forEach(function (e) {
                var n = Pe[e];
                o && (o[e] = n);
              }), o && (o.paddingRight = c + "px");
            }

            i && Le() && (i.addEventListener("touchmove", Me, this.listenerOptions), t && (t.addEventListener("touchstart", Te, this.listenerOptions), t.addEventListener("touchmove", Ie, this.listenerOptions))), Ne += 1;
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          var e = this;

          if (Re) {
            var n = this.props,
                a = n.accountForScrollbars,
                t = n.touchScrollTarget,
                i = document.body,
                o = i && i.style;
            Ne = Math.max(Ne - 1, 0), a && Ne < 1 && De.forEach(function (n) {
              var a = e.originalStyles[n];
              o && (o[n] = a);
            }), i && Le() && (i.removeEventListener("touchmove", Me, this.listenerOptions), t && (t.removeEventListener("touchstart", Te, this.listenerOptions), t.removeEventListener("touchmove", Ie, this.listenerOptions)));
          }
        }
      }, {
        key: "render",
        value: function value() {
          return null;
        }
      }]), n;
    }(f.Component);

    Ve.defaultProps = {
      accountForScrollbars: !0
    };

    var ze = function (e) {
      function n() {
        var e, a, t;
        X(this, n);

        for (var i = arguments.length, o = Array(i), s = 0; s < i; s++) {
          o[s] = arguments[s];
        }

        return a = t = ee(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(o))), t.state = {
          touchScrollTarget: null
        }, t.getScrollTarget = function (e) {
          e !== t.state.touchScrollTarget && t.setState({
            touchScrollTarget: e
          });
        }, t.blurSelectInput = function () {
          document.activeElement && document.activeElement.blur();
        }, ee(t, a);
      }

      return K(n, e), J(n, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.children,
              a = e.isEnabled,
              t = e.emotion,
              i = this.state.touchScrollTarget;
          return a ? v.a.createElement("div", null, v.a.createElement("div", {
            onClick: this.blurSelectInput,
            className: t.css({
              position: "fixed",
              left: 0,
              bottom: 0,
              right: 0,
              top: 0
            })
          }), v.a.createElement(Fe, {
            innerRef: this.getScrollTarget
          }, n), i ? v.a.createElement(Ve, {
            touchScrollTarget: i
          }) : null) : n;
        }
      }]), n;
    }(f.PureComponent),
        _e = function (e) {
      function n() {
        var e, a, t;
        X(this, n);

        for (var i = arguments.length, o = Array(i), s = 0; s < i; s++) {
          o[s] = arguments[s];
        }

        return a = t = ee(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(o))), t.isBottom = !1, t.isTop = !1, t.cancelScroll = function (e) {
          e.preventDefault(), e.stopPropagation();
        }, t.handleEventDelta = function (e, n) {
          var a = t.props,
              i = a.onBottomArrive,
              o = a.onBottomLeave,
              s = a.onTopArrive,
              r = a.onTopLeave,
              c = t.scrollTarget,
              p = c.scrollTop,
              u = c.scrollHeight,
              l = c.clientHeight,
              d = t.scrollTarget,
              m = n > 0,
              f = u - l - p,
              v = !1;
          f > n && t.isBottom && (o && o(e), t.isBottom = !1), m && t.isTop && (r && r(e), t.isTop = !1), m && n > f ? (i && !t.isBottom && i(e), d.scrollTop = u, v = !0, t.isBottom = !0) : !m && -n > p && (s && !t.isTop && s(e), d.scrollTop = 0, v = !0, t.isTop = !0), v && t.cancelScroll(e);
        }, t.onWheel = function (e) {
          t.handleEventDelta(e, e.deltaY);
        }, t.onTouchStart = function (e) {
          t.touchStart = e.changedTouches[0].clientY;
        }, t.onTouchMove = function (e) {
          var n = t.touchStart - e.changedTouches[0].clientY;
          t.handleEventDelta(e, n);
        }, t.getScrollTarget = function (e) {
          t.scrollTarget = e;
        }, ee(t, a);
      }

      return K(n, e), J(n, [{
        key: "componentDidMount",
        value: function value() {
          this.startListening(this.scrollTarget);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.stopListening(this.scrollTarget);
        }
      }, {
        key: "startListening",
        value: function value(e) {
          e.scrollHeight <= e.clientHeight || ("function" === typeof e.addEventListener && e.addEventListener("wheel", this.onWheel, !1), "function" === typeof e.addEventListener && e.addEventListener("touchstart", this.onTouchStart, !1), "function" === typeof e.addEventListener && e.addEventListener("touchmove", this.onTouchMove, !1));
        }
      }, {
        key: "stopListening",
        value: function value(e) {
          e.scrollHeight <= e.clientHeight || ("function" === typeof e.removeEventListener && e.removeEventListener("wheel", this.onWheel, !1), "function" === typeof e.removeEventListener && e.removeEventListener("touchstart", this.onTouchStart, !1), "function" === typeof e.removeEventListener && e.removeEventListener("touchmove", this.onTouchMove, !1));
        }
      }, {
        key: "render",
        value: function value() {
          return v.a.createElement(Fe, {
            innerRef: this.getScrollTarget
          }, this.props.children);
        }
      }]), n;
    }(f.Component),
        Be = function (e) {
      function n() {
        return X(this, n), ee(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
      }

      return K(n, e), J(n, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.isEnabled,
              a = $(e, ["isEnabled"]);
          return n ? v.a.createElement(_e, a) : this.props.children;
        }
      }]), n;
    }(f.Component);

    Be.defaultProps = {
      isEnabled: !0
    };

    var qe,
        Ue,
        We = function We(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          a = n.isSearchable,
          t = n.isMulti,
          i = n.label;

      switch (e) {
        case "menu":
          return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.";

        case "input":
          return (i || "Select") + " is focused " + (a ? ",type to refine list" : "") + ", press Down to open the menu, " + (t ? " press left to focus selected values" : "");

        case "value":
          return "Use left and right to toggle between focused values, press Enter to remove the currently focused value";
      }
    },
        He = function He(e, n) {
      var a = n.value;
      if (a) switch (e) {
        case "deselect-option":
        case "pop-value":
        case "remove-value":
          return "option " + a + ", deselected.";

        case "select-option":
          return "option " + a + ", selected.";
      }
    },
        Ge = function (e) {
      function n() {
        return X(this, n), ee(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
      }

      return K(n, e), J(n, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.children,
              a = e.className,
              t = e.cx,
              i = e.isMulti,
              o = e.getStyles,
              s = e.hasValue,
              r = e.emotion;
          return v.a.createElement("div", {
            className: t(r.css(o("valueContainer", this.props)), {
              "value-container": !0,
              "value-container--is-multi": i,
              "value-container--has-value": s
            }, a)
          }, n);
        }
      }]), n;
    }(f.Component),
        Ye = (qe = ["@keyframes ", " {\n      0%, 80%, 100% { opacity: 0; }\n      40% { opacity: 1; }\n    };"], Ue = ["@keyframes ", " {\n      0%, 80%, 100% { opacity: 0; }\n      40% { opacity: 1; }\n    };"], Object.freeze(Object.defineProperties(qe, {
      raw: {
        value: Object.freeze(Ue)
      }
    }))),
        Xe = function Xe(e) {
      var n = e.size,
          a = e.emotion,
          t = $(e, ["size", "emotion"]);
      return v.a.createElement("svg", Z({
        height: n,
        width: n,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        className: a.css({
          display: "inline-block",
          fill: "currentColor",
          lineHeight: 1,
          stroke: "currentColor",
          strokeWidth: 0
        })
      }, t));
    },
        Je = function Je(e) {
      return v.a.createElement(Xe, Z({
        size: 20
      }, e), v.a.createElement("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
      }));
    },
        Qe = function Qe(e) {
      return v.a.createElement(Xe, Z({
        size: 20
      }, e), v.a.createElement("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
      }));
    },
        Ze = function Ze(e) {
      var n = e.isFocused,
          a = e.theme,
          t = a.spacing.baseUnit,
          i = a.colors;
      return {
        color: n ? i.neutral60 : i.neutral20,
        display: "flex",
        padding: 2 * t,
        transition: "color 150ms",
        ":hover": {
          color: n ? i.neutral80 : i.neutral40
        }
      };
    },
        Ke = Ze,
        $e = Ze,
        en = !1,
        nn = function nn(e) {
      var n = e.color,
          a = e.delay,
          t = e.offset,
          i = e.emotion;
      return v.a.createElement("span", {
        className: i.css({
          animationDuration: "1s",
          animationDelay: a + "ms",
          animationIterationCount: "infinite",
          animationName: "react-select-loading-indicator",
          animationTimingFunction: "ease-in-out",
          backgroundColor: n,
          borderRadius: "1em",
          display: "inline-block",
          marginLeft: t ? "1em" : null,
          height: "1em",
          verticalAlign: "top",
          width: "1em"
        })
      });
    },
        an = function an(e) {
      var n = e.className,
          a = e.cx,
          t = e.getStyles,
          i = e.innerProps,
          o = e.isFocused,
          s = e.isRtl,
          r = e.emotion,
          c = e.theme.colors,
          p = o ? c.neutral80 : c.neutral20;
      return en || (r.injectGlobal(Ye, "react-select-loading-indicator"), en = !0), v.a.createElement("div", Z({}, i, {
        className: a(r.css(t("loadingIndicator", e)), {
          indicator: !0,
          "loading-indicator": !0
        }, n)
      }), v.a.createElement(nn, {
        emotion: r,
        color: p,
        delay: 0,
        offset: s
      }), v.a.createElement(nn, {
        emotion: r,
        color: p,
        delay: 160,
        offset: !0
      }), v.a.createElement(nn, {
        emotion: r,
        color: p,
        delay: 320,
        offset: !s
      }));
    };

    an.defaultProps = {
      size: 4
    };

    var tn = function tn(e) {
      return {
        background: 0,
        border: 0,
        fontSize: "inherit",
        opacity: e ? 0 : 1,
        outline: 0,
        padding: 0,
        color: "inherit"
      };
    },
        on = function on(e) {
      var n = e.children,
          a = e.innerProps;
      return v.a.createElement("div", a, n);
    },
        sn = on,
        rn = on,
        cn = function (e) {
      function n() {
        return X(this, n), ee(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
      }

      return K(n, e), J(n, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.children,
              a = e.innerProps,
              t = e.emotion;
          return v.a.createElement("div", a, n || v.a.createElement(Je, {
            size: 14,
            emotion: t
          }));
        }
      }]), n;
    }(f.Component),
        pn = function (e) {
      function n() {
        return X(this, n), ee(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
      }

      return K(n, e), J(n, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.children,
              a = e.className,
              t = e.components,
              i = e.cx,
              o = e.data,
              s = e.getStyles,
              r = e.innerProps,
              c = e.isDisabled,
              p = e.removeProps,
              u = e.selectProps,
              l = e.emotion,
              d = t.Container,
              m = t.Label,
              f = t.Remove,
              h = Z({
            className: i(l.css(s("multiValue", this.props)), {
              "multi-value": !0,
              "multi-value--is-disabled": c
            }, a)
          }, r),
              x = {
            className: i(l.css(s("multiValueLabel", this.props)), {
              "multi-value__label": !0
            }, a)
          },
              b = Z({
            className: i(l.css(s("multiValueRemove", this.props)), {
              "multi-value__remove": !0
            }, a)
          }, p);
          return v.a.createElement(d, {
            data: o,
            innerProps: h,
            selectProps: u
          }, v.a.createElement(m, {
            data: o,
            innerProps: x,
            selectProps: u
          }, n), v.a.createElement(f, {
            data: o,
            innerProps: b,
            selectProps: u,
            emotion: l
          }));
        }
      }]), n;
    }(f.Component);

    pn.defaultProps = {
      cropWithEllipsis: !0
    };

    var un = {
      ClearIndicator: function ClearIndicator(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.innerProps,
            s = e.emotion;
        return v.a.createElement("div", Z({}, o, {
          className: t(s.css(i("clearIndicator", e)), {
            indicator: !0,
            "clear-indicator": !0
          }, a)
        }), n || v.a.createElement(Je, {
          emotion: s
        }));
      },
      Control: function Control(e) {
        var n = e.children,
            a = e.cx,
            t = e.getStyles,
            i = e.className,
            o = e.isDisabled,
            s = e.isFocused,
            r = e.innerRef,
            c = e.innerProps,
            p = e.emotion;
        return v.a.createElement("div", Z({
          ref: r,
          className: a(p.css(t("control", e)), {
            control: !0,
            "control--is-disabled": o,
            "control--is-focused": s
          }, i)
        }, c), n);
      },
      DropdownIndicator: function DropdownIndicator(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.innerProps,
            s = e.emotion;
        return v.a.createElement("div", Z({}, o, {
          className: t(s.css(i("dropdownIndicator", e)), {
            indicator: !0,
            "dropdown-indicator": !0
          }, a)
        }), n || v.a.createElement(Qe, {
          emotion: s
        }));
      },
      DownChevron: Qe,
      CrossIcon: Je,
      Group: function Group(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.Heading,
            s = e.headingProps,
            r = e.label,
            c = e.theme,
            p = e.emotion,
            u = e.selectProps;
        return v.a.createElement("div", {
          className: t(p.css(i("group", e)), {
            group: !0
          }, a)
        }, v.a.createElement(o, Z({}, s, {
          selectProps: u,
          emotion: p,
          theme: c,
          getStyles: i,
          cx: t
        }), r), v.a.createElement("div", null, n));
      },
      GroupHeading: function GroupHeading(e) {
        var n = e.className,
            a = e.cx,
            t = e.getStyles,
            i = e.theme,
            o = e.emotion,
            s = (e.selectProps, $(e, ["className", "cx", "getStyles", "theme", "emotion", "selectProps"]));
        return v.a.createElement("div", Z({
          className: a(o.css(t("groupHeading", Z({
            theme: i
          }, s))), {
            "group-heading": !0
          }, n)
        }, s));
      },
      IndicatorsContainer: function IndicatorsContainer(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.emotion;
        return v.a.createElement("div", {
          className: t(o.css(i("indicatorsContainer", e)), {
            indicators: !0
          }, a)
        }, n);
      },
      IndicatorSeparator: function IndicatorSeparator(e) {
        var n = e.className,
            a = e.cx,
            t = e.getStyles,
            i = e.innerProps,
            o = e.emotion;
        return v.a.createElement("span", Z({}, i, {
          className: a(o.css(t("indicatorSeparator", e)), {
            "indicator-separator": !0
          }, n)
        }));
      },
      Input: function Input(e) {
        var n = e.className,
            a = e.cx,
            t = e.getStyles,
            i = e.innerRef,
            o = e.isHidden,
            s = e.isDisabled,
            r = e.theme,
            c = e.emotion,
            p = (e.selectProps, $(e, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "emotion", "selectProps"]));
        return v.a.createElement("div", {
          className: c.css(t("input", Z({
            theme: r
          }, p)))
        }, v.a.createElement(U.a, Z({
          className: a(null, {
            input: !0
          }, n),
          inputRef: i,
          inputStyle: tn(o),
          disabled: s
        }, p)));
      },
      LoadingIndicator: an,
      Menu: function Menu(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.innerRef,
            s = e.innerProps,
            r = t(e.emotion.css(i("menu", e)), {
          menu: !0
        }, a);
        return v.a.createElement("div", Z({
          className: r
        }, s, {
          ref: o
        }), n);
      },
      MenuList: function MenuList(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.isMulti,
            s = e.innerRef,
            r = e.emotion;
        return v.a.createElement("div", {
          className: t(r.css(i("menuList", e)), {
            "menu-list": !0,
            "menu-list--is-multi": o
          }, a),
          ref: s
        }, n);
      },
      MenuPortal: be,
      LoadingMessage: xe,
      NoOptionsMessage: he,
      MultiValue: pn,
      MultiValueContainer: sn,
      MultiValueLabel: rn,
      MultiValueRemove: cn,
      Option: function Option(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.isDisabled,
            s = e.isFocused,
            r = e.isSelected,
            c = e.innerRef,
            p = e.innerProps,
            u = e.emotion;
        return v.a.createElement("div", Z({
          ref: c,
          className: t(u.css(i("option", e)), {
            option: !0,
            "option--is-disabled": o,
            "option--is-focused": s,
            "option--is-selected": r
          }, a)
        }, p), n);
      },
      Placeholder: function Placeholder(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.innerProps,
            s = e.emotion;
        return v.a.createElement("div", Z({
          className: t(s.css(i("placeholder", e)), {
            placeholder: !0
          }, a)
        }, o), n);
      },
      SelectContainer: function SelectContainer(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.innerProps,
            s = e.isDisabled,
            r = e.isRtl,
            c = e.emotion;
        return v.a.createElement("div", Z({
          className: t(c.css(i("container", e)), {
            "--is-disabled": s,
            "--is-rtl": r
          }, a)
        }, o), n);
      },
      SingleValue: function SingleValue(e) {
        var n = e.children,
            a = e.className,
            t = e.cx,
            i = e.getStyles,
            o = e.isDisabled,
            s = e.innerProps,
            r = e.emotion;
        return v.a.createElement("div", Z({
          className: t(r.css(i("singleValue", e)), {
            "single-value": !0,
            "single-value--is-disabled": o
          }, a)
        }, s), n);
      },
      ValueContainer: Ge
    },
        ln = function ln(e) {
      return Z({}, un, e.components);
    },
        dn = {
      clearIndicator: $e,
      container: function container(e) {
        var n = e.isDisabled;
        return {
          direction: e.isRtl ? "rtl" : null,
          pointerEvents: n ? "none" : null,
          position: "relative"
        };
      },
      control: function control(e) {
        var n = e.isDisabled,
            a = e.isFocused,
            t = e.theme,
            i = t.colors,
            o = t.borderRadius,
            s = t.spacing;
        return {
          alignItems: "center",
          backgroundColor: n ? i.neutral5 : i.neutral0,
          borderColor: n ? i.neutral10 : a ? i.primary : i.neutral20,
          borderRadius: o,
          borderStyle: "solid",
          borderWidth: 1,
          boxShadow: a ? "0 0 0 1px " + i.primary : null,
          cursor: "default",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          minHeight: s.controlHeight,
          outline: "0 !important",
          position: "relative",
          transition: "all 100ms",
          "&:hover": {
            borderColor: a ? i.primary : i.neutral30
          }
        };
      },
      dropdownIndicator: Ke,
      group: function group(e) {
        var n = e.theme.spacing;
        return {
          paddingBottom: 2 * n.baseUnit,
          paddingTop: 2 * n.baseUnit
        };
      },
      groupHeading: function groupHeading(e) {
        var n = e.theme.spacing;
        return {
          color: "#999",
          cursor: "default",
          display: "block",
          fontSize: "75%",
          fontWeight: "500",
          marginBottom: "0.25em",
          paddingLeft: 3 * n.baseUnit,
          paddingRight: 3 * n.baseUnit,
          textTransform: "uppercase"
        };
      },
      indicatorsContainer: function indicatorsContainer() {
        return {
          alignItems: "center",
          alignSelf: "stretch",
          display: "flex",
          flexShrink: 0
        };
      },
      indicatorSeparator: function indicatorSeparator(e) {
        var n = e.isDisabled,
            a = e.theme,
            t = a.spacing.baseUnit,
            i = a.colors;
        return {
          alignSelf: "stretch",
          backgroundColor: n ? i.neutral10 : i.neutral20,
          marginBottom: 2 * t,
          marginTop: 2 * t,
          width: 1
        };
      },
      input: function input(e) {
        var n = e.isDisabled,
            a = e.theme,
            t = a.spacing,
            i = a.colors;
        return {
          margin: t.baseUnit / 2,
          paddingBottom: t.baseUnit / 2,
          paddingTop: t.baseUnit / 2,
          visibility: n ? "hidden" : "visible",
          color: i.neutral80
        };
      },
      loadingIndicator: function loadingIndicator(e) {
        var n = e.isFocused,
            a = e.size,
            t = e.theme,
            i = t.colors,
            o = t.spacing.baseUnit;
        return {
          color: n ? i.neutral60 : i.neutral20,
          display: "flex",
          padding: 2 * o,
          transition: "color 150ms",
          alignSelf: "center",
          fontSize: a,
          lineHeight: 1,
          marginRight: a,
          textAlign: "center",
          verticalAlign: "middle"
        };
      },
      loadingMessage: ve,
      menu: function menu(e) {
        var n,
            a = e.placement,
            t = e.theme,
            i = t.borderRadius,
            o = t.spacing,
            s = t.colors;
        return Q(n = {}, function (e) {
          return e ? {
            bottom: "top",
            top: "bottom"
          }[e] : "bottom";
        }(a), "100%"), Q(n, "backgroundColor", s.neutral0), Q(n, "borderRadius", i), Q(n, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), Q(n, "marginBottom", o.menuGutter), Q(n, "marginTop", o.menuGutter), Q(n, "position", "absolute"), Q(n, "width", "100%"), Q(n, "zIndex", 1), n;
      },
      menuList: function menuList(e) {
        var n = e.maxHeight,
            a = e.theme.spacing.baseUnit;
        return {
          maxHeight: n,
          overflowY: "auto",
          paddingBottom: a,
          paddingTop: a,
          position: "relative",
          WebkitOverflowScrolling: "touch"
        };
      },
      menuPortal: function menuPortal(e) {
        var n = e.rect,
            a = e.offset,
            t = e.position;
        return {
          left: n.left,
          position: t,
          top: a,
          width: n.width,
          zIndex: 1
        };
      },
      multiValue: function multiValue(e) {
        var n = e.theme,
            a = n.spacing,
            t = n.borderRadius;
        return {
          backgroundColor: n.colors.neutral10,
          borderRadius: t / 2,
          display: "flex",
          margin: a.baseUnit / 2,
          minWidth: 0
        };
      },
      multiValueLabel: function multiValueLabel(e) {
        var n = e.theme,
            a = n.borderRadius,
            t = n.colors,
            i = e.cropWithEllipsis;
        return {
          borderRadius: a / 2,
          color: t.neutral80,
          fontSize: "85%",
          overflow: "hidden",
          padding: 3,
          paddingLeft: 6,
          textOverflow: i ? "ellipsis" : null,
          whiteSpace: "nowrap"
        };
      },
      multiValueRemove: function multiValueRemove(e) {
        var n = e.theme,
            a = n.spacing,
            t = n.borderRadius,
            i = n.colors;
        return {
          alignItems: "center",
          borderRadius: t / 2,
          backgroundColor: e.isFocused && i.dangerLight,
          display: "flex",
          paddingLeft: a.baseUnit,
          paddingRight: a.baseUnit,
          ":hover": {
            backgroundColor: i.dangerLight,
            color: i.danger
          }
        };
      },
      noOptionsMessage: fe,
      option: function option(e) {
        var n = e.isDisabled,
            a = e.isFocused,
            t = e.isSelected,
            i = e.theme,
            o = i.spacing,
            s = i.colors;
        return {
          backgroundColor: t ? s.primary : a ? s.primary25 : "transparent",
          color: n ? s.neutral20 : t ? s.neutral0 : "inherit",
          cursor: "default",
          display: "block",
          fontSize: "inherit",
          padding: 2 * o.baseUnit + "px " + 3 * o.baseUnit + "px",
          width: "100%",
          userSelect: "none",
          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
          ":active": {
            backgroundColor: t ? s.primary : s.primary50
          }
        };
      },
      placeholder: function placeholder(e) {
        var n = e.theme,
            a = n.spacing;
        return {
          color: n.colors.neutral50,
          marginLeft: a.baseUnit / 2,
          marginRight: a.baseUnit / 2,
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)"
        };
      },
      singleValue: function singleValue(e) {
        var n = e.isDisabled,
            a = e.theme,
            t = a.spacing,
            i = a.colors;
        return {
          color: n ? i.neutral40 : i.neutral80,
          marginLeft: t.baseUnit / 2,
          marginRight: t.baseUnit / 2,
          maxWidth: "calc(100% - " + 2 * t.baseUnit + "px)",
          overflow: "hidden",
          position: "absolute",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          top: "50%",
          transform: "translateY(-50%)"
        };
      },
      valueContainer: function valueContainer(e) {
        var n = e.theme.spacing;
        return {
          alignItems: "center",
          display: "flex",
          flex: 1,
          flexWrap: "wrap",
          padding: n.baseUnit / 2 + "px " + 2 * n.baseUnit + "px",
          WebkitOverflowScrolling: "touch",
          position: "relative",
          overflow: "hidden"
        };
      }
    };

    var mn,
        fn = {
      borderRadius: 4,
      colors: {
        primary: "#2684FF",
        primary75: "#4C9AFF",
        primary50: "#B2D4FF",
        primary25: "#DEEBFF",
        danger: "#DE350B",
        dangerLight: "#FFBDAD",
        neutral0: "hsl(0, 0%, 100%)",
        neutral5: "hsl(0, 0%, 95%)",
        neutral10: "hsl(0, 0%, 90%)",
        neutral20: "hsl(0, 0%, 80%)",
        neutral30: "hsl(0, 0%, 70%)",
        neutral40: "hsl(0, 0%, 60%)",
        neutral50: "hsl(0, 0%, 50%)",
        neutral60: "hsl(0, 0%, 40%)",
        neutral70: "hsl(0, 0%, 30%)",
        neutral80: "hsl(0, 0%, 20%)",
        neutral90: "hsl(0, 0%, 10%)"
      },
      spacing: {
        baseUnit: 4,
        controlHeight: 38,
        menuGutter: 8
      }
    },
        vn = {
      backspaceRemovesValue: !0,
      blurInputOnSelect: pe(),
      captureMenuScroll: !pe(),
      closeMenuOnSelect: !0,
      closeMenuOnScroll: !1,
      components: {},
      controlShouldRenderValue: !0,
      escapeClearsValue: !1,
      filterOption: function filterOption(e, n) {
        var a = Z({
          ignoreCase: !0,
          ignoreAccents: !0,
          stringify: Ae,
          trim: !0,
          matchFrom: "any"
        }, mn),
            t = a.ignoreCase,
            i = a.ignoreAccents,
            o = a.stringify,
            s = a.trim,
            r = a.matchFrom,
            c = s ? Ce(n) : n,
            p = s ? Ce(o(e)) : o(e);
        return t && (c = c.toLowerCase(), p = p.toLowerCase()), i && (c = Oe(c), p = Oe(p)), "start" === r ? p.substr(0, c.length) === c : p.indexOf(c) > -1;
      },
      formatGroupLabel: function formatGroupLabel(e) {
        return e.label;
      },
      getOptionLabel: function getOptionLabel(e) {
        return e.label;
      },
      getOptionValue: function getOptionValue(e) {
        return e.value;
      },
      isDisabled: !1,
      isLoading: !1,
      isMulti: !1,
      isRtl: !1,
      isSearchable: !0,
      isOptionDisabled: function isOptionDisabled(e) {
        return !!e.isDisabled;
      },
      loadingMessage: function loadingMessage() {
        return "Loading...";
      },
      maxMenuHeight: 300,
      minMenuHeight: 140,
      menuIsOpen: !1,
      menuPlacement: "bottom",
      menuPosition: "absolute",
      menuShouldBlockScroll: !1,
      menuShouldScrollIntoView: !function () {
        try {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
          return !1;
        }
      }(),
      noOptionsMessage: function noOptionsMessage() {
        return "No options";
      },
      openMenuOnFocus: !1,
      openMenuOnClick: !0,
      options: [],
      pageSize: 5,
      placeholder: "Select...",
      screenReaderStatus: function screenReaderStatus(e) {
        var n = e.count;
        return n + " result" + (1 !== n ? "s" : "") + " available";
      },
      styles: {},
      tabIndex: "0",
      tabSelectsValue: !0
    },
        hn = 1,
        xn = H(function (e) {
      return B(e ? {
        nonce: e
      } : {});
    }),
        bn = function (e) {
      function n(e) {
        X(this, n);
        var a = ee(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
        gn.call(a);
        var t = e.value;
        a.cacheComponents = H(a.cacheComponents, Ee).bind(a), a.cacheComponents(e.components), a.instancePrefix = "react-select-" + (a.props.instanceId || ++hn);
        var i = ie(t),
            o = a.buildMenuOptions(e, i);
        return a.emotion = xn(e.nonce), a.state.menuOptions = o, a.state.selectValue = i, a;
      }

      return K(n, e), J(n, [{
        key: "componentDidMount",
        value: function value() {
          this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput();
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var n = this.props,
              a = n.options,
              t = n.value,
              i = n.inputValue;

          if (this.cacheComponents(e.components), e.value !== t || e.options !== a || e.inputValue !== i) {
            var o = ie(e.value),
                s = this.buildMenuOptions(e, o),
                r = this.getNextFocusedValue(o),
                c = this.getNextFocusedOption(s.focusable);
            this.setState({
              menuOptions: s,
              selectValue: o,
              focusedOption: c,
              focusedValue: r
            });
          }

          null != this.inputIsHiddenAfterUpdate && (this.setState({
            inputIsHidden: this.inputIsHiddenAfterUpdate
          }), delete this.inputIsHiddenAfterUpdate);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          var n = this.props,
              a = n.isDisabled,
              t = n.menuIsOpen,
              i = this.state.isFocused;
          (i && !a && e.isDisabled || i && t && !e.menuIsOpen) && this.focusInput(), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && function (e, n) {
            var a = e.getBoundingClientRect(),
                t = n.getBoundingClientRect(),
                i = n.offsetHeight / 3;
            t.bottom + i > a.bottom ? re(e, Math.min(n.offsetTop + n.clientHeight - e.offsetHeight + i, e.scrollHeight)) : t.top - i < a.top && re(e, Math.max(n.offsetTop - i, 0));
          }(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1;
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
        }
      }, {
        key: "onMenuOpen",
        value: function value() {
          this.props.onMenuOpen();
        }
      }, {
        key: "onMenuClose",
        value: function value() {
          var e = this.props,
              n = e.isSearchable,
              a = e.isMulti;
          this.announceAriaLiveContext({
            event: "input",
            context: {
              isSearchable: n,
              isMulti: a
            }
          }), this.onInputChange("", {
            action: "menu-close"
          }), this.props.onMenuClose();
        }
      }, {
        key: "onInputChange",
        value: function value(e, n) {
          this.props.onInputChange(e, n);
        }
      }, {
        key: "focusInput",
        value: function value() {
          this.inputRef && this.inputRef.focus();
        }
      }, {
        key: "blurInput",
        value: function value() {
          this.inputRef && this.inputRef.blur();
        }
      }, {
        key: "openMenu",
        value: function value(e) {
          var n = this.state,
              a = n.menuOptions,
              t = n.selectValue,
              i = this.props.isMulti,
              o = "first" === e ? 0 : a.focusable.length - 1;

          if (!i) {
            var s = a.focusable.indexOf(t[0]);
            s > -1 && (o = s);
          }

          this.scrollToFocusedOptionOnUpdate = !0, this.inputIsHiddenAfterUpdate = !1, this.onMenuOpen(), this.setState({
            focusedValue: null,
            focusedOption: a.focusable[o]
          }), this.announceAriaLiveContext({
            event: "menu"
          });
        }
      }, {
        key: "focusValue",
        value: function value(e) {
          var n = this.props,
              a = n.isMulti,
              t = n.isSearchable,
              i = this.state,
              o = i.selectValue,
              s = i.focusedValue;

          if (a) {
            this.setState({
              focusedOption: null
            });
            var r = o.indexOf(s);
            s || (r = -1, this.announceAriaLiveContext({
              event: "value"
            }));
            var c = o.length - 1,
                p = -1;

            if (o.length) {
              switch (e) {
                case "previous":
                  p = 0 === r ? 0 : -1 === r ? c : r - 1;
                  break;

                case "next":
                  r > -1 && r < c && (p = r + 1);
              }

              -1 === p && this.announceAriaLiveContext({
                event: "input",
                context: {
                  isSearchable: t,
                  isMulti: a
                }
              }), this.setState({
                inputIsHidden: -1 !== p,
                focusedValue: o[p]
              });
            }
          }
        }
      }, {
        key: "focusOption",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "first",
              n = this.props.pageSize,
              a = this.state,
              t = a.focusedOption,
              i = a.menuOptions.focusable;

          if (i.length) {
            var o = 0,
                s = i.indexOf(t);
            t || (s = -1, this.announceAriaLiveContext({
              event: "menu"
            })), "up" === e ? o = s > 0 ? s - 1 : i.length - 1 : "down" === e ? o = (s + 1) % i.length : "pageup" === e ? (o = s - n) < 0 && (o = 0) : "pagedown" === e ? (o = s + n) > i.length - 1 && (o = i.length - 1) : "last" === e && (o = i.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
              focusedOption: i[o],
              focusedValue: null
            });
          }
        }
      }, {
        key: "getTheme",
        value: function value() {
          return this.props.theme ? "function" === typeof this.props.theme ? this.props.theme(fn) : Z({}, fn, this.props.theme) : fn;
        }
      }, {
        key: "getCommonProps",
        value: function value() {
          var e = this.clearValue,
              n = this.getStyles,
              a = this.setValue,
              t = this.selectOption,
              i = this.props,
              o = i.classNamePrefix,
              s = i.isMulti,
              r = i.isRtl,
              c = i.options,
              p = this.state.selectValue,
              u = this.hasValue();
          return {
            cx: function (e, n, a, t) {
              var i = [n, t];
              if (a && e) for (var o in a) {
                a.hasOwnProperty(o) && a[o] && i.push("" + te(e, o));
              }
              return i.filter(function (e) {
                return e;
              }).map(function (e) {
                return String(e).trim();
              }).join(" ");
            }.bind(null, o),
            clearValue: e,
            getStyles: n,
            getValue: function getValue() {
              return p;
            },
            hasValue: u,
            isMulti: s,
            isRtl: r,
            options: c,
            selectOption: t,
            setValue: a,
            selectProps: i,
            theme: this.getTheme(),
            emotion: this.emotion
          };
        }
      }, {
        key: "getNextFocusedValue",
        value: function value(e) {
          if (this.clearFocusValueOnUpdate) return this.clearFocusValueOnUpdate = !1, null;
          var n = this.state,
              a = n.focusedValue,
              t = n.selectValue.indexOf(a);

          if (t > -1) {
            if (e.indexOf(a) > -1) return a;
            if (t < e.length) return e[t];
          }

          return null;
        }
      }, {
        key: "getNextFocusedOption",
        value: function value(e) {
          var n = this.state.focusedOption;
          return n && e.indexOf(n) > -1 ? n : e[0];
        }
      }, {
        key: "hasValue",
        value: function value() {
          return this.state.selectValue.length > 0;
        }
      }, {
        key: "hasOptions",
        value: function value() {
          return !!this.state.menuOptions.render.length;
        }
      }, {
        key: "countOptions",
        value: function value() {
          return this.state.menuOptions.focusable.length;
        }
      }, {
        key: "isClearable",
        value: function value() {
          var e = this.props,
              n = e.isClearable,
              a = e.isMulti;
          return void 0 === n ? a : n;
        }
      }, {
        key: "isOptionDisabled",
        value: function value(e, n) {
          return "function" === typeof this.props.isOptionDisabled && this.props.isOptionDisabled(e, n);
        }
      }, {
        key: "isOptionSelected",
        value: function value(e, n) {
          var a = this;
          if (n.indexOf(e) > -1) return !0;
          if ("function" === typeof this.props.isOptionSelected) return this.props.isOptionSelected(e, n);
          var t = this.getOptionValue(e);
          return n.some(function (e) {
            return a.getOptionValue(e) === t;
          });
        }
      }, {
        key: "filterOption",
        value: function value(e, n) {
          return !this.props.filterOption || this.props.filterOption(e, n);
        }
      }, {
        key: "formatOptionLabel",
        value: function value(e, n) {
          if ("function" === typeof this.props.formatOptionLabel) {
            var a = this.props.inputValue,
                t = this.state.selectValue;
            return this.props.formatOptionLabel(e, {
              context: n,
              inputValue: a,
              selectValue: t
            });
          }

          return this.getOptionLabel(e);
        }
      }, {
        key: "formatGroupLabel",
        value: function value(e) {
          return this.props.formatGroupLabel(e);
        }
      }, {
        key: "startListeningComposition",
        value: function value() {
          document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
        }
      }, {
        key: "stopListeningComposition",
        value: function value() {
          document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
        }
      }, {
        key: "startListeningToTouch",
        value: function value() {
          document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
        }
      }, {
        key: "stopListeningToTouch",
        value: function value() {
          document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
        }
      }, {
        key: "buildMenuOptions",
        value: function value(e, n) {
          var a = this,
              t = e.inputValue,
              i = void 0 === t ? "" : t,
              o = e.options,
              s = function s(e, t) {
            var o = a.isOptionDisabled(e, n),
                s = a.isOptionSelected(e, n),
                r = a.getOptionLabel(e),
                c = a.getOptionValue(e);

            if (!(a.shouldHideSelectedOptions() && s || !a.filterOption({
              label: r,
              value: c,
              data: e
            }, i))) {
              var p = o ? void 0 : function () {
                return a.onOptionHover(e);
              },
                  u = o ? void 0 : function () {
                return a.selectOption(e);
              },
                  l = a.getElementId("option") + "-" + t;
              return {
                innerProps: {
                  id: l,
                  onClick: u,
                  onMouseMove: p,
                  onMouseOver: p,
                  role: "option",
                  tabIndex: -1
                },
                data: e,
                isDisabled: o,
                isSelected: s,
                key: l,
                label: r,
                type: "option",
                value: c
              };
            }
          };

          return o.reduce(function (e, n, t) {
            if (n.options) {
              a.hasGroups || (a.hasGroups = !0);
              var i = n.options.map(function (n, a) {
                var i = s(n, t + "-" + a);
                return i && !i.isDisabled && e.focusable.push(n), i;
              }).filter(Boolean);

              if (i.length) {
                var o = a.getElementId("group") + "-" + t;
                e.render.push({
                  type: "group",
                  key: o,
                  data: n,
                  options: i
                });
              }
            } else {
              var r = s(n, "" + t);
              r && (e.render.push(r), r.isDisabled || e.focusable.push(n));
            }

            return e;
          }, {
            render: [],
            focusable: []
          });
        }
      }, {
        key: "constructAriaLiveMessage",
        value: function value() {
          var e = this.state,
              n = e.ariaLiveContext,
              a = e.selectValue,
              t = e.focusedValue,
              i = e.focusedOption,
              o = this.props,
              s = o.options,
              r = o.menuIsOpen,
              c = o.inputValue,
              p = o.screenReaderStatus;
          return (t ? function (e) {
            var n = e.focusedValue,
                a = e.getOptionLabel,
                t = e.selectValue;
            return "value " + a(n) + " focused, " + (t.indexOf(n) + 1) + " of " + t.length + ".";
          }({
            focusedValue: t,
            getOptionLabel: this.getOptionLabel,
            selectValue: a
          }) : "") + " " + (i && r ? function (e) {
            var n = e.focusedOption,
                a = e.getOptionLabel,
                t = e.options;
            return "option " + a(n) + " focused, " + (t.indexOf(n) + 1) + " of " + t.length + ".";
          }({
            focusedOption: i,
            getOptionLabel: this.getOptionLabel,
            options: s
          }) : "") + " " + function (e) {
            var n = e.inputValue;
            return e.screenReaderMessage + (n ? " for search term " + n : "") + ".";
          }({
            inputValue: c,
            screenReaderMessage: p({
              count: this.countOptions()
            })
          }) + " " + n;
        }
      }, {
        key: "renderInput",
        value: function value() {
          var e = this.props,
              n = e.isDisabled,
              a = e.isSearchable,
              t = e.inputId,
              i = e.inputValue,
              o = e.tabIndex,
              s = this.components.Input,
              r = this.state.inputIsHidden,
              c = t || this.getElementId("input");
          if (!a) return v.a.createElement(Se, {
            id: c,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: ae,
            onFocus: this.onInputFocus,
            readOnly: !0,
            disabled: n,
            tabIndex: o,
            value: "",
            emotion: this.emotion
          });
          var p = {
            "aria-autocomplete": "list",
            "aria-label": this.props["aria-label"],
            "aria-labelledby": this.props["aria-labelledby"]
          },
              u = this.commonProps,
              l = u.cx,
              d = u.theme,
              m = u.selectProps;
          return v.a.createElement(s, Z({
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            cx: l,
            getStyles: this.getStyles,
            id: c,
            innerRef: this.getInputRef,
            isDisabled: n,
            isHidden: r,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            selectProps: m,
            spellCheck: "false",
            tabIndex: o,
            theme: d,
            type: "text",
            value: i,
            emotion: this.emotion
          }, p));
        }
      }, {
        key: "renderPlaceholderOrValue",
        value: function value() {
          var e = this,
              n = this.components,
              a = n.MultiValue,
              t = n.MultiValueContainer,
              i = n.MultiValueLabel,
              o = n.MultiValueRemove,
              s = n.SingleValue,
              r = n.Placeholder,
              c = this.commonProps,
              p = this.props,
              u = p.controlShouldRenderValue,
              l = p.isDisabled,
              d = p.isMulti,
              m = p.inputValue,
              f = p.placeholder,
              h = this.state,
              x = h.selectValue,
              b = h.focusedValue,
              g = h.isFocused;
          if (!this.hasValue() || !u) return m ? null : v.a.createElement(r, Z({}, c, {
            key: "placeholder",
            isDisabled: l,
            isFocused: g
          }), f);
          if (d) return x.map(function (n) {
            var s = n === b;
            return v.a.createElement(a, Z({}, c, {
              components: {
                Container: t,
                Label: i,
                Remove: o
              },
              isFocused: s,
              isDisabled: l,
              key: e.getOptionValue(n),
              removeProps: {
                onClick: function onClick() {
                  return e.removeValue(n);
                },
                onTouchEnd: function onTouchEnd() {
                  return e.removeValue(n);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault(), e.stopPropagation();
                }
              },
              data: n
            }), e.formatOptionLabel(n, "value"));
          });
          if (m) return null;
          var y = x[0];
          return v.a.createElement(s, Z({}, c, {
            data: y,
            isDisabled: l
          }), this.formatOptionLabel(y, "value"));
        }
      }, {
        key: "renderClearIndicator",
        value: function value() {
          var e = this.components.ClearIndicator,
              n = this.commonProps,
              a = this.props,
              t = a.isDisabled,
              i = a.isLoading,
              o = this.state.isFocused;
          if (!this.isClearable() || !e || t || !this.hasValue() || i) return null;
          var s = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            "aria-hidden": "true"
          };
          return v.a.createElement(e, Z({}, n, {
            innerProps: s,
            isFocused: o
          }));
        }
      }, {
        key: "renderLoadingIndicator",
        value: function value() {
          var e = this.components.LoadingIndicator,
              n = this.commonProps,
              a = this.props,
              t = a.isDisabled,
              i = a.isLoading,
              o = this.state.isFocused;
          if (!e || !i) return null;
          return v.a.createElement(e, Z({}, n, {
            innerProps: {
              "aria-hidden": "true"
            },
            isDisabled: t,
            isFocused: o
          }));
        }
      }, {
        key: "renderIndicatorSeparator",
        value: function value() {
          var e = this.components,
              n = e.DropdownIndicator,
              a = e.IndicatorSeparator;
          if (!n || !a) return null;
          var t = this.commonProps,
              i = this.props.isDisabled,
              o = this.state.isFocused;
          return v.a.createElement(a, Z({}, t, {
            isDisabled: i,
            isFocused: o
          }));
        }
      }, {
        key: "renderDropdownIndicator",
        value: function value() {
          var e = this.components.DropdownIndicator;
          if (!e) return null;
          var n = this.commonProps,
              a = this.props.isDisabled,
              t = this.state.isFocused,
              i = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            "aria-hidden": "true"
          };
          return v.a.createElement(e, Z({}, n, {
            innerProps: i,
            isDisabled: a,
            isFocused: t
          }));
        }
      }, {
        key: "renderMenu",
        value: function value() {
          var e = this,
              n = this.components,
              a = n.Group,
              t = n.GroupHeading,
              i = n.Menu,
              o = n.MenuList,
              s = n.MenuPortal,
              r = n.LoadingMessage,
              c = n.NoOptionsMessage,
              p = n.Option,
              u = this.commonProps,
              l = this.state,
              d = l.focusedOption,
              m = l.menuOptions,
              f = this.props,
              h = f.captureMenuScroll,
              x = f.inputValue,
              b = f.isLoading,
              g = f.loadingMessage,
              y = f.minMenuHeight,
              w = f.maxMenuHeight,
              E = f.menuIsOpen,
              k = f.menuPlacement,
              O = f.menuPosition,
              C = f.menuPortalTarget,
              A = f.menuShouldBlockScroll,
              j = f.menuShouldScrollIntoView,
              S = f.noOptionsMessage,
              F = f.onMenuScrollToTop,
              D = f.onMenuScrollToBottom;
          if (!E) return null;

          var P = function P(n) {
            var a = d === n.data;
            return n.innerRef = a ? e.getFocusedOptionRef : void 0, v.a.createElement(p, Z({}, u, n, {
              isFocused: a
            }), e.formatOptionLabel(n.data, "menu"));
          },
              M = void 0;

          if (this.hasOptions()) M = m.render.map(function (n) {
            if ("group" === n.type) {
              n.type;
              var i = $(n, ["type"]),
                  o = n.key + "-heading";
              return v.a.createElement(a, Z({}, u, i, {
                Heading: t,
                headingProps: {
                  id: o
                },
                label: e.formatGroupLabel(n.data)
              }), n.options.map(function (e) {
                return P(e);
              }));
            }

            if ("option" === n.type) return P(n);
          });else if (b) {
            var I = g({
              inputValue: x
            });
            if (null === I) return null;
            M = v.a.createElement(r, u, I);
          } else {
            var T = S({
              inputValue: x
            });
            if (null === T) return null;
            M = v.a.createElement(c, u, T);
          }
          var L = {
            minMenuHeight: y,
            maxMenuHeight: w,
            menuPlacement: k,
            menuPosition: O,
            menuShouldScrollIntoView: j
          },
              R = v.a.createElement(de, Z({}, u, L), function (n) {
            var a = n.ref,
                t = n.placerProps,
                s = t.placement,
                r = t.maxHeight;
            return v.a.createElement(i, Z({}, u, L, {
              innerRef: a,
              innerProps: {
                onMouseDown: e.onMenuMouseDown,
                onMouseMove: e.onMenuMouseMove
              },
              isLoading: b,
              placement: s
            }), v.a.createElement(Be, {
              isEnabled: h,
              onTopArrive: F,
              onBottomArrive: D
            }, v.a.createElement(ze, {
              emotion: e.emotion,
              isEnabled: A
            }, v.a.createElement(o, Z({}, u, {
              innerRef: e.getMenuListRef,
              isLoading: b,
              maxHeight: r
            }), M))));
          });
          return C || "fixed" === O ? v.a.createElement(s, Z({}, u, {
            appendTo: C,
            controlElement: this.controlRef,
            menuPlacement: k,
            menuPosition: O
          }), R) : R;
        }
      }, {
        key: "renderFormField",
        value: function value() {
          var e = this,
              n = this.props,
              a = n.delimiter,
              t = n.isDisabled,
              i = n.isMulti,
              o = n.name,
              s = this.state.selectValue;

          if (o && !t) {
            if (i) {
              if (a) {
                var r = s.map(function (n) {
                  return e.getOptionValue(n);
                }).join(a);
                return v.a.createElement("input", {
                  name: o,
                  type: "hidden",
                  value: r
                });
              }

              var c = s.length > 0 ? s.map(function (n, a) {
                return v.a.createElement("input", {
                  key: "i-" + a,
                  name: o,
                  type: "hidden",
                  value: e.getOptionValue(n)
                });
              }) : v.a.createElement("input", {
                name: o,
                type: "hidden"
              });
              return v.a.createElement("div", null, c);
            }

            var p = s[0] ? this.getOptionValue(s[0]) : "";
            return v.a.createElement("input", {
              name: o,
              type: "hidden",
              value: p
            });
          }
        }
      }, {
        key: "renderLiveRegion",
        value: function value() {
          return this.state.isFocused ? v.a.createElement(je, {
            emotion: this.emotion,
            "aria-live": "assertive"
          }, v.a.createElement("p", {
            id: "aria-selection-event"
          }, "\xa0", this.state.ariaLiveSelection), v.a.createElement("p", {
            id: "aria-context"
          }, "\xa0", this.constructAriaLiveMessage())) : null;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.components,
              n = e.Control,
              a = e.IndicatorsContainer,
              t = e.SelectContainer,
              i = e.ValueContainer,
              o = this.props,
              s = o.className,
              r = o.id,
              c = o.isDisabled,
              p = this.state.isFocused,
              u = this.commonProps = this.getCommonProps();
          return v.a.createElement(t, Z({}, u, {
            className: s,
            innerProps: {
              id: r,
              onKeyDown: this.onKeyDown
            },
            isDisabled: c,
            isFocused: p
          }), this.renderLiveRegion(), v.a.createElement(n, Z({}, u, {
            innerRef: this.getControlRef,
            innerProps: {
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: c,
            isFocused: p
          }), v.a.createElement(i, Z({}, u, {
            isDisabled: c
          }), this.renderPlaceholderOrValue(), this.renderInput()), v.a.createElement(a, Z({}, u, {
            isDisabled: c
          }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
      }]), n;
    }(f.Component);

    bn.defaultProps = vn;

    var gn = function gn() {
      var e = this;
      this.state = {
        ariaLiveSelection: "",
        ariaLiveContext: "",
        focusedOption: null,
        focusedValue: null,
        inputIsHidden: !1,
        isFocused: !1,
        isComposing: !1,
        menuOptions: {
          render: [],
          focusable: []
        },
        selectValue: []
      }, this.blockOptionHover = !1, this.clearFocusValueOnUpdate = !1, this.hasGroups = !1, this.initialTouchX = 0, this.initialTouchY = 0, this.instancePrefix = "", this.openAfterFocus = !1, this.scrollToFocusedOptionOnUpdate = !1, this.controlRef = null, this.getControlRef = function (n) {
        e.controlRef = n;
      }, this.focusedOptionRef = null, this.getFocusedOptionRef = function (n) {
        e.focusedOptionRef = n;
      }, this.menuListRef = null, this.getMenuListRef = function (n) {
        e.menuListRef = n;
      }, this.inputRef = null, this.getInputRef = function (n) {
        e.inputRef = n;
      }, this.cacheComponents = function (n) {
        e.components = ln({
          components: n
        });
      }, this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = function (n, a) {
        var t = e.props,
            i = t.onChange,
            o = t.name;
        i(n, Z({}, a, {
          name: o
        }));
      }, this.setValue = function (n) {
        var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "set-value",
            t = arguments[2],
            i = e.props,
            o = i.closeMenuOnSelect,
            s = i.isMulti;
        e.onInputChange("", {
          action: "set-value"
        }), o && (e.inputIsHiddenAfterUpdate = !s, e.onMenuClose()), e.clearFocusValueOnUpdate = !0, e.onChange(n, {
          action: a,
          option: t
        });
      }, this.selectOption = function (n) {
        var a = e.props,
            t = a.blurInputOnSelect;

        if (a.isMulti) {
          var i = e.state.selectValue;

          if (e.isOptionSelected(n, i)) {
            var o = e.getOptionValue(n);
            e.setValue(i.filter(function (n) {
              return e.getOptionValue(n) !== o;
            }), "deselect-option", n), e.announceAriaLiveSelection({
              event: "deselect-option",
              context: {
                value: e.getOptionLabel(n)
              }
            });
          } else e.setValue([].concat(ne(i), [n]), "select-option", n), e.announceAriaLiveSelection({
            event: "select-option",
            context: {
              value: e.getOptionLabel(n)
            }
          });
        } else e.setValue(n, "select-option"), e.announceAriaLiveSelection({
          event: "select-option",
          context: {
            value: e.getOptionLabel(n)
          }
        });

        t && e.blurInput();
      }, this.removeValue = function (n) {
        var a = e.state.selectValue,
            t = e.getOptionValue(n);
        e.onChange(a.filter(function (n) {
          return e.getOptionValue(n) !== t;
        }), {
          action: "remove-value",
          removedValue: n
        }), e.announceAriaLiveSelection({
          event: "remove-value",
          context: {
            value: n ? e.getOptionLabel(n) : void 0
          }
        }), e.focusInput();
      }, this.clearValue = function () {
        var n = e.props.isMulti;
        e.onChange(n ? [] : null, {
          action: "clear"
        });
      }, this.popValue = function () {
        var n = e.state.selectValue,
            a = n[n.length - 1];
        e.announceAriaLiveSelection({
          event: "pop-value",
          context: {
            value: a ? e.getOptionLabel(a) : void 0
          }
        }), e.onChange(n.slice(0, n.length - 1), {
          action: "pop-value",
          removedValue: a
        });
      }, this.getOptionLabel = function (n) {
        return e.props.getOptionLabel(n);
      }, this.getOptionValue = function (n) {
        return e.props.getOptionValue(n);
      }, this.getStyles = function (n, a) {
        var t = dn[n](a);
        t.boxSizing = "border-box";
        var i = e.props.styles[n];
        return i ? i(t, a) : t;
      }, this.getElementId = function (n) {
        return e.instancePrefix + "-" + n;
      }, this.getActiveDescendentId = function () {
        var n = e.props.menuIsOpen,
            a = e.state,
            t = a.menuOptions,
            i = a.focusedOption;

        if (i && n) {
          var o = t.focusable.indexOf(i),
              s = t.render[o];
          return s && s.key;
        }
      }, this.announceAriaLiveSelection = function (n) {
        var a = n.event,
            t = n.context;
        e.setState({
          ariaLiveSelection: He(a, t)
        });
      }, this.announceAriaLiveContext = function (n) {
        var a = n.event,
            t = n.context;
        e.setState({
          ariaLiveContext: We(a, Z({}, t, {
            label: e.props["aria-label"]
          }))
        });
      }, this.onMenuMouseDown = function (n) {
        0 === n.button && (n.stopPropagation(), n.preventDefault(), e.focusInput());
      }, this.onMenuMouseMove = function (n) {
        e.blockOptionHover = !1;
      }, this.onControlMouseDown = function (n) {
        var a = e.props.openMenuOnClick;
        e.state.isFocused ? e.props.menuIsOpen ? "INPUT" !== n.target.tagName && e.onMenuClose() : e.openMenu("first") : (a && (e.openAfterFocus = !0), e.focusInput()), "INPUT" !== n.target.tagName && n.preventDefault();
      }, this.onDropdownIndicatorMouseDown = function (n) {
        if ((!n || "mousedown" !== n.type || 0 === n.button) && !e.props.isDisabled) {
          var a = e.props,
              t = a.isMulti,
              i = a.menuIsOpen;
          e.focusInput(), i ? (e.inputIsHiddenAfterUpdate = !t, e.onMenuClose()) : e.openMenu("first"), n.preventDefault(), n.stopPropagation();
        }
      }, this.onClearIndicatorMouseDown = function (n) {
        n && "mousedown" === n.type && 0 !== n.button || (e.clearValue(), n.stopPropagation(), e.openAfterFocus = !1, setTimeout(function () {
          return e.focusInput();
        }));
      }, this.onScroll = function (n) {
        "boolean" === typeof e.props.closeMenuOnScroll ? n.target instanceof HTMLElement && oe(n.target) && e.props.onMenuClose() : "function" === typeof e.props.closeMenuOnScroll && e.props.closeMenuOnScroll(n) && e.props.onMenuClose();
      }, this.onCompositionStart = function () {
        e.setState({
          isComposing: !0
        });
      }, this.onCompositionEnd = function () {
        e.setState({
          isComposing: !1
        });
      }, this.onTouchStart = function (n) {
        var a = n.touches.item(0);
        a && (e.initialTouchX = a.clientX, e.initialTouchY = a.clientY, e.userIsDragging = !1);
      }, this.onTouchMove = function (n) {
        var a = n.touches.item(0);

        if (a) {
          var t = Math.abs(a.clientX - e.initialTouchX),
              i = Math.abs(a.clientY - e.initialTouchY);
          e.userIsDragging = t > 5 || i > 5;
        }
      }, this.onTouchEnd = function (n) {
        if (!e.userIsDragging) {
          var a = n.target;
          e.controlRef && !e.controlRef.contains(a) && e.menuListRef && !e.menuListRef.contains(a) && e.blurInput(), e.initialTouchX = 0, e.initialTouchY = 0;
        }
      }, this.onControlTouchEnd = function (n) {
        e.userIsDragging || e.onControlMouseDown(n);
      }, this.onClearIndicatorTouchEnd = function (n) {
        e.userIsDragging || e.onClearIndicatorMouseDown(n);
      }, this.onDropdownIndicatorTouchEnd = function (n) {
        e.userIsDragging || e.onDropdownIndicatorMouseDown(n);
      }, this.handleInputChange = function (n) {
        var a = n.currentTarget.value;
        e.inputIsHiddenAfterUpdate = !1, e.onInputChange(a, {
          action: "input-change"
        }), e.onMenuOpen();
      }, this.onInputFocus = function (n) {
        var a = e.props,
            t = a.isSearchable,
            i = a.isMulti;
        e.props.onFocus && e.props.onFocus(n), e.inputIsHiddenAfterUpdate = !1, e.announceAriaLiveContext({
          event: "input",
          context: {
            isSearchable: t,
            isMulti: i
          }
        }), e.setState({
          isFocused: !0
        }), (e.openAfterFocus || e.props.openMenuOnFocus) && e.openMenu("first"), e.openAfterFocus = !1;
      }, this.onInputBlur = function (n) {
        e.menuListRef && e.menuListRef.contains(document.activeElement) ? e.inputRef.focus() : (e.props.onBlur && e.props.onBlur(n), e.onInputChange("", {
          action: "input-blur"
        }), e.onMenuClose(), e.setState({
          focusedValue: null,
          isFocused: !1
        }));
      }, this.onOptionHover = function (n) {
        e.blockOptionHover || e.state.focusedOption === n || e.setState({
          focusedOption: n
        });
      }, this.shouldHideSelectedOptions = function () {
        var n = e.props,
            a = n.hideSelectedOptions,
            t = n.isMulti;
        return void 0 === a ? t : a;
      }, this.onKeyDown = function (n) {
        var a = e.props,
            t = a.isMulti,
            i = a.backspaceRemovesValue,
            o = a.escapeClearsValue,
            s = a.inputValue,
            r = a.isClearable,
            c = a.isDisabled,
            p = a.menuIsOpen,
            u = a.onKeyDown,
            l = a.tabSelectsValue,
            d = a.openMenuOnFocus,
            m = e.state,
            f = m.isComposing,
            v = m.focusedOption,
            h = m.focusedValue,
            x = m.selectValue;

        if (!c && ("function" !== typeof u || (u(n), !n.defaultPrevented))) {
          switch (e.blockOptionHover = !0, n.key) {
            case "ArrowLeft":
              if (!t || s) return;
              e.focusValue("previous");
              break;

            case "ArrowRight":
              if (!t || s) return;
              e.focusValue("next");
              break;

            case "Delete":
            case "Backspace":
              if (s) return;
              if (h) e.removeValue(h);else {
                if (!i) return;
                t ? e.popValue() : r && e.clearValue();
              }
              break;

            case "Tab":
              if (f) return;
              if (n.shiftKey || !p || !l || !v || d && e.isOptionSelected(v, x)) return;
              e.selectOption(v);
              break;

            case "Enter":
              if (p) {
                if (!v) return;
                if (f) return;
                e.selectOption(v);
              } else e.focusOption("first");

              break;

            case "Escape":
              p ? (e.inputIsHiddenAfterUpdate = !1, e.onInputChange("", {
                action: "menu-close"
              }), e.onMenuClose()) : r && o && e.clearValue();
              break;

            case " ":
              if (s) return;

              if (!p) {
                e.openMenu("first");
                break;
              }

              if (!v) return;
              e.selectOption(v);
              break;

            case "ArrowUp":
              p ? e.focusOption("up") : e.openMenu("last");
              break;

            case "ArrowDown":
              p ? e.focusOption("down") : e.openMenu("first");
              break;

            case "PageUp":
              if (!p) return;
              e.focusOption("pageup");
              break;

            case "PageDown":
              if (!p) return;
              e.focusOption("pagedown");
              break;

            case "Home":
              if (!p) return;
              e.focusOption("first");
              break;

            case "End":
              if (!p) return;
              e.focusOption("last");
              break;

            default:
              return;
          }

          n.preventDefault();
        }
      };
    },
        yn = function yn(e) {
      var n, a;
      return a = n = function (n) {
        function a() {
          var e, n, t;
          X(this, a);

          for (var i = arguments.length, o = Array(i), s = 0; s < i; s++) {
            o[s] = arguments[s];
          }

          return n = t = ee(this, (e = a.__proto__ || Object.getPrototypeOf(a)).call.apply(e, [this].concat(o))), t.state = {
            inputValue: void 0 !== t.props.inputValue ? t.props.inputValue : t.props.defaultInputValue,
            menuIsOpen: void 0 !== t.props.menuIsOpen ? t.props.menuIsOpen : t.props.defaultMenuIsOpen,
            value: void 0 !== t.props.value ? t.props.value : t.props.defaultValue
          }, t.onChange = function (e, n) {
            t.callProp("onChange", e, n), t.setState({
              value: e
            });
          }, t.onInputChange = function (e, n) {
            var a = t.callProp("onInputChange", e, n);
            t.setState({
              inputValue: void 0 !== a ? a : e
            });
          }, t.onMenuOpen = function () {
            t.callProp("onMenuOpen"), t.setState({
              menuIsOpen: !0
            });
          }, t.onMenuClose = function () {
            t.callProp("onMenuClose"), t.setState({
              menuIsOpen: !1
            });
          }, ee(t, n);
        }

        return K(a, n), J(a, [{
          key: "focus",
          value: function value() {
            this.select.focus();
          }
        }, {
          key: "blur",
          value: function value() {
            this.select.blur();
          }
        }, {
          key: "getProp",
          value: function value(e) {
            return void 0 !== this.props[e] ? this.props[e] : this.state[e];
          }
        }, {
          key: "callProp",
          value: function value(e) {
            if ("function" === typeof this.props[e]) {
              for (var n, a = arguments.length, t = Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++) {
                t[i - 1] = arguments[i];
              }

              return (n = this.props)[e].apply(n, ne(t));
            }
          }
        }, {
          key: "render",
          value: function value() {
            var n = this;
            return v.a.createElement(e, Z({}, this.props, {
              ref: function ref(e) {
                n.select = e;
              },
              inputValue: this.getProp("inputValue"),
              menuIsOpen: this.getProp("menuIsOpen"),
              onChange: this.onChange,
              onInputChange: this.onInputChange,
              onMenuClose: this.onMenuClose,
              onMenuOpen: this.onMenuOpen,
              value: this.getProp("value")
            }));
          }
        }]), a;
      }(f.Component), n.defaultProps = {
        defaultInputValue: "",
        defaultMenuIsOpen: !1,
        defaultValue: null
      }, a;
    },
        wn = {
      cacheOptions: !1,
      defaultOptions: !1
    },
        En = function En(e) {
      var n, a;
      return a = n = function (n) {
        function a(e) {
          X(this, a);
          var n = ee(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this));
          return n.mounted = !1, n.optionsCache = {}, n.handleInputChange = function (e, a) {
            var t = n.props,
                i = t.cacheOptions,
                o = function (e, n, a) {
              if (a) {
                var t = a(e, n);
                if ("string" === typeof t) return t;
              }

              return e;
            }(e, a, t.onInputChange);

            if (!o) return delete n.lastRequest, void n.setState({
              inputValue: "",
              loadedInputValue: "",
              loadedOptions: [],
              isLoading: !1,
              passEmptyOptions: !1
            });
            if (i && n.optionsCache[o]) n.setState({
              inputValue: o,
              loadedInputValue: o,
              loadedOptions: n.optionsCache[o],
              isLoading: !1,
              passEmptyOptions: !1
            });else {
              var s = n.lastRequest = {};
              n.setState({
                inputValue: o,
                isLoading: !0,
                passEmptyOptions: !n.state.loadedInputValue
              }, function () {
                n.loadOptions(o, function (e) {
                  n.mounted && (e && (n.optionsCache[o] = e), s === n.lastRequest && (delete n.lastRequest, n.setState({
                    isLoading: !1,
                    loadedInputValue: o,
                    loadedOptions: e || [],
                    passEmptyOptions: !1
                  })));
                });
              });
            }
            return o;
          }, n.state = {
            defaultOptions: Array.isArray(e.defaultOptions) ? e.defaultOptions : void 0,
            inputValue: e.inputValue,
            isLoading: !0 === e.defaultOptions,
            loadedOptions: [],
            passEmptyOptions: !1
          }, n;
        }

        return K(a, n), J(a, [{
          key: "componentDidMount",
          value: function value() {
            var e = this;
            this.mounted = !0;
            var n = this.props.defaultOptions,
                a = this.state.inputValue;
            !0 === n && this.loadOptions(a, function (n) {
              if (e.mounted) {
                var a = !!e.lastRequest;
                e.setState({
                  defaultOptions: n || [],
                  isLoading: a
                });
              }
            });
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            e.cacheOptions !== this.props.cacheOptions && (this.optionsCache = {}), e.defaultOptions !== this.props.defaultOptions && this.setState({
              defaultOptions: Array.isArray(e.defaultOptions) ? e.defaultOptions : void 0
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.mounted = !1;
          }
        }, {
          key: "focus",
          value: function value() {
            this.select.focus();
          }
        }, {
          key: "blur",
          value: function value() {
            this.select.blur();
          }
        }, {
          key: "loadOptions",
          value: function value(e, n) {
            var a = this.props.loadOptions;
            if (!a) return n();
            var t = a(e, n);
            t && "function" === typeof t.then && t.then(n, function () {
              return n();
            });
          }
        }, {
          key: "render",
          value: function value() {
            var n = this,
                a = this.props,
                t = (a.loadOptions, $(a, ["loadOptions"])),
                i = this.state,
                o = i.defaultOptions,
                s = i.inputValue,
                r = i.isLoading,
                c = i.loadedInputValue,
                p = i.loadedOptions,
                u = i.passEmptyOptions ? [] : s && c ? p : o || [];
            return v.a.createElement(e, Z({}, t, {
              filterOption: this.props.filterOption || null,
              ref: function ref(e) {
                n.select = e;
              },
              options: u,
              isLoading: r,
              onInputChange: this.handleInputChange
            }));
          }
        }]), a;
      }(f.Component), n.defaultProps = wn, a;
    },
        kn = (En(yn(bn)), function (e, n) {
      var a = e.toLowerCase();
      return n.value.toLowerCase() === a || n.label.toLowerCase() === a;
    }),
        On = Z({
      allowCreateWhileLoading: !1,
      createOptionPosition: "last"
    }, {
      formatCreateLabel: function formatCreateLabel(e) {
        return 'Create "' + e + '"';
      },
      isValidNewOption: function isValidNewOption(e, n, a) {
        return !(!e || n.some(function (n) {
          return kn(e, n);
        }) || a.some(function (n) {
          return kn(e, n);
        }));
      },
      getNewOptionData: function getNewOptionData(e, n) {
        return {
          label: n,
          value: e,
          __isNew__: !0
        };
      }
    }),
        Cn = function Cn(e) {
      var n, a;
      return a = n = function (n) {
        function a(e) {
          X(this, a);
          var n = ee(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, e));

          n.onChange = function (e, a) {
            var t = n.props,
                i = t.getNewOptionData,
                o = t.inputValue,
                s = t.isMulti,
                r = t.onChange,
                c = t.onCreateOption,
                p = t.value;
            if ("select-option" !== a.action) return r(e, a);
            var u = n.state.newOption,
                l = Array.isArray(e) ? e : [e];
            if (l[l.length - 1] !== u) r(e, a);else if (c) c(o);else {
              var d = i(o, o),
                  m = {
                action: "create-option"
              };
              r(s ? [].concat(ne(ie(p)), [d]) : d, m);
            }
          };

          var t = e.options || [];
          return n.state = {
            newOption: void 0,
            options: t
          }, n;
        }

        return K(a, n), J(a, [{
          key: "componentWillReceiveProps",
          value: function value(e) {
            var n = e.allowCreateWhileLoading,
                a = e.createOptionPosition,
                t = e.formatCreateLabel,
                i = e.getNewOptionData,
                o = e.inputValue,
                s = e.isLoading,
                r = e.isValidNewOption,
                c = e.value,
                p = e.options || [],
                u = this.state.newOption;
            u = r(o, ie(c), p) ? i(o, t(o)) : void 0, this.setState({
              newOption: u,
              options: !n && s || !u ? p : "first" === a ? [u].concat(ne(p)) : [].concat(ne(p), [u])
            });
          }
        }, {
          key: "focus",
          value: function value() {
            this.select.focus();
          }
        }, {
          key: "blur",
          value: function value() {
            this.select.blur();
          }
        }, {
          key: "render",
          value: function value() {
            var n = this,
                a = $(this.props, []),
                t = this.state.options;
            return v.a.createElement(e, Z({}, a, {
              ref: function ref(e) {
                n.select = e;
              },
              options: t,
              onChange: this.onChange
            }));
          }
        }]), a;
      }(f.Component), n.defaultProps = On, a;
    },
        An = (yn(Cn(bn)), En(yn(Cn(bn))), function (e) {
      var n = e.component,
          a = e.duration,
          t = void 0 === a ? 1 : a,
          i = e.in,
          o = (e.onExited, $(e, ["component", "duration", "in", "onExited"])),
          s = {
        entering: {
          opacity: 0
        },
        entered: {
          opacity: 1,
          transition: "opacity " + t + "ms"
        },
        exiting: {
          opacity: 0
        },
        exited: {
          opacity: 0
        }
      };
      return v.a.createElement(G.Transition, {
        mountOnEnter: !0,
        unmountOnExit: !0,
        in: i,
        timeout: t
      }, function (e) {
        var a = {
          style: Z({}, s[e])
        };
        return v.a.createElement(n, Z({
          innerProps: a
        }, o));
      });
    }),
        jn = 260,
        Sn = function (e) {
      function n() {
        var e, a, t;
        X(this, n);

        for (var i = arguments.length, o = Array(i), s = 0; s < i; s++) {
          o[s] = arguments[s];
        }

        return a = t = ee(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(o))), t.duration = jn, t.state = {
          width: "auto"
        }, t.transition = {
          exiting: {
            width: 0,
            transition: "width " + t.duration + "ms ease-out"
          },
          exited: {
            width: 0
          }
        }, t.getWidth = function (e) {
          if (e && isNaN(t.state.width)) {
            var n = e.getBoundingClientRect().width;
            t.setState({
              width: n
            });
          }
        }, t.getStyle = function (e) {
          return {
            overflow: "hidden",
            whiteSpace: "nowrap",
            width: e
          };
        }, t.getTransition = function (e) {
          return t.transition[e];
        }, ee(t, a);
      }

      return K(n, e), J(n, [{
        key: "render",
        value: function value() {
          var e = this,
              n = this.props,
              a = n.children,
              t = n.in,
              i = this.state.width;
          return v.a.createElement(G.Transition, {
            enter: !1,
            mountOnEnter: !0,
            unmountOnExit: !0,
            in: t,
            timeout: this.duration
          }, function (n) {
            var t = Z({}, e.getStyle(i), e.getTransition(n));
            return v.a.createElement("div", {
              ref: e.getWidth,
              style: t
            }, a);
          });
        }
      }]), n;
    }(f.Component),
        Fn = function Fn(e) {
      return function (n) {
        var a = n.in,
            t = n.onExited,
            i = $(n, ["in", "onExited"]);
        return v.a.createElement(Sn, {
          in: a,
          onExited: t
        }, v.a.createElement(e, Z({
          cropWithEllipsis: a
        }, i)));
      };
    },
        Dn = function Dn(e) {
      return function (n) {
        return v.a.createElement(An, Z({
          component: e,
          duration: n.isMulti ? jn : 1
        }, n));
      };
    },
        Pn = function Pn(e) {
      return function (n) {
        return v.a.createElement(An, Z({
          component: e
        }, n));
      };
    },
        Mn = function Mn(e) {
      return function (n) {
        return v.a.createElement(G.TransitionGroup, Z({
          component: e
        }, n));
      };
    },
        In = function In(e) {
      var n,
          a = ln({
        components: e
      }),
          t = a.Input,
          i = a.MultiValue,
          o = a.Placeholder,
          s = a.SingleValue,
          r = a.ValueContainer,
          c = $(a, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);
      return Z({
        Input: (n = t, function (e) {
          e.in, e.onExited, e.appear, e.enter, e.exit;
          var a = e.innerRef,
              t = $(e, ["in", "onExited", "appear", "enter", "exit", "innerRef"]);
          return v.a.createElement(n, Z({
            innerRef: a
          }, t));
        }),
        MultiValue: Fn(i),
        Placeholder: Dn(o),
        SingleValue: Pn(s),
        ValueContainer: Mn(r)
      }, c);
    },
        Tn = In(),
        Ln = (Tn.Input, Tn.MultiValue, Tn.Placeholder, Tn.SingleValue, Tn.ValueContainer, H(In, Ee), yn(bn));

    a(21);

    function Rn(e, n) {
      return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(n)
        }
      }));
    }

    var Nn = a(4),
        Vn = a.n(Nn);

    function zn() {
      var e = Rn(["\n  display: inline-block;\n  vertical-align: middle;\n"]);
      return zn = function zn() {
        return e;
      }, e;
    }

    function _n() {
      var e = Rn(["\n  width: 32px;\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n"]);
      return _n = function _n() {
        return e;
      }, e;
    }

    function Bn() {
      var e = Rn(["\n  cursor: pointer;\n  display: block;\n  padding: 10px 5px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n  &:last-child {\n    border: none;\n  }\n\n  &:hover {\n    background-color: #ebf5ff;\n  }\n"]);
      return Bn = function Bn() {
        return e;
      }, e;
    }

    var qn = Vn.a.div(Bn()),
        Un = Vn.a.img(_n()),
        Wn = Vn.a.span(zn()),
        Hn = function Hn(e) {
      var n = e.innerProps,
          a = e.isDisabled,
          t = e.innerRef,
          i = e.data;
      return a ? null : v.a.createElement(qn, Object.assign({
        ref: t
      }, n, {
        className: "option"
      }), v.a.createElement(Un, {
        src: i.image,
        className: "icon",
        alt: "provider"
      }), v.a.createElement(Wn, null, i.label));
    },
        Gn = function Gn(e) {
      var n = e.data,
          a = m(e, ["data"]);
      return v.a.createElement(un.SingleValue, Object.assign({}, a, {
        className: "selected"
      }), v.a.createElement(Un, {
        src: n.image,
        className: "icon",
        alt: "single_provider"
      }), v.a.createElement(Wn, null, n.label));
    },
        Yn = function (e) {
      function n() {
        return i(this, n), p(this, u(n).apply(this, arguments));
      }

      return d(n, f["Component"]), s(n, [{
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.className,
              a = e.placeholder,
              t = e.options,
              i = e.components,
              o = e.onChange;
          return v.a.createElement(Ln, {
            placeholder: a,
            className: "solid-provider-select ".concat(n || ""),
            options: t,
            components: i ? {
              Option: Hn,
              SingleValue: Gn
            } : null,
            onChange: o
          });
        }
      }]), n;
    }();

    function Xn(e, n, a) {
      return n in e ? Object.defineProperty(e, n, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = a, e;
    }

    function Jn(e) {
      for (var n = 1; n < arguments.length; n++) {
        var a = null != arguments[n] ? arguments[n] : {},
            t = Object.keys(a);
        "function" === typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(a).filter(function (e) {
          return Object.getOwnPropertyDescriptor(a, e).enumerable;
        }))), t.forEach(function (n) {
          Xn(e, n, a[n]);
        });
      }

      return e;
    }

    var Qn = a(5),
        Zn = a.n(Qn);

    function Kn(e, n, a, t, i, o, s) {
      try {
        var r = e[o](s),
            c = r.value;
      } catch (p) {
        return void a(p);
      }

      r.done ? n(c) : Promise.resolve(c).then(t, i);
    }

    function $n(e) {
      return function () {
        var n = this,
            a = arguments;
        return new Promise(function (t, i) {
          var o = e.apply(n, a);

          function s(e) {
            Kn(o, t, i, s, r, "next", e);
          }

          function r(e) {
            Kn(o, t, i, s, r, "throw", e);
          }

          s(void 0);
        });
      };
    }

    var ea = a(7),
        na = a.n(ea);

    function aa() {
      var e = Rn(["\n  color: red;\n  margin: 0;\n"]);
      return aa = function aa() {
        return e;
      }, e;
    }

    function ta() {
      var e = Rn(["\n  border: 1px solid hsl(0, 0%, 80%);\n  cursor: pointer;\n  padding: 10px 30px;\n\n  &:hover {\n    opacity: 0.7;\n  }\n"]);
      return ta = function ta() {
        return e;
      }, e;
    }

    function ia() {
      var e = Rn(["\n  border: none;\n  background: transparent;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"]);
      return ia = function ia() {
        return e;
      }, e;
    }

    function oa() {
      var e = Rn(["\n  background-color: hsl(0, 0%, 100%);\n  border-color: hsl(0, 0%, 80%);\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 2px 8px;\n  height: 30px;\n"]);
      return oa = function oa() {
        return e;
      }, e;
    }

    var sa = Vn.a.input(oa()),
        ra = Vn.a.button(ia()),
        ca = Vn.a.button(ta()),
        pa = Vn.a.p(aa());

    function ua() {
      var e = Rn(["\n  button {\n    margin: 20px auto;\n    display: block;\n  }\n"]);
      return ua = function ua() {
        return e;
      }, e;
    }

    var la = Vn.a.div(ua()),
        da = function da(e) {
      return v.a.createElement(la, {
        className: "solid-provider-login-component ".concat(e.className, " ").concat(e.error && "error")
      }, v.a.createElement("form", {
        onSubmit: e.onSubmit
      }, e.error && v.a.createElement(pa, null, e.error.message), e.withWebId ? v.a.createElement(sa, {
        type: "text",
        name: "idp",
        onChange: e.onChangeInput,
        placeholder: e.inputPlaholder,
        "data-testid": "input-webid"
      }) : v.a.createElement(Yn, {
        placeholder: e.selectPlaceholder,
        onChange: e.onSelectChange,
        options: e.providers,
        components: !0,
        name: "provider"
      }), v.a.createElement(ra, {
        type: "button",
        className: "link",
        onClick: e.optionToggle,
        "data-testid": "change-mode-button"
      }, e.withWebId ? e.btnTxtProvider : e.btnTxtWebId), v.a.createElement(ca, {
        type: "submit",
        "data-testid": "provider-form-button"
      }, e.formButtonText)));
    };

    function ma(e, n, a) {
      return (ma = function () {
        if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" === typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }() ? Reflect.construct : function (e, n, a) {
        var t = [null];
        t.push.apply(t, n);
        var i = new (Function.bind.apply(e, t))();
        return a && l(i, a.prototype), i;
      }).apply(null, arguments);
    }

    function fa(e) {
      var n = "function" === typeof Map ? new Map() : void 0;
      return (fa = function fa(e) {
        if (null === e || (a = e, -1 === Function.toString.call(a).indexOf("[native code]"))) return e;
        var a;
        if ("function" !== typeof e) throw new TypeError("Super expression must either be null or a function");

        if ("undefined" !== typeof n) {
          if (n.has(e)) return n.get(e);
          n.set(e, t);
        }

        function t() {
          return ma(e, arguments, u(this).constructor);
        }

        return t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), l(t, e);
      })(e);
    }

    var va = function (e) {
      function n(e, a, t) {
        var o;
        return i(this, n), (o = p(this, u(n).call(this, e))).message = e, o.statusText = e, o.name = a || "SolidError", o.type = o.name, o.code = t || 0, o;
      }

      return d(n, fa(Error)), n;
    }(),
        ha = a(56),
        xa = a.n(ha),
        ba = a(57),
        ga = a.n(ba),
        ya = function (e) {
      function n(e) {
        var a;
        return i(this, n), (a = p(this, u(n).call(this, e))).isWebIdValid = function (e) {
          return new RegExp(/[(http(s)?):\/\/(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&\/\/=]*)/, "i", "g").test(e);
        }, a.goLogin = function () {
          var e = $n(Zn.a.mark(function e(n) {
            var t, i, o, s, r, c, p, u;
            return Zn.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (e.prev = 0, n.preventDefault(), t = a.state, i = t.idp, o = t.withWebId, s = a.props, r = s.callbackUri, c = s.errorsText, i) {
                      e.next = 7;
                      break;
                    }

                    throw new va(c[p = o ? "emptyWebId" : "emptyProvider"], p);

                  case 7:
                    if (!i || !o || a.isWebIdValid(i)) {
                      e.next = 9;
                      break;
                    }

                    throw new va(c.webIdNotValid, "webIdNotValid");

                  case 9:
                    return e.next = 11, na.a.login(i, {
                      callbackUri: r,
                      storage: localStorage
                    });

                  case 11:
                    if (!(u = e.sent)) {
                      e.next = 14;
                      break;
                    }

                    return e.abrupt("return", a.setState({
                      session: u
                    }));

                  case 14:
                    throw new va(c.unknown, "unknown");

                  case 17:
                    e.prev = 17, e.t0 = e.catch(0), a.props.onError && a.props.onError(e.t0), "unknown" !== e.t0.name && a.setState({
                      error: e.t0
                    });

                  case 21:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[0, 17]]);
          }));
          return function (n) {
            return e.apply(this, arguments);
          };
        }(), a.onProviderSelect = function (e) {
          var n = e && e.value;
          a.setState({
            idp: n || "",
            error: !n
          });
        }, a.optionToggle = function () {
          return a.setState({
            withWebId: !a.state.withWebId,
            idp: "",
            error: null
          });
        }, a.onChangeInput = function (e) {
          a.setState(Xn({}, e.target.name, e.target.value)), a.isWebIdValid(e.target.value) && a.setState({
            error: null
          });
        }, a.state = {
          session: null,
          idp: null,
          withWebId: !0,
          error: null
        }, a;
      }

      return d(n, f["Component"]), s(n, [{
        key: "componentDidUpdate",
        value: function value(e, n) {
          "" !== e.idp && e.idp !== this.props.idp && this.setState({
            error: null
          });
        }
      }, {
        key: "render",
        value: function value() {
          return v.a.createElement(da, Object.assign({}, this.props, {
            error: this.state.error,
            withWebId: this.state.withWebId,
            onSubmit: this.goLogin,
            optionToggle: this.optionToggle,
            onChangeInput: this.onChangeInput,
            onSelectChange: this.onProviderSelect
          }));
        }
      }]), n;
    }();

    ya.getDerivedStateFromProps = function (e, n) {
      var a = n.error;
      return a ? {
        error: Jn({}, a, {
          message: e.errorsText[n.error.name]
        })
      } : null;
    }, ya.defaultProps = {
      selectPlaceholder: "Select ID Provider",
      inputPlaholder: "WebID",
      formButtonText: "Log In",
      btnTxtWebId: "Log In with WebId",
      btnTxtProvider: "Log In with Provider",
      errorsText: {
        unknown: "Something is wrong, please try again...",
        webIdNotValid: "WeibID is not valid",
        emptyProvider: "Solid Provider is required",
        emptyWebId: "Valid WebID is required"
      },
      providers: [{
        label: "Inrupt",
        image: ga.a,
        value: "https://inrupt.net/auth",
        registerLink: "https://inrupt.net/register",
        description: "This is a prototype implementation of a Solid server"
      }, {
        label: "Solid Community",
        image: xa.a,
        value: "https://solid.community",
        registerLink: "https://solid.community/register",
        description: "This is a prototype implementation of a Solid server"
      }]
    };

    var wa = ya,
        Ea = a(9),
        ka = a.n(Ea),
        Oa = a(8),
        Ca = a.n(Oa),
        Aa = a(22),
        ja = a.n(Aa),
        Sa = {},
        Fa = 0,
        Da = function Da(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          a = arguments[2];
      "string" === typeof n && (n = {
        path: n
      });
      var t = n,
          i = t.path,
          o = t.exact,
          s = void 0 !== o && o,
          r = t.strict,
          c = void 0 !== r && r,
          p = t.sensitive;
      if (null == i) return a;

      var u = function (e, n) {
        var a = "" + n.end + n.strict + n.sensitive,
            t = Sa[a] || (Sa[a] = {});
        if (t[e]) return t[e];
        var i = [],
            o = {
          re: ja()(e, i, n),
          keys: i
        };
        return Fa < 1e4 && (t[e] = o, Fa++), o;
      }(i, {
        end: s,
        strict: c,
        sensitive: void 0 !== p && p
      }),
          l = u.re,
          d = u.keys,
          m = l.exec(e);

      if (!m) return null;
      var f = m[0],
          v = m.slice(1),
          h = e === f;
      return s && !h ? null : {
        path: i,
        url: "/" === i && "" === f ? "/" : f,
        isExact: h,
        params: d.reduce(function (e, n, a) {
          return e[n.name] = v[a], e;
        }, {})
      };
    },
        Pa = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var a = arguments[n];

        for (var t in a) {
          Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
        }
      }

      return e;
    };

    function Ma(e, n) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !n || "object" !== typeof n && "function" !== typeof n ? e : n;
    }

    var Ia = function Ia(e) {
      return 0 === v.a.Children.count(e);
    },
        Ta = function (e) {
      function n() {
        var a, t;
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, n);

        for (var i = arguments.length, o = Array(i), s = 0; s < i; s++) {
          o[s] = arguments[s];
        }

        return a = t = Ma(this, e.call.apply(e, [this].concat(o))), t.state = {
          match: t.computeMatch(t.props, t.context.router)
        }, Ma(t, a);
      }

      return function (e, n) {
        if ("function" !== typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
        e.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
      }(n, e), n.prototype.getChildContext = function () {
        return {
          router: Pa({}, this.context.router, {
            route: {
              location: this.props.location || this.context.router.route.location,
              match: this.state.match
            }
          })
        };
      }, n.prototype.computeMatch = function (e, n) {
        var a = e.computedMatch,
            t = e.location,
            i = e.path,
            o = e.strict,
            s = e.exact,
            r = e.sensitive;
        if (a) return a;
        Ca()(n, "You should not use <Route> or withRouter() outside a <Router>");
        var c = n.route,
            p = (t || c.location).pathname;
        return Da(p, {
          path: i,
          strict: o,
          exact: s,
          sensitive: r
        }, c.match);
      }, n.prototype.componentWillMount = function () {
        ka()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored"), ka()(!(this.props.component && this.props.children && !Ia(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored"), ka()(!(this.props.render && this.props.children && !Ia(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
      }, n.prototype.componentWillReceiveProps = function (e, n) {
        ka()(!(e.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.'), ka()(!(!e.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.'), this.setState({
          match: this.computeMatch(e, n.router)
        });
      }, n.prototype.render = function () {
        var e = this.state.match,
            n = this.props,
            a = n.children,
            t = n.component,
            i = n.render,
            o = this.context.router,
            s = o.history,
            r = o.route,
            c = o.staticContext,
            p = {
          match: e,
          location: this.props.location || r.location,
          history: s,
          staticContext: c
        };
        return t ? e ? v.a.createElement(t, p) : null : i ? e ? i(p) : null : "function" === typeof a ? a(p) : a && !Ia(a) ? v.a.Children.only(a) : null;
      }, n;
    }(v.a.Component);

    Ta.propTypes = {
      computedMatch: y.a.object,
      path: y.a.string,
      exact: y.a.bool,
      strict: y.a.bool,
      sensitive: y.a.bool,
      component: y.a.func,
      render: y.a.func,
      children: y.a.oneOfType([y.a.func, y.a.node]),
      location: y.a.object
    }, Ta.contextTypes = {
      router: y.a.shape({
        history: y.a.object.isRequired,
        route: y.a.object.isRequired,
        staticContext: y.a.object
      })
    }, Ta.childContextTypes = {
      router: y.a.object.isRequired
    };
    var La = Ta;
    a(3);

    function Ra(e) {
      return "/" === e.charAt(0);
    }

    function Na(e, n) {
      for (var a = n, t = a + 1, i = e.length; t < i; a += 1, t += 1) {
        e[a] = e[t];
      }

      e.pop();
    }

    var Va = function Va(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          a = e && e.split("/") || [],
          t = n && n.split("/") || [],
          i = e && Ra(e),
          o = n && Ra(n),
          s = i || o;
      if (e && Ra(e) ? t = a : a.length && (t.pop(), t = t.concat(a)), !t.length) return "/";
      var r = void 0;

      if (t.length) {
        var c = t[t.length - 1];
        r = "." === c || ".." === c || "" === c;
      } else r = !1;

      for (var p = 0, u = t.length; u >= 0; u--) {
        var l = t[u];
        "." === l ? Na(t, u) : ".." === l ? (Na(t, u), p++) : p && (Na(t, u), p--);
      }

      if (!s) for (; p--; p) {
        t.unshift("..");
      }
      !s || "" === t[0] || t[0] && Ra(t[0]) || t.unshift("");
      var d = t.join("/");
      return r && "/" !== d.substr(-1) && (d += "/"), d;
    },
        za = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };

    var _a = function e(n, a) {
      if (n === a) return !0;
      if (null == n || null == a) return !1;
      if (Array.isArray(n)) return Array.isArray(a) && n.length === a.length && n.every(function (n, t) {
        return e(n, a[t]);
      });
      var t = "undefined" === typeof n ? "undefined" : za(n);
      if (t !== ("undefined" === typeof a ? "undefined" : za(a))) return !1;

      if ("object" === t) {
        var i = n.valueOf(),
            o = a.valueOf();
        if (i !== n || o !== a) return e(i, o);
        var s = Object.keys(n),
            r = Object.keys(a);
        return s.length === r.length && s.every(function (t) {
          return e(n[t], a[t]);
        });
      }

      return !1;
    },
        Ba = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var a = arguments[n];

        for (var t in a) {
          Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
        }
      }

      return e;
    },
        qa = function qa(e, n, a, t) {
      var i = void 0;
      "string" === typeof e ? (i = function (e) {
        var n = e || "/",
            a = "",
            t = "",
            i = n.indexOf("#");
        -1 !== i && (t = n.substr(i), n = n.substr(0, i));
        var o = n.indexOf("?");
        return -1 !== o && (a = n.substr(o), n = n.substr(0, o)), {
          pathname: n,
          search: "?" === a ? "" : a,
          hash: "#" === t ? "" : t
        };
      }(e)).state = n : (void 0 === (i = Ba({}, e)).pathname && (i.pathname = ""), i.search ? "?" !== i.search.charAt(0) && (i.search = "?" + i.search) : i.search = "", i.hash ? "#" !== i.hash.charAt(0) && (i.hash = "#" + i.hash) : i.hash = "", void 0 !== n && void 0 === i.state && (i.state = n));

      try {
        i.pathname = decodeURI(i.pathname);
      } catch (o) {
        throw o instanceof URIError ? new URIError('Pathname "' + i.pathname + '" could not be decoded. This is likely caused by an invalid percent-encoding.') : o;
      }

      return a && (i.key = a), t ? i.pathname ? "/" !== i.pathname.charAt(0) && (i.pathname = Va(i.pathname, t.pathname)) : i.pathname = t.pathname : i.pathname || (i.pathname = "/"), i;
    },
        Ua = function Ua(e, n) {
      return e.pathname === n.pathname && e.search === n.search && e.hash === n.hash && e.key === n.key && _a(e.state, n.state);
    },
        Wa = ("undefined" === typeof window || !window.document || window.document.createElement, "function" === typeof Symbol && Symbol.iterator, Object.assign, Object.assign, "function" === typeof Symbol && Symbol.iterator, Object.assign, {}),
        Ha = 0,
        Ga = function Ga() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "/",
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return "/" === e ? e : function (e) {
        var n = e,
            a = Wa[n] || (Wa[n] = {});
        if (a[e]) return a[e];
        var t = ja.a.compile(e);
        return Ha < 1e4 && (a[e] = t, Ha++), t;
      }(e)(n, {
        pretty: !0
      });
    },
        Ya = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var a = arguments[n];

        for (var t in a) {
          Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
        }
      }

      return e;
    };

    var Xa = function (e) {
      function n() {
        return function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, n), function (e, n) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !n || "object" !== typeof n && "function" !== typeof n ? e : n;
        }(this, e.apply(this, arguments));
      }

      return function (e, n) {
        if ("function" !== typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
        e.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
      }(n, e), n.prototype.isStatic = function () {
        return this.context.router && this.context.router.staticContext;
      }, n.prototype.componentWillMount = function () {
        Ca()(this.context.router, "You should not use <Redirect> outside a <Router>"), this.isStatic() && this.perform();
      }, n.prototype.componentDidMount = function () {
        this.isStatic() || this.perform();
      }, n.prototype.componentDidUpdate = function (e) {
        var n = qa(e.to),
            a = qa(this.props.to);
        Ua(n, a) ? ka()(!1, "You tried to redirect to the same route you're currently on: \"" + a.pathname + a.search + '"') : this.perform();
      }, n.prototype.computeTo = function (e) {
        var n = e.computedMatch,
            a = e.to;
        return n ? "string" === typeof a ? Ga(a, n.params) : Ya({}, a, {
          pathname: Ga(a.pathname, n.params)
        }) : a;
      }, n.prototype.perform = function () {
        var e = this.context.router.history,
            n = this.props.push,
            a = this.computeTo(this.props);
        n ? e.push(a) : e.replace(a);
      }, n.prototype.render = function () {
        return null;
      }, n;
    }(v.a.Component);

    Xa.propTypes = {
      computedMatch: y.a.object,
      push: y.a.bool,
      from: y.a.string,
      to: y.a.oneOfType([y.a.string, y.a.object]).isRequired
    }, Xa.defaultProps = {
      push: !1
    }, Xa.contextTypes = {
      router: y.a.shape({
        history: y.a.shape({
          push: y.a.func.isRequired,
          replace: y.a.func.isRequired
        }).isRequired,
        staticContext: y.a.object
      }).isRequired
    };
    var Ja = Xa;

    function Qa() {
      var e = Rn(["\n  max-width: 300;\n  margin: 0 auto;\n  text-align: center;\n"]);
      return Qa = function Qa() {
        return e;
      }, e;
    }

    var Za = Vn.a.div(Qa()),
        Ka = function (e) {
      function n() {
        var e, a;
        i(this, n);

        for (var t = arguments.length, o = new Array(t), s = 0; s < t; s++) {
          o[s] = arguments[s];
        }

        return (a = p(this, (e = u(n)).call.apply(e, [this].concat(o)))).renderRouter = function () {
          var e = a.props,
              n = e.webId,
              t = e.redirect,
              i = e.component,
              o = m(e, ["webId", "redirect", "component"]);
          return n ? v.a.createElement(La, Object.assign({}, o, {
            component: i
          })) : v.a.createElement(Ja, {
            to: t
          });
        }, a;
      }

      return d(n, f["Component"]), s(n, [{
        key: "render",
        value: function value() {
          return void 0 === this.props.webId ? this.props.loaderComponent() : this.renderRouter();
        }
      }]), n;
    }();

    Ka.defaultProps = {
      redirect: "/login",
      loaderComponent: function loaderComponent() {
        return v.a.createElement(Za, {
          className: "auth-loader"
        }, "We are validating your data...");
      }
    };

    var $a = Object(t.withWebId)(Ka),
        et = function et(e, n) {
      return Object(t.withWebId)(function (a) {
        function t() {
          return i(this, t), p(this, u(t).apply(this, arguments));
        }

        return d(t, v.a.Component), s(t, [{
          key: "render",
          value: function value() {
            switch (this.props.webId) {
              case void 0:
                return n || null;

              case null:
                return v.a.createElement(Ja, {
                  to: "/login"
                });

              default:
                return v.a.createElement(e, this.props);
            }
          }
        }]), t;
      }());
    };

    function nt(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var n = 0, a = new Array(e.length); n < e.length; n++) {
            a[n] = e[n];
          }

          return a;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function at(e) {
      var n;

      if ("function" === typeof Symbol) {
        if (Symbol.asyncIterator && null != (n = e[Symbol.asyncIterator])) return n.call(e);
        if (Symbol.iterator && null != (n = e[Symbol.iterator])) return n.call(e);
      }

      throw new TypeError("Object is not async iterable");
    }

    var tt = a(14),
        it = function (e) {
      function n(e) {
        var a;
        return i(this, n), (a = p(this, u(n).call(this, e))).validateAcceptFiles = function (e, n) {
          return e.split(",").find(function (e) {
            return Object(tt.extension)(n.trim()) === e;
          });
        }, a.removeFileOnError = function (e) {
          var n = a.state.files.filter(function (n) {
            return n.name !== e.name;
          });
          a.setState({
            files: n,
            inProgress: !1
          });
        }, a.renameFile = function (e, n) {
          var a = Date.parse(new Date()),
              t = Object(tt.extension)(e.type),
              i = e.name.substr(0, e.name.lastIndexOf(".".concat(t)));
          return "".concat(i, "_").concat(a, "_.").concat(n || t);
        }, a.upload = function () {
          var e = $n(Zn.a.mark(function e(n) {
            var t, i, o, s, r, c, p, u, l, d, m, f, v, h;
            return Zn.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    t = a.props, i = t.fileBase, o = t.onError, s = t.limitSize, r = t.accept, c = t.errorsText, p = a.state.files, u = !0, l = !1, e.prev = 4, m = function m() {
                      var e = h,
                          n = new FileReader(),
                          t = !1;
                      n.onload = function () {
                        var n = $n(Zn.a.mark(function n(p) {
                          var u, l, d, m, f, v;
                          return Zn.a.wrap(function (n) {
                            for (;;) {
                              switch (n.prev = n.next) {
                                case 0:
                                  if (n.prev = 0, u = p.target.result, !(s && e.size > s)) {
                                    n.next = 4;
                                    break;
                                  }

                                  throw new va(c.sizeLimit, "file", 400);

                                case 4:
                                  if (!e.type || "" === e.type) {
                                    n.next = 8;
                                    break;
                                  }

                                  e.type !== Object(tt.lookup)(e.name) && (t = "".concat(Object(tt.extension)(e.type))), n.next = 9;
                                  break;

                                case 8:
                                  throw new va(c.unsupported, "file", 415);

                                case 9:
                                  if (!r || a.validateAcceptFiles(r, e.type)) {
                                    n.next = 11;
                                    break;
                                  }

                                  throw new va(c.unsupported, "file", 415);

                                case 11:
                                  return l = a.renameFile(e, t), d = "".concat(i, "/").concat(encodeURIComponent(l)), n.next = 15, na.a.fetch(d, {
                                    method: "PUT",
                                    force: !0,
                                    headers: {
                                      "content-type": e.type,
                                      credentials: "include"
                                    },
                                    body: u
                                  });

                                case 15:
                                  if (!(m = n.sent).ok) {
                                    n.next = 20;
                                    break;
                                  }

                                  return f = [].concat(nt(a.state.uploadedFiles), [{
                                    uri: d,
                                    name: l
                                  }]), v = a.state.files.filter(function (n) {
                                    return n.name !== e.name;
                                  }), n.abrupt("return", a.setState({
                                    uploadedFiles: f,
                                    files: v
                                  }));

                                case 20:
                                  throw m;

                                case 23:
                                  n.prev = 23, n.t0 = n.catch(0), o && o(n.t0, e), a.removeFileOnError(e);

                                case 27:
                                case "end":
                                  return n.stop();
                              }
                            }
                          }, n, this, [[0, 23]]);
                        }));
                        return function (e) {
                          return n.apply(this, arguments);
                        };
                      }(), n.readAsArrayBuffer(e);
                    }, f = at(p);

                  case 7:
                    return e.next = 9, f.next();

                  case 9:
                    return v = e.sent, u = v.done, e.next = 13, v.value;

                  case 13:
                    if (h = e.sent, u) {
                      e.next = 19;
                      break;
                    }

                    m();

                  case 16:
                    u = !0, e.next = 7;
                    break;

                  case 19:
                    e.next = 25;
                    break;

                  case 21:
                    e.prev = 21, e.t0 = e.catch(4), l = !0, d = e.t0;

                  case 25:
                    if (e.prev = 25, e.prev = 26, u || null == f.return) {
                      e.next = 30;
                      break;
                    }

                    return e.next = 30, f.return();

                  case 30:
                    if (e.prev = 30, !l) {
                      e.next = 33;
                      break;
                    }

                    throw d;

                  case 33:
                    return e.finish(30);

                  case 34:
                    return e.finish(25);

                  case 35:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[4, 21, 25, 35], [26,, 30, 34]]);
          }));
          return function (n) {
            return e.apply(this, arguments);
          };
        }(), a.onComplete = function (e) {
          a.setState({
            inProgress: !1
          }), a.props.onComplete && a.props.onComplete(e);
        }, a.onDragEnter = function (e) {
          a.overrideEvent(e), a.counter += 1, (e.dataTransfer.items && e.dataTransfer.items[a.positionFile] || e.dataTransfer.types && "Files" === e.dataTransfer.types[a.positionFile]) && a.setState({
            dragging: !0
          });
        }, a.onDragLeave = function (e) {
          a.overrideEvent(e), a.counter -= 1, 0 === a.counter && a.setState({
            dragging: !1
          });
        }, a.onDrop = function () {
          var e = $n(Zn.a.mark(function e(n) {
            var t, i, o, s, r, c, p, u, l;
            return Zn.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t = a.props.errorsText, a.overrideEvent(n), a.counter = 0, i = [], !(a.props.limitFiles && n.dataTransfer.items.length > a.props.limitFiles)) {
                      e.next = 7;
                      break;
                    }

                    return o = new va(t.maximumFiles, "file", 400), e.abrupt("return", a.props.onError(o, []));

                  case 7:
                    if (!n.dataTransfer.items) {
                      e.next = 27;
                      break;
                    }

                    for (s = !0, r = !1, c = void 0, e.prev = 11, p = n.dataTransfer.files[Symbol.iterator](); !(s = (u = p.next()).done); s = !0) {
                      l = u.value, i = [].concat(nt(i), [l]);
                    }

                    e.next = 19;
                    break;

                  case 15:
                    e.prev = 15, e.t0 = e.catch(11), r = !0, c = e.t0;

                  case 19:
                    e.prev = 19, e.prev = 20, s || null == p.return || p.return();

                  case 22:
                    if (e.prev = 22, !r) {
                      e.next = 25;
                      break;
                    }

                    throw c;

                  case 25:
                    return e.finish(22);

                  case 26:
                    return e.finish(19);

                  case 27:
                    a.props.onDrop && a.props.onDrop(i), a.onStart(), a.setState({
                      files: i
                    });

                  case 30:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[11, 15, 19, 27], [20,, 22, 26]]);
          }));
          return function (n) {
            return e.apply(this, arguments);
          };
        }(), a.onClickFile = function () {
          a.fileInput && a.fileInput.current.click();
        }, a.onStart = function () {
          a.props.onStart && a.props.onStart(), a.state.inProgress || a.setState({
            inProgress: !0
          });
        }, a.onFileChanged = function (e) {
          e.target.files && e.target.files[a.positionFile] && (a.onStart(), a.setState({
            files: [].concat(nt(a.state.files), nt(e.target.files))
          }));
        }, a.overrideEvent = function (e) {
          e.preventDefault(), e.stopPropagation();
        }, a.state = {
          dragging: !1,
          files: [],
          uploadedFiles: []
        }, a.fileInput = v.a.createRef(), a.positionFile = 0, a;
      }

      return d(n, f["Component"]), s(n, [{
        key: "componentDidMount",
        value: function value() {
          var e = this;
          window.addEventListener("dragover", function (n) {
            e.overrideEvent(n);
          }), window.addEventListener("drop", function (n) {
            e.overrideEvent(n);
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, n) {
          this.state.files !== n.files && this.state.files.length > 0 && this.upload(), this.state.uploadedFiles.length > 0 && n.uploadedFiles !== this.state.uploadedFiles && this.onComplete(this.state.uploadedFiles);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.onDragLeave,
              n = this.onDragEnter,
              a = this.onClickFile,
              t = this.onDrop;
          return v.a.createElement("div", null, v.a.createElement("input", {
            ref: this.fileInput,
            type: "file",
            className: "file-uploader--input",
            onChange: this.onFileChanged,
            style: {
              display: "none"
            },
            "data-testid": "input-file"
          }), this.props.render(Jn({}, this.state, {
            overrideEventDefaults: this.overrideEventDefaults,
            onDragLeave: e,
            onDragEnter: n,
            onClickFile: a,
            onDrop: t
          })));
        }
      }]), n;
    }();

    it.defaultProps = {
      errorsText: {
        sizeLimit: "File size exceeds the allowable limit",
        unsupported: "Unsupported media type",
        maximumFiles: "Sorry, you have exceeded the maximum number of files allowed per upload"
      }
    };
    var ot = it;

    function st() {
      var e = Rn(["\n  margin-top: 10px;\n"]);
      return st = function st() {
        return e;
      }, e;
    }

    function rt() {
      var e = Rn(["\n  border-radius: 60px;\n  width: 100%;\n  height: 100%;\n"]);
      return rt = function rt() {
        return e;
      }, e;
    }

    function ct() {
      var e = Rn(["\n  border-radius: 60px;\n  text-align: center;\n  width: 129px;\n  height: 129px;\n"]);
      return ct = function ct() {
        return e;
      }, e;
    }

    var pt = Vn.a.div(ct()),
        ut = Vn.a.img(rt()),
        lt = Vn.a.button(st()),
        dt = function dt(e) {
      return v.a.createElement(pt, {
        onDragStart: e.overrideEventDefaults,
        onDragOver: e.overrideEventDefaults,
        onDragEnd: e.overrideEventDefaults,
        onDrag: e.overrideEventDefaults,
        onDragLeave: e.onDragLeave,
        onDragEnter: e.onDragEnter,
        onDrop: e.onDrop,
        className: e.className
      }, e.uploadedFiles && e.uploadedFiles.length > 0 && v.a.createElement(ut, {
        src: e.uploadedFiles[e.uploadedFiles.length - 1].uri,
        alt: "profile",
        "data-testid": "image-style"
      }), v.a.createElement(lt, {
        type: "button",
        onClick: e.onClickFile,
        "data-testid": "button-style"
      }, "Upload File"));
    };

    a.d(n, "ProviderLogin", function () {
      return wa;
    }), a.d(n, "PrivateRoute", function () {
      return $a;
    }), a.d(n, "withAuthorization", function () {
      return et;
    }), a.d(n, "Uploader", function () {
      return ot;
    }), a.d(n, "ProfileUploader", function () {
      return dt;
    }), a.d(n, "withWebId", function () {
      return t.withWebId;
    }), a.d(n, "LogoutButton", function () {
      return t.LogoutButton;
    }), a.d(n, "Image", function () {
      return t.Image;
    }), a.d(n, "LiveUpdate", function () {
      return t.LiveUpdate;
    }), a.d(n, "useWebId", function () {
      return t.useWebId;
    }), a.d(n, "UpdateContext", function () {
      return t.UpdateContext;
    }), a.d(n, "useLiveUpdate", function () {
      return t.useLiveUpdate;
    });
  }]);
});